const LOCKED_CARRIER_HANDLE = 'locked-to-a-carrier';

window.PYD = {
  state: { ...(window.PYD?.state || {}) },
  config: {
    GRAPHQL_URL: "https://api.ecoatm.com/omni/v1/graphql/graphql",
    CHANNELS: ["WEB", "TRADE_IN"],
    SHOPIFY_URL: "https://ecoatm-public.myshopify.com/api/2025-04/graphql.json",
    SHOPIFY_ACCESS_TOKEN: "b5a1a54d256bb415c6098f182d75d015",
    ...(window.PYD?.config || {}),
  },

  allErrorMessages: {
    "email": 'Please enter a valid email',
    'payable-to': 'Enter a full name',
    'first-name': 'Enter a first name',
    'last-name': 'Enter a last name',
    "address": 'Enter an address',
    'address-1': 'Enter an apartment or suite',
    "city": 'Enter a city',
    "state": 'Enter a state',
    'zip-code': 'Enter a ZIP code',
    "phone": 'Enter a phone number',
    'payment-address': 'Enter a billing address',
    'paypal-email': 'Enter a PayPal email address',
    'terms': 'Please agree to the terms of service',
    'mailin': 'Please select an option',
    'payment-method': 'Please select a payment method'
  },

  screens: {
    pyd: '#ti-device-picker',
    cart: '#ti-cart',
    checkout: '#ti-checkout',
    thankYou: '#ti-thank-you',
  },
  queries: {
    brands: `query Brands( $channels: [ChannelName]) {
      brands(channels: $channels) {
        id
        name
      }
    }`,
    categories: `query Categories($channels: [ChannelName]) {
      categories(channels: $channels) {
        id
        name
      }
    }`,
    series: `query Series($brandId: ID!, $categoryId: ID!, $channels: [ChannelName]) {
      series(brandId: $brandId, categoryId: $categoryId, channels: $channels) {
        id
        name
        readyForSale
        moratoriumEndDate
      }
    }`,
    models: `query Models($brandId: String!, $categoryId: ID, $seriesId: String) {
      models(categoryId: $categoryId, brandId: $brandId, seriesId: $seriesId) {
        id
        name
      }
    }`,
    storage: `query StorageOptions($brandId: String!, $seriesId: String!, $modelName: String!) {
      storageOptions(brandId: $brandId, seriesId: $seriesId, modelName: $modelName) {
        id
        name
      }
    }`,
    carriers: `query Carriers {
      carriers {
        id
        name
      }
    }`,
    createPackingSlip: `mutation CreatePackingSlip($item: TransactionItemInput!) {
      checkout(input: {
        operation: CREATE_PACKING_SLIP,
        transactionItems: [$item]
      }) {
        packingSlip { number }
      }
    }`,
    addOffer: `mutation AddOffer($item: TransactionItemInput!, $packingSlipNumber: String!) {
      checkout(input: {
        operation: ADD_OFFER,
        packingSlipNumber: $packingSlipNumber,
        transactionItem: $item
      }) {
        packingSlip { number }
      }
    }`,
    removeOffer: `
      mutation RemoveOffer($packingSlipNumber: String!, $offerNumber: String!) {
        checkout(input: {
          operation: REMOVE_OFFER,
          packingSlipNumber: $packingSlipNumber,
          offerNumber: $offerNumber
        }) {
          packingSlip { number }
        }
      }
    `,
    payout: `query Payout($brandName: String!
      $modelName: String!
      $seriesName: String
      $storageOption: String
      $carrierName: String
      $categoryId: ID
      $powerUp: Boolean
      $lcdOK: Boolean
      $cracks: Boolean
      $additionalPromoQualifiers: JSON
      $channels: [ChannelName]
      $countryCode: String
      $currencyCode: String
    ) {
      payout(
        brandName: $brandName
        modelName: $modelName
        seriesName: $seriesName
        storageOption: $storageOption
        carrierName: $carrierName
        categoryId: $categoryId
        powerUp: $powerUp
        lcdOK: $lcdOK
        cracks: $cracks
        additionalPromoQualifiers: $additionalPromoQualifiers
        channels: $channels
        countryCode: $countryCode
        currencyCode: $currencyCode
      ) {
        deviceId
        offerId
        pid
        recyclable
        promotion {
          promoCode
          promoPrice
          sourceId
        }
        offerState
        offerV3 {
          amount
          channel
          currencyCode
        }
      }
    }`,
    packingSlip: `query PackingSlip($number: String!) {
      packingSlip(number: $number) {
        createdAt
        email
        expirationDate
        id
        number
        totalEstimatedValue 
        totalPayoutBonus
        totalPromo 
        totalEstimatedPayment
        paymentInformation {
          id
          payoutType
          paypalEmail
          checkAddress {
            id
            checkName
            street1
            city
            state
            zipCode
            country
            phoneNumber
          }
        }
        status
        submittedAt
        updatedAt
        shippingInformation {
          id
          firstName
          lastName
          street1
          city
          state
          zipCode
          country
          phoneNumber
        }
        shippingOptions {
          id
          name
        }
        transactionItems {
          id
          number
          product {
            id
            name
            manufacturerName
            categoryName
            imageUrl
          }
          status
          estimatedValue
          actualValue
          hasEstimatedValue
          createdAt
          updatedAt
        }
      }
    }`,
    deviceFAQ: `
        query GetDeviceFAQ($handle: MetaobjectHandleInput!) {
          metaobject(handle: $handle) {
            handle
            fields {
              key
              value
            }
          }
        }
      `,
    verifyAddress: `query VerifyAddress($street1: String!, $city: String!, $state: String!, $zip: String!) {
        verifyAddress(street1: $street1, city: $city, state: $state, zip: $zip) {
          city
          country
          state
          street1
          zip
        }
      }`,
      checkout: `mutation Checkout($input: CheckoutInput!) {
        checkout(input: $input) {
          operation
          packingSlip {
            id
            number
            status
            email
            transactionItems {
              id
              number
              product {
                id
                name
                manufacturerName
                categoryName
                imageUrl
              }
              status
              estimatedValue
              actualValue
              hasEstimatedValue
              createdAt
              updatedAt
            }
            shippingInformation {
              id
              firstName
              lastName
              street1
              city
              state
              zipCode
              country
              phoneNumber
            }
            paymentInformation {
              id
              payoutType
              paypalEmail
              checkAddress {
                street1
                city
                state
                zipCode
                country
                phoneNumber
              }
            }
            totalEstimatedValue 
            totalPayoutBonus
            totalPromo 
            totalEstimatedPayment
            #eligibleForBox
            expirationDate
            shippingLabelUrl
            user {
              email
              firstName
              lastName
            }      
            createdAt
            updatedAt
            submittedAt
          }
        }
      }`
  },

  init() {
    this.parseSettings();
    this.initScreen('pyd');
  },

  parseSettings() {
    try {
      const settings = JSON.parse(
        document.querySelector('#pyd')?.dataset.settings || '{}'
      );

      window.PYD ??= {};
      window.PYD.config = { ...window.PYD.config, ...settings };
      window.PYD_META_TAGS_ENABLED = Boolean(window.PYD.config?.UPDATE_META_TAGS);

      return settings;
    } catch {
      return {};
    }
  },

  // Init screen from URL or fallback
  initScreen(defaultScreen) {
    const { ['ti-screen']: screen } = this.getUrlParams(['ti-screen']);
    const existingScreen = screen && this.screens[screen] ? screen : defaultScreen;
    this.showScreen(existingScreen);
  },

  // Show one screen, hide others, and update URL
  showScreen(key) {
    const selector = this.screens[key];
    PYD.state.currentScreen = key;

    if (!selector) {
      console.error(`Screen key "${key}" is not defined in PYD.screens{}.`);
      return;
    }

    // Hide all screens
    Object.values(this.screens).forEach(sel => {
      const el = document.querySelector(sel);
      if (el) {
        el.style.display = 'none';
        el.setAttribute('hidden', '');
      }
    });

    // Show the selected screen
    const target = document.querySelector(selector);
    if (target) {
      target.style.display = 'block';
      target.removeAttribute('hidden');
      
      // single param update
      PYD.updateUrlParam('ti-screen', key);
      
      if (key === "pyd") {
        window.dispatchEvent(new CustomEvent('pageload', {
          detail: { stepName: selector },
        }));
      }
    } else {
      console.error(`Element for selector "${selector}" not found.`);
    }
  },

  async fetchData(url, query = null, method = "GET", extraHeaders = {}) {
    const headers = new Headers({
      "Content-Type": "application/json",
      "Accept": "application/json",
      ...extraHeaders
    });

    let finalUrl = url;
    const requestOptions = {
      method,
      query,
      headers,
      redirect: "follow",
    };

    if (method === "GET") {
      finalUrl = `${url}?query=${encodeURIComponent(query.query)}`;
      if (query.variables) finalUrl += `&variables=${encodeURIComponent(JSON.stringify(query.variables))}`;
    } else {
      requestOptions.method = "POST";
      requestOptions.body = JSON.stringify({ query: query.query, variables: query.variables || null });
    }

    return fetch(finalUrl, requestOptions);
  },

  // Returns an object with the specified URL parameters and their values.
  getUrlParams(keys = []) {
    return Object.fromEntries(keys.map(k => [k, new URLSearchParams(window.location.search).get(k) || '']));
  },
  formatCurrency(value) {
    return value.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  },

  // Batch update multiple URL params at once
  updateUrlParams(updates) {
    const url = new URL(window.location.href);
    let hasChanges = false;

    Object.entries(updates).forEach(([key, value]) => {
      const current = url.searchParams.get(key);
      if (value) {
        if (current !== value) {
          url.searchParams.set(key, value);
          hasChanges = true;
        }
      } else if (current !== null) {
        url.searchParams.delete(key);
        hasChanges = true;
      }
    });

    if (hasChanges) {
      window.history.replaceState({}, '', url.toString());
    }
  },

  // Single param update (uses batch under the hood)
  updateUrlParam(key, value) {
    this.updateUrlParams({ [key]: value });
  },

  // Set or merge data into sessionStorage
  setSessionStorage: (key, value) => {
    const existing = sessionStorage.getItem(key);
    let dataToStore = value;

    // Merge objects if both existing and new values are objects
    if (existing && typeof value === "object") {
      const parsed = JSON.parse(existing);
      if (parsed && typeof parsed === "object") {
        dataToStore = { ...parsed, ...value };
      }
    }
    sessionStorage.setItem(key, JSON.stringify(dataToStore));
  },

  // Retrieve and parse data from sessionStorage
  getSessionStorage: (key) => {
    try {
      return JSON.parse(sessionStorage.getItem(key));
    } catch {
      return sessionStorage.getItem(key);
    }
  },

  // clear a specific key from sessionStorage
  clearSessionStorage: (key) => {
    if (typeof Storage === "undefined") return;
    sessionStorage.removeItem(key);
  },
  
  // Reset PYD form, start over
  reset() {
    // Reset all form selections
    const PYDForm = document.querySelector("pyd-form");
    PYDForm?.resetDownstream(['brand', 'series', 'model', 'storage', 'carrier']);
    PYDForm?.disableSubmit();
    PYDForm?.disableQuestions();

    // Batch all URL param clears into one call
    PYD.updateUrlParams({
      brand: null,
      series: null,
      model: null,
      storage: null,
      carrier: null,
      q1: null,
      q2: null,
      q3: null
    });

    // Reset State
    this.state = {};

    // Hide all offer screen and render placeholder screen
    PYD.hideAll('.offer-screen')
      .then(() => {
        document.querySelector('.device-placeholder')?.classList.remove('hidden');
      });

    // Go to PYD screen
    this.showScreen("pyd");
    const scrollTarget = document.getElementById('ti-device-picker');

    if (scrollTarget) {
    scrollTarget.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
    }
    PYDForm?.init();
  },

  resetPYDState() {
    Object.assign(this.state, {
      brand: undefined,
      category: undefined,
      series: undefined,
      model: undefined,
      storage: undefined,
      carrier: undefined,
      q1: undefined,
      q2: undefined,
      q3: undefined
    });
  },

  // Apply hidden class to all element with classname
  hideAll(selector) {
    return new Promise(resolve => {
      // Hide all elements matching the selector
      document.querySelectorAll(selector).forEach(el => {
        el.classList.add('hidden');
      });

      // Resolve the promise once the hiding action is complete
      resolve();
    });
  },

  async getPriceEstimate() {
    // Get active channels only WEB, only TRADE_IN or both WEB and TRADE_IN
    const activeChannel = document.querySelector('[data-channel]').dataset.channel
      .split(',')              // split by commas
      .map(s => s.trim())      // remove spaces
      .filter(s => s.length);  // remove empty strings
      PYD.config.CHANNELS = activeChannel;

    const countryCode = document.querySelector('[data-country]').dataset.country 
    const currencyMap = {
      US: 'USD',
      CA: 'CAD'
    };
    const currencyCode = currencyMap[countryCode] || 'USD';

    const validPromoParams = PYD.getSessionStorage("socialMarketingPromoUTM");
  
    // 2. Destructure state values
    const { brand, category, series, model, storage, carrier, q1, q2, q3 } = PYD.state;
  
    const carrierName =
      carrier?.handle === LOCKED_CARRIER_HANDLE ? 'Other' : (carrier?.name ?? null);

    // 3. Base GraphQL variables
    const variables = {
      brandName: brand?.name ?? null,
      seriesName: series?.name ?? null,
      modelName: model?.name ?? series?.name ?? null,
      storageOption: storage?.name ?? null,
      carrierName,
      categoryId: category?.id ?? null,
      powerUp: q1.id === 'yes',
      lcdOK: q2.id === 'yes',
      cracks: q3.id === 'yes',
      channels: PYD.config?.CHANNELS ?? ['WEB'],
      latitude: null,
      longitude: null,
      countryCode: countryCode ?? 'US',
      currencyCode: currencyCode
    };
      
    // 4. Only include promo qualifiers if available
    if (validPromoParams != null && Object.keys(validPromoParams).length > 0) {
      variables.additionalPromoQualifiers = validPromoParams;
    }
  
    // 5. Fetch and process response
    const response = await PYD.fetchData(PYD.config.GRAPHQL_URL, {
      query: PYD.queries.payout,
      variables,
    }, "POST");
  
    // 6. Safely get payout data
    const data = await response.json();
    const payout = data?.data?.payout || [];
    document.querySelector(`.device-cash-offer`)?.classList.add('active');

    if (typeof data.errors !== 'undefined' || payout.offerV3 == null) {

      PYD.hideAll('.offer-type')
      .then(() => {
        document.querySelector('.device-placeholder')?.classList.add('hidden');
        document.querySelector(`.offer-card`)?.classList.remove('hidden');
        document.querySelector(`.offer-error`)?.classList.remove("hidden");
      });
    }
    else {
      document.querySelector(`.offer-error`).classList.add("hidden");
    }

    // 7. Update state with payout info
    PYD.state.payout = payout;
  },

  setDeviceInfo: () => {
    let sessionData = PYD.getSessionStorage('pyd');
  
    const brandName = sessionData && sessionData.brandName.charAt(0).toUpperCase() + sessionData.brandName.slice(1);
    const categoryName = sessionData && sessionData.categoryName;
    const modelName = sessionData && sessionData.modelName;
    const seriesName = sessionData && sessionData.seriesName;
    const storageOption = sessionData && sessionData.storageOption;
    const carrierName = sessionData && sessionData.carrierName;
    const powerUp = sessionData && sessionData.powerUp;
    const lcdOk = sessionData && sessionData.lcdOk;
    const cracks = sessionData && sessionData.cracks;
    const offerPrice = sessionData && sessionData.offerPrice;
    const promoPrice = sessionData && sessionData.promoPrice;
    const offerPriceMailIn = sessionData && sessionData.offerPriceMailIn;
    const offerState = sessionData && sessionData.offerState?.toLowerCase();
    const countryCode = document.querySelector('[data-country]').dataset.country 
    const currencyMap = {
      CA: ' CAD'
    };
    const currencyCode = currencyMap[countryCode] || '';
    const displayName = modelName && modelName.trim() !== '' && modelName !== seriesName ? modelName : seriesName;

    document.querySelectorAll('.strikethrough-price').forEach(i => {
      i.innerHTML = "";
    });

    // Display on device info selected brand and series
    document.querySelector(`.device-name`).innerHTML = `${decodeURIComponent(brandName)} ${decodeURIComponent(displayName)}`;
    
    // Display on device info selected storage size
    document.querySelector(`.device-storage`).classList.add('hidden');
    if (storageOption) {
      document.querySelector(`.device-storage`).innerHTML = `${storageOption}`;
      document.querySelector(`.device-storage`).classList.remove('hidden');
    }

    // Display on device info selected carrier
    document.querySelector(`.device-carrier`).classList.add('hidden');
    if (carrierName) {
      document.querySelector(`.device-carrier`).innerHTML = `${carrierName}`;
      document.querySelector(`.device-carrier`).classList.remove('hidden');
    }

    document.querySelector(`.powers-on.yes`).classList.toggle("hidden", powerUp === 'no');
    document.querySelector(`.powers-on.no`).classList.toggle("hidden", powerUp !== 'no');

    document.querySelector(`.lights-up.yes`).classList.toggle("hidden", lcdOk === 'no');
    document.querySelector(`.lights-up.no`).classList.toggle("hidden", lcdOk !== 'no');

    document.querySelector(`.has-cracks.yes`).classList.toggle("hidden", cracks !== 'no');
    document.querySelector(`.has-cracks.no`).classList.toggle("hidden", cracks === 'no');


    let offerType = document.querySelector(`.device-offer`).dataset.offerType;
    PYD.setSessionStorage("pyd", {"selectedOfferType": offerType});

    // Hide all offer types
    PYD.hideAll('.offer-type')
    .then(() => {
      if (offerType == "both") {
        if (offerPrice == null || offerPrice == 0 ) {
          offerType = 'mailin';
        }
        if (offerPriceMailIn == null || offerPriceMailIn == 0) {
          offerType = 'kiosk';
        }
      }  
      // Offer type is both kiosk and mail-in
      if (offerType == "both") {
        PYD.setSessionStorage("pyd", {"offerDisplayed": "both"});
        document.querySelector(`.device-placeholder`).classList.add('hidden');
        document.querySelector(`.offer-card`).classList.remove('hidden');
        document.querySelector(`.kiosk-mailin`).classList.remove("hidden");

        let kioskDiscount = 1 - (document.querySelector(`.kiosk`).dataset.discount / 100);
        if (kioskDiscount < 1 && (Math.round(offerPrice * kioskDiscount) < offerPrice)) {
          document.querySelector(`label[for='kiosk-offer'] .strikethrough-price`).innerHTML = `$${Math.round(offerPrice * kioskDiscount)}<div class="currency-code">${currencyCode}</div>`;
        }

        document.querySelector(`label[for='kiosk-offer'] .amount:not(.counter)`).innerHTML = `${offerPrice}`;
        PYD.countUp(offerPrice, `label[for='kiosk-offer'] .offer-amount`);

        document.querySelector(`label[for='mailin-offer'] .amount:not(.counter)`).innerHTML = `${offerPriceMailIn}`;
        PYD.countUp(offerPriceMailIn, `label[for='mailin-offer'] .offer-amount`);
        this.dispatchEvent(new CustomEvent('pyd:condition-completed', {
          detail: { ...PYD.state, stepName: "condition" },
          bubbles: true
        }));
        this.dispatchEvent(new CustomEvent('pyd:form-completed', {
          detail: { ...PYD.state, stepName: "offer page" },
          bubbles: true
        }));
      }
      // Offer type is kiosk only
      if (offerType == "kiosk") {
        PYD.setSessionStorage("pyd", {"offerDisplayed": "kiosk"});
        document.querySelector(`.kiosk`)?.classList.remove("hidden");
        document.querySelector(`.offer-card`)?.classList.remove('hidden');

        PYD.hideAll('.offer-state')
        .then(() => {

          this.dispatchEvent(new CustomEvent('pyd:screen-loaded', {
            detail: { screen: offerState?.replaceAll('_', '-') },
            bubbles: true
          }));
          if (offerState) {
            if (offerState == "base_price") {
              document.querySelector(`.base-price`).classList.remove("hidden");
              let kioskDiscount = 1 - (document.querySelector(`.kiosk`).dataset.discount / 100);
              if (kioskDiscount < 1 && (Math.round(offerPrice * kioskDiscount) < offerPrice)) {
                document.querySelector(`.base-price .strikethrough-price`).innerHTML = `$${Math.round(offerPrice * kioskDiscount)}<div class="currency-code">${currencyCode}</div>`;
              }
              document.querySelector(`.base-price .amount:not(.counter)`).innerHTML = `${offerPrice}${currencyCode}`;
              PYD.countUp(offerPrice, '.base-price .offer-amount', currencyCode);

            }
            if (offerState == "promo_price") {
              let offerPriceWithPromo = offerPrice + promoPrice;
              let promoPercent = 1 - (document.querySelector(`.kiosk`).dataset.promoPercent / 100);
              if (promoPercent < 1 && (Math.round(offerPriceWithPromo * promoPercent) < offerPriceWithPromo)) {
                document.querySelector(`.promo-price`).classList.remove("hidden");
                document.querySelector(`.promo-price .strikethrough-price`).innerHTML = `$${Math.round(offerPriceWithPromo * promoPercent)}<div class="currency-code">${currencyCode}</div>`;
                document.querySelector(`.promo-price .amount:not(.counter)`).innerHTML = `${Math.round(offerPriceWithPromo)}${currencyCode}`;
                PYD.countUp(offerPriceWithPromo, '.promo-price .offer-amount', currencyCode);              
              }
              else {
                let strikethroughPrice = offerPrice;
                let offerPriceWithPromo = offerPrice + promoPrice;
                PYD.setSessionStorage("pyd", {
                  offerPrice: offerPriceWithPromo 
                });
                document.querySelector(`.promo-price`).classList.remove("hidden");
                document.querySelector(`.promo-price .strikethrough-price`).innerHTML = `$${Math.round(strikethroughPrice)}<div class="currency-code">${currencyCode}</div>`;
                document.querySelector(`.promo-price .amount:not(.counter)`).innerHTML = `${Math.round(offerPriceWithPromo)}${currencyCode}`;
                PYD.countUp(offerPriceWithPromo, '.promo-price .offer-amount', currencyCode);
              }
            }     
            if (offerState == "no_lock") {
              document.querySelector(`.no-lock`).classList.remove("hidden");
              if (categoryName.toLowerCase() == 'tablet') {
                document.querySelector(`.no-lock .tablet`).classList.remove('hidden');
              } else {
                document.querySelector(`.no-lock .non-tablet`).classList.remove('hidden');
              }
              let kioskDiscount = 1 - (document.querySelector(`.kiosk`).dataset.discount / 100);
              if (kioskDiscount < 1 && (Math.round(offerPrice * kioskDiscount) < offerPrice)) {
                document.querySelector(`.no-lock .strikethrough-price`).innerHTML = `$${Math.round(offerPrice * kioskDiscount)}<div class="currency-code">${currencyCode}</div>`;
              }
              document.querySelector(`.no-lock .amount:not(.counter)`).innerHTML = `${offerPrice}${currencyCode}`;
              PYD.countUp(offerPrice, '.no-lock .offer-amount', currencyCode);
            }
            if (offerState == "recycle") {
              document.querySelector(`.recycle`).classList.remove("hidden");
            }
            if (offerState == "check_back") {
              document.querySelector(`.check-back`).classList.remove("hidden");
            }
            if (offerState == "device_not_accepted") {
              document.querySelector(`.device-not-accepted`).classList.remove("hidden");  
            }
            document.querySelector(`.device-email`).classList.add('hidden');
            document.querySelector(`.device-dropoff`).classList.add('hidden');
            document.querySelector(`.device-placeholder`).classList.add('hidden');
            this.dispatchEvent(new CustomEvent('pyd:condition-completed', {
              detail: { ...PYD.state, stepName: "condition" },
              bubbles: true
            }));
            this.dispatchEvent(new CustomEvent('pyd:form-completed', {
              detail: { ...PYD.state, stepName: "offer page" },
              bubbles: true
            }));
          }
        });
      }
      // Offer type is mail in only
      if (offerType == "mailin") {
        document.querySelector(`.mailin`).classList.remove("hidden");
        document.querySelector(`.mail-in-error`).classList.add("hidden");

        if (offerPriceMailIn <= 0 || sessionData.productId == "") {
          PYD.setSessionStorage("pyd", {"offerDisplayed": "none"});
          document.querySelector(`.offer-error`).classList.add("hidden");
          document.querySelector(`.mail-in`).classList.add("hidden");
          document.querySelector(`.mail-in-error`).classList.remove("hidden");
          this.dispatchEvent(new CustomEvent('pyd:form-completed', {
            detail: { ...PYD.state, stepName: "no price available" },
            bubbles: true
          }));
        }
        else {
          PYD.setSessionStorage("pyd", {"offerDisplayed": "mail-in"});
          document.querySelector(`.mail-in`).classList.remove("hidden");
          document.querySelector(`.mailin`).classList.remove("hidden");
          document.querySelector(`.mailin .amount:not(.counter)`).innerHTML = `${offerPriceMailIn}`;
          PYD.countUp(offerPriceMailIn, '.mailin .offer-amount');
        }

        document.querySelector(`.device-placeholder`).classList.add('hidden');
        document.querySelector(`.offer-card`).classList.remove('hidden');
        this.dispatchEvent(new CustomEvent('pyd:condition-completed', {
          detail: { ...PYD.state, stepName: "condition" },
          bubbles: true
        }));
        this.dispatchEvent(new CustomEvent('pyd:form-completed', {
          detail: { ...PYD.state, stepName: "offer page" },
          bubbles: true
        }));
      }
      
    });

    document.querySelector('.ti-pyd-offer').scrollIntoView({
      behavior: 'smooth',
      block: 'start' // or 'center', 'end', 'nearest'
    });

    window.dispatchEvent(new CustomEvent('pyd:offer-shown', {
      detail: PYD.state,
      bubbles: true,
      composed: true
    }));
  },

  // Display the counter for selected element
  countUp: (countTo, selector, suffix = '') => {
    if (suffix !== '') {
      suffix = ' ' + suffix;
    }

    const el = document.querySelector(`${selector} .counter`);
    if (!countTo || !el) return;

    const duration = 1000;
    const start = performance.now();

    const animate = t => {
      const progress = Math.min((t - start) / duration, 1);
      const value = Math.floor(progress * countTo);

      el.textContent = `${value}${suffix}`;

      if (progress < 1) {
        requestAnimationFrame(animate);
      } else {
        el.textContent = `${countTo}${suffix}`;
      }
    };

    requestAnimationFrame(animate);
  },

  // Copies the provided text to the user's clipboard and shows a temporary "copied" notification
  copyToClipboard: (text) => {

    // Attempt to write the text to the clipboard
    navigator.clipboard.writeText(text).then(() => {

      // Find the UI element that displays the "copied" message
      const copied = document.querySelector('.device-offer .copied');

      // Show the message by adding a class (assumes CSS handles the animation)
      copied.classList.add('show');

      // Hide the message again after 2 seconds
      setTimeout(() => {
        copied.classList.remove('show');
      }, 2000);

    }).catch(err => {
      // Handle any failure to copy text (e.g., permission issues or insecure context)
      console.error("Failed to copy:", err);
    });
  },
  updateMetaTags: ({ title, description, canonical }) => {
    canonical = (canonical || '').toLowerCase();
    // Helper: create or update meta tag
    const upsertMeta = (selector, attributes) => {
      let tag = document.querySelector(selector);
  
      if (!tag) {
        tag = document.createElement('meta');
  
        Object.keys(attributes).forEach(key => {
          if (key !== 'content') {
            tag.setAttribute(key, attributes[key]);
          }
        });
  
        document.head.appendChild(tag);
      }
  
      if (attributes.content) {
        tag.setAttribute('content', attributes.content);
      }
    };
  
    // Update <title>
    if (title) {
      document.title = title;
    }
  
    // Update <meta name="description">
    upsertMeta('meta[name="description"]', {
      name: 'description',
      content: description
    });
  
    // Update <link rel="canonical">
    let canonicalLink = document.querySelector('link[rel="canonical"]');
    if (!canonicalLink) {
      canonicalLink = document.createElement('link');
      canonicalLink.setAttribute('rel', 'canonical');
      document.head.appendChild(canonicalLink);
    }
    if (canonical) {
      canonicalLink.setAttribute('href', canonical);
    }
  
    // ---------------------------
    // Open Graph Updates
    // ---------------------------
  
    if (title) {
      upsertMeta('meta[property="og:title"]', {
        property: 'og:title',
        content: title
      });
    }
  
    if (description) {
      upsertMeta('meta[property="og:description"]', {
        property: 'og:description',
        content: description
      });
    }
  
    if (canonical) {
      upsertMeta('meta[property="og:url"]', {
        property: 'og:url',
        content: canonical
      });
    }
  
    // ---------------------------
    // Twitter Updates
    // ---------------------------
  
    if (title) {
      upsertMeta('meta[name="twitter:title"]', {
        name: 'twitter:title',
        content: title
      });
    }
  
    if (description) {
      upsertMeta('meta[name="twitter:description"]', {
        name: 'twitter:description',
        content: description
      });
    }
  
    if (canonical) {
      upsertMeta('meta[name="twitter:url"]', {
        name: 'twitter:url',
        content: canonical
      });
    }
  },
  capitalize: (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  },

  getBrandFromDomain: () =>{
    const domain = location.hostname.toLowerCase();
    if (domain.includes("ecoatm")) return "ecoatm";
    if (domain.includes("gazelle")) return "gazelle";
    return "ecoatm";
  },

  acceptOffer: (e) => {
    if (document.querySelector('#kiosk-offer').checked == true) {
      PYD.setSessionStorage('pyd',{
        selectedOfferType: 'kiosk'
      });
    }
    if (document.querySelector('#mailin-offer').checked == true) {
      PYD.setSessionStorage('pyd',{
        selectedOfferType: 'mailin'
      });
    }
    let sessionData = PYD.getSessionStorage('pyd');
    const offerType = sessionData && sessionData.selectedOfferType;
    const offerId = sessionData && sessionData.offerId;
    const productId = sessionData && sessionData.productId;
    if (offerType === 'kiosk') {
      // Handle kiosk path
      PYD.getEmail(e);
      window.dispatchEvent(new CustomEvent('pyd:offer-kiosk', {
        detail: {...PYD.state, stepName: "offer page" }
      }));
    } 
    if (offerType === 'mailin') {
      // Handle mail-in path
      let newDevice = {
        productId: productId,
        offerId: offerId
      };
      PYD.setSessionStorage("pyd", {"currency": "USD"});
      window.tradeIn.addItem(newDevice);
      // clear PYD url params
      ['brand','series','model','storage','carrier','q1','q2','q3']
      .forEach(p => PYD.updateUrlParam(p, null));
      
      window.dispatchEvent(new CustomEvent('pyd:offer-accepted', {
        detail: PYD.state,
        bubbles: true,
        composed: true
      }));

      PYD.showScreen("cart");
    }
  },

  getEmail: (e) => {
    const countryCode = document.querySelector('[data-country]').dataset.country 
    const currencyMap = {
      CA: ' CAD'
    };
    const currencyCode = currencyMap[countryCode] || '';
    document.querySelector(`#email-button img`)?.classList.remove('hidden');
    document.querySelector(`#email-button .pyd-spinner`)?.classList.add('hidden');
    document.querySelector(`#phone-button img`)?.classList.remove('hidden');
    document.querySelector(`#phone-button .pyd-spinner`)?.classList.add('hidden');
    PYD.enableButton('#email-button');
    PYD.enableButton('#phone-button');

    document.querySelector(`.kiosk-mailin`).classList.add('hidden');
    document.querySelector(`.kiosk`).classList.remove('hidden');

    let sessionData = PYD.getSessionStorage('pyd');
    document.querySelectorAll('.offer-state').forEach(el => {
      el.classList.add('hidden');
    });
    document.querySelector(`.device-email`).classList.remove('hidden');


    if (sessionData?.offerState.toLowerCase() == 'promo_price') {
      let offerPriceWithPromo = sessionData?.offerPrice + sessionData?.promoPrice;
      let promoPercent = 1 - (document.querySelector(`.kiosk`).dataset.promoPercent / 100);
      if (promoPercent < 1 && (Math.round(offerPriceWithPromo * promoPercent) < offerPriceWithPromo)) {
        document.querySelector(`.device-email .strikethrough-price`).innerHTML = `$${Math.round(offerPriceWithPromo * promoPercent)}<div class="currency-code">${currencyCode}</div>`;
      }
      else {
        document.querySelector(`.device-email .strikethrough-price`).innerHTML = `$${Math.round(sessionData?.offerPrice - sessionData?.promoPrice)}<div class="currency-code">${currencyCode}</div>`;
      }
      document.querySelector(`.device-email .amount:not(.counter)`).innerHTML = `${offerPriceWithPromo}${currencyCode}`;
      document.querySelector(`.device-email .amount.counter`).innerHTML = `${offerPriceWithPromo}${currencyCode}`;
    }
    else {
      let kioskDiscount = 1 - (document.querySelector(`.kiosk`).dataset.discount / 100);
      if (kioskDiscount < 1 && (Math.round(sessionData.offerPrice * kioskDiscount) < sessionData.offerPrice)) {
        document.querySelector(`.device-email .strikethrough-price`).innerHTML = `$${Math.round(sessionData.offerPrice * kioskDiscount)}<div class="currency-code">${currencyCode}</div>`;
      }
      document.querySelector(`.device-email .amount:not(.counter)`).innerHTML = `${sessionData.offerPrice}${currencyCode}`;
      document.querySelector(`.device-email .amount.counter`).innerHTML = `${sessionData.offerPrice}${currencyCode}`;
    }

    this.dispatchEvent(new CustomEvent('pyd:screen-loaded', {
      detail: { screen: 'contact-form' },
      bubbles: true
    }));
  },

  disableButton: (selector) => {
    //  Logic to disable button so user can't spam it causing multiple offer codes 
    let targetButton = document.querySelector(selector);
    targetButton?.setAttribute('disabled', 'disabled');
    targetButton?.classList.add('disabled'); // optional, for styling
    targetButton?.setAttribute('disabled', 'true'); // for accessibility and form behavior
    targetButton?.style && (targetButton.style.pointerEvents = 'none');
    targetButton?.style && (targetButton.style.opacity = 0.5);

  },

  enableButton: (selector) => {
    //  Logic to enable button 
    let targetButton = document.querySelector(selector);
    targetButton?.removeAttribute('disabled', 'disabled');
    targetButton?.classList.remove('disabled'); // optional, for styling
    targetButton?.removeAttribute('disabled', 'true'); // for accessibility and form behavior
    targetButton?.style && (targetButton.style.pointerEvents = 'auto');
    targetButton?.style && (targetButton.style.opacity = 1);
  },

  getOfferCodeEmail: (e) => {
    // Logic to disable button so user can't spam it causing multiple offer codes
    PYD.disableButton('#email-button');

    const emailAddress = document.querySelector('input[name="email-address"]').value.trim();
    if (PYD.validateEmail(emailAddress) === false) {
      document.querySelector('.input-email').classList.add('error');
      document.querySelector('input[name="email-address"]').addEventListener('input', PYD.errorMessageRemove);
      PYD.enableButton('#email-button');
    }
    else {
      document.querySelector(`.input-email`).classList.remove('error');
      document.querySelector(`#email-button img`).classList.add('hidden');
      document.querySelector(`#email-button .pyd-spinner`).classList.remove('hidden');
      
      PYD.setSessionStorage("pyd", {
        emailAddress: emailAddress
      });
      PYD.state.emailAddress = emailAddress;
      PYD.getOfferCode('email');
    }
  },

  getOfferCodePhone: (e) => {
    // Logic to disable button so user can't spam it causing multiple offer codes
    PYD.disableButton('#phone-button');

    const phone = document.querySelector(`input[name="phone-number"]`).value.trim();
    if (PYD.validatePhone(phone) === false) {
      document.querySelector('.error-message.phone-error')?.classList.remove('hidden');
      document.querySelector('.error-message.checkbox-error')?.classList.add('hidden');
      document.querySelector('.input-phone')?.classList.add('error');
      document.querySelector('input[name="phone-number"]').addEventListener('input', PYD.errorMessageRemove);
      PYD.enableButton('#phone-button');
    } else if (!(document.querySelector('#text-subscribe input[type="checkbox"]')?.checked)) {
      document.querySelector(`.error-message.checkbox-error`)?.classList.remove('hidden');
      document.querySelector(`.error-message.phone-error`)?.classList.add('hidden');
      document.querySelector(`.input-phone`)?.classList.add('error');
      PYD.enableButton('#phone-button');
    }
    else {
      document.querySelector(`.input-phone`)?.classList.remove('error');
      document.querySelector(`.error-message.checkbox-error`)?.classList.add('hidden');
      document.querySelector(`.error-message.phone-error`)?.classList.add('hidden');
      document.querySelector(`#phone-button img`)?.classList.add('hidden');
      document.querySelector(`#phone-button .pyd-spinner`)?.classList.remove('hidden');
      
      PYD.setSessionStorage("pyd", {
        phoneNumber: phone
      });
      PYD.state.phone = phone;
      PYD.getOfferCode('phone');
    }
  },

  getOfferCode: (type) => {
    const countryCode = document.querySelector('[data-country]').dataset.country 
    const currencyMap = {
      CA: ' CAD'
    };
    const currencyCode = currencyMap[countryCode] || '';
    
    let sessionData = PYD.getSessionStorage('pyd');
    let apiUrl = `${PYD.config.GRAPHQL_URL}/graphql`;
    let moneyLionExist = false;
    let moneyLionElement = document.getElementById('moneyLionMain');
    if (moneyLionElement && moneyLionElement.style.display !== 'none') {
      moneyLionExist = true;
    }

    let optimizelyDecisionData = PYD.getSessionStorage("optimizelyDecisionData");
    let metaData = {
      moneylionVisible: moneyLionExist,
      optimizelyDecisionData: optimizelyDecisionData,
      referringDomain: window.location.hostname
    }

    const sessionKeys = {
      "pyd_gclid": "gclid",
      "pyd_msclkid": "msclkid",
      "pyd_fbclid": "fbclid"
    };
    Object.keys(sessionKeys).forEach(storageKey => {
      const value = sessionStorage.getItem(storageKey);
      if (value) {
        metaData[sessionKeys[storageKey]] = value;
      }
    });

    PYD.handleNewsletterSubscribe();

    let stepName = "enter " + type;
    this.dispatchEvent(new CustomEvent('pyd:enter-contact', {
      detail: {...PYD.state, stepName: stepName},
      bubbles: true,
      composed: true,
    }));

    var graphql = {
      query: `mutation DropOffCode(
        $DeviceId: String!
        ${sessionData.emailAddress ? '$Email: String' : ''}
        ${sessionData.phoneNumber ? '$phoneNumber: String' : ''}
        $OfferId: String
        $scratches: Boolean
        $cracks: Boolean
        $powerUp: Boolean
        $lcdOk: Boolean
        $channelName: ChannelName
        $v2PaymentInfo: PaymentInfoV2Input
        $codeType: String
        $metadata: JSON
      ) {
        dropOffCode(
          DeviceId: $DeviceId
          ${sessionData.emailAddress ? 'Email: $Email' : ''}
          ${sessionData.phoneNumber ? 'phoneNumber: $phoneNumber' : ''}
          OfferId: $OfferId
          scratches: $scratches
          cracks: $cracks
          powerUp: $powerUp
          lcdOk: $lcdOk
          channelName: $channelName
          v2PaymentInfo: $v2PaymentInfo
          codeType: $codeType
          metadata: $metadata
        ) {
          Code
          ChannelName
          CodeVersion
          CreationDateTime
          DevicePriceId
          ${sessionData.emailAddress ? 'Email' : ''}
          ${sessionData.phoneNumber ? 'PhoneNumber' : ''}
          ExpirationDateTime
          Id
          Price
          PriceGrade
        }
      }`,
      variables: {
        DeviceId: sessionData.deviceId,
        Email: sessionData.emailAddress,
        OfferId: sessionData.offerId,
        scratches: sessionData.cracks === 'yes' ? true : false,
        cracks: sessionData.cracks === 'yes' ? true : false,
        powerUp: sessionData.powerUp === 'yes' ? true : false,
        lcdOk: sessionData.lcdOk === 'yes' ? true : false,
        channelName: "WEB",
        codeType: "W",
        metadata: metaData,
        ...(sessionData.emailAddress && { Email: sessionData.emailAddress.toLowerCase() }),
        ...(sessionData.phoneNumber && { phoneNumber: sessionData.phoneNumber })          
      }
    }

    PYD.fetchData(apiUrl, graphql, "POST")
    .then(response => response.json())
    .then(results => {
      if (results.errors && results.errors.length > 0) {
        let error = results.errors[0];
        let errorData = {apiUrl: apiUrl, query: graphql};
        PYD.handleError("Error caught while fetching DropOffCode", error, errorData);
      } else {
        let offer = results.data.dropOffCode;
        PYD.setSessionStorage("pyd", {
          createdAt: offer.CreationDateTime,
          expiryDate: offer.ExpirationDateTime,
          kioskCode: offer.Code,
          currency: "USD"
        });
        let sessionData = PYD.getSessionStorage('pyd');
        PYD.state.kioskCode = offer.Code;
        this.dispatchEvent(new CustomEvent('pyd:thank-you', {
          detail: {...PYD.state, stepName: "thank you page"},
          bubbles: true,
          composed: true,
          
        }));
        document.querySelector(`.device-email`)?.classList.add('hidden');
        document.querySelector(`.device-dropoff`)?.classList.remove('hidden');
        document.querySelector(`.offer-code .code`) && (document.querySelector(`.offer-code .code`).innerHTML = `${offer.Code}`);
        document.querySelector(`.expire-date span`) && (document.querySelector(`.expire-date span`).innerHTML = ` Expires ${PYD.formatDate(offer.ExpirationDateTime)}`);

        if (sessionData?.offerState.toLowerCase() == 'promo_price') {
          let offerPriceWithPromo = sessionData?.offerPrice + sessionData?.promoPrice;
          let promoPercent = 1 - (document.querySelector(`.kiosk`).dataset.promoPercent / 100);
          if (promoPercent < 1 && (Math.round(offerPriceWithPromo * promoPercent) < offerPriceWithPromo)) {
            document.querySelector(`.device-dropoff .strikethrough-price`).innerHTML = `$${Math.round(offerPriceWithPromo * promoPercent)}<div class="currency-code">${currencyCode}</div>`;
          }
          else {
            document.querySelector(`.device-dropoff .strikethrough-price`).innerHTML = `$${Math.round(sessionData?.offerPrice - sessionData?.promoPrice)}<div class="currency-code">${currencyCode}</div>`;
          }
          document.querySelector(`.device-dropoff .amount:not(.counter)`).innerHTML = `${offerPriceWithPromo}${currencyCode}`;
          document.querySelector(`.device-dropoff .amount.counter`).innerHTML = `${offerPriceWithPromo}${currencyCode}`;
        }
        else {
          let kioskDiscount = 1 - (document.querySelector(`.kiosk`).dataset.discount / 100);
          if (kioskDiscount < 1 && (Math.round(sessionData.offerPrice * kioskDiscount) < sessionData.offerPrice)) {
            document.querySelector(`.device-dropoff .strikethrough-price`).innerHTML = `$${Math.round(sessionData.offerPrice * kioskDiscount)}<div class="currency-code">${currencyCode}</div>`;
          }
          document.querySelector(`.device-dropoff .amount:not(.counter)`).innerHTML = `${sessionData.offerPrice}${currencyCode}`;
          document.querySelector(`.device-dropoff .amount.counter`).innerHTML = `${sessionData.offerPrice}${currencyCode}`;
        }

        PYD.sendOffer();
        PYD.clearSessionStorage('pyd');
      }
    })
    .catch((error) => {
      PYD.hideAll('.offer-type')
      .then(() => {
        if (error.code == "VALIDATION_ERROR") {
          document.querySelector(`.input-email`)?.classList.add('error');
          document.querySelector(`#email-button img`)?.classList.remove('hidden');
          document.querySelector(`#email-button .pyd-spinner`)?.classList.add('hidden');
          document.querySelector(`.kiosk`)?.classList.remove('hidden');
          PYD.enableButton('#email-button');
        } else {
          document.querySelector('.device-placeholder')?.classList.add('hidden');
          document.querySelector(`.offer-card`)?.classList.remove('hidden');
          document.querySelector(`.offer-error`)?.classList.remove("hidden");
        }
      });
      let errorData = {apiUrl: apiUrl, query: graphql};
      PYD.handleError("Error caught while fetching DropOffCode", error, errorData);
    });
  },

  handleNewsletterSubscribe: () => { 
    const newsletterInputs = document.querySelectorAll('.contact-form input[name="method"]'),
          sessionData = PYD.getSessionStorage('pyd');

    newsletterInputs.forEach((input)=>{
      if(input.checked){
        const type = input.getAttribute('id');
        if(type == 'email-method'){
          if (document.querySelector('#email-newsletter').checked) {
            PYD.setSessionStorage("pyd", {
              emailSubscribed: true
            });
            PYD.subscribeToNewsletter(sessionData.emailAddress.toLowerCase(), PYD.getBrandFromDomain(), PYD.config.NEWSLETTER_SOURCE);
          }
        }
      }  
    });
  },

  // Set or merge data into sessionStorage
  setSessionStorage: (key, value) => {
    const existing = sessionStorage.getItem(key);
    let dataToStore = value;

    // Merge objects if both existing and new values are objects
    if (existing && typeof value === "object") {
      const parsed = JSON.parse(existing);
      if (parsed && typeof parsed === "object") {
        dataToStore = { ...parsed, ...value };
      }
    }
    sessionStorage.setItem(key, JSON.stringify(dataToStore));
  },

  // Retrieve and parse data from sessionStorage
  getSessionStorage: (key) => {
    try {
      return JSON.parse(sessionStorage.getItem(key));
    } catch {
      return sessionStorage.getItem(key);
    }
  },

  // clear a specific key from sessionStorage
  clearSessionStorage: (key) => {
    if (typeof Storage === "undefined") return;
    sessionStorage.removeItem(key);
  },

  // Converts a string into a URL-friendly "handle" or slug.
  handleize: (input = '') => {
    if (!input) return '';

    return input
      .trim()
      .toString()
      .toLowerCase()
      .normalize('NFD')                 // Split accented chars (é → e +  ́)
      .replace(/[\u0300-\u036f]/g, '')  // Remove diacritics
      .replace(/&/g, '-and-')           // Replace & with “and”
      .replace(/\+/g, '-plus-')         // Replace + with “plus”
      .replace(/[^a-z0-9]+/g, '-')      // Replace all non-alphanumeric with hyphen
      .replace(/^-+|-+$/g, '')          // Trim leading/trailing hyphens
      .replace(/-{2,}/g, '-');          // Collapse multiple hyphens
  },

  // Validates email address, returns a boolean
  validateEmail: (email) => {
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
      return true;
    }
    else {
      return false;
    }
  },

  // Validates phone number, returns a boolean
  validatePhone: (phone) => {
    // Remove common formatting characters
    const cleaned = phone.replace(/[^\d]/g, '');
    
    // Valid if 10 digits or 11 digits 
    if (/^(\d{10}|\d{11})$/.test(cleaned)) {
      return true;
    } else {
      return false;
    }
  },

  // Validates zipcode, returns a boolean
  validateZip: (zip) => {
    if (/^\d{5}(-\d{4})?$/.test(zip)) {
      return true;
    }
    else {
      return false;
    }
  },

  // Formats an ISO date string (YYYY-MM-DD...) into a short US-style date (e.g., "Nov 14, 2025")
  formatDate: (isoString) => {
    const date = new Date(isoString);

    // Options for "Nov 14, 2025" style formatting
    const options = { 
      month: 'short', 
      day: '2-digit', 
      year: 'numeric', 
      timeZone: 'UTC' 
    };

    return date.toLocaleDateString('en-US', options);
  },

  // Formats a phone number into the pattern: ###-###-####
  formatPhoneNumber: (input) => {
    // Remove anything that isn't a digit
    let value = input.value.replace(/\D/g, '');
    let formattedValue = '';

    // Checks if field is cleared
    if (value == '') {
      input.classList.remove('filled');
    }

    // Add first 3 digits
    if (value.length > 0) {
      input.classList.add('filled');
      formattedValue = value.substring(0, 3);
    }

    // Add next 3 digits with a dash
    if (value.length >= 4) {
      formattedValue += '-' + value.substring(3, 6);
    }

    // Add last 4 digits with a dash
    if (value.length >= 7) {
      formattedValue += '-' + value.substring(6, 10);
    }

    // Update the input value with formatted result
    input.value = formattedValue;
  },

  // Formats an address into a single HTML-friendly string
  formatAddress: ({ street1, city, state, zip }) => {
    return `${street1}<br>${city}, ${state} ${zip}`;
  },

  errorMessageRemove: (e) => {
    const input = e.target
    if(input.value == ''){
      input.closest('.contact-form-container').classList.remove('error');
      input.removeEventListener('input', PYD.errorMessageRemove);
    }
  },

  // [TODO] Error handling, custom logs to DataDog (TBD)
  handleError(message, error, payout) {
    console.error(message, error);

    window.ecoATMTheme.sendLogsToDataDog({
      error,
      message: message,
      payload: {
        apiURL: payout?.apiUrl,
        query: payout?.query,
      },
    });
    throw error;
  },

  deActivateErrorCard: () => {
    document.querySelector('.offer-screen.device-error')?.classList.add('hidden');
    document.querySelector('.offer-screen.device-placeholder')?.classList.remove('hidden');
    document.querySelector('.offer-screen.offer-card')?.classList.add('hidden');
  },

  activateErrorCard: () => {
    document.querySelector('.offer-screen.device-placeholder')?.classList.add('hidden');
    document.querySelector('.offer-screen.device-error')?.classList.remove('hidden');
    document.querySelector('.offer-screen.offer-card')?.classList.add('hidden');

    if (window.innerWidth < 650) {
      const target = document.getElementById('estimate-button');
      
      if (target) {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }
  },

  sendOffer: (e) => {
    let sessionData = PYD.getSessionStorage('pyd');
    let apiUrl = `${PYD.config.GRAPHQL_URL}}/graphql`;
    var graphql = {
      query: `mutation SendDropoffCode($input: SendDropoffCodeInput) {
        sendDropoffCode(input: $input)
      }`,
      variables: {
        input: {
          kioskCode: sessionData.kioskCode,
          deviceId: sessionData.deviceId,
          offerId: sessionData.offerId
        }
      }
    }
    PYD.fetchData(apiUrl, graphql, "POST")
    .then(response => response.json())
    .then(results => {
      console.log(results);
    })
    .catch((error) => {
      let errorData = {apiUrl: apiUrl, query: graphql};
      PYD.handleError("Error caught while fetching sendDropoffCode", error, errorData);
    });
  },

  subscribeToNewsletter: (email, domain, contactSourceDetail) => {
    return new Promise((resolve, reject) => {
      let apiUrl = `${PYD.config.GRAPHQL_URL}/graphql`;
      var graphql = {
        query: `mutation subscribeToNewsletter($input: NewsletterSubscribeInput!) {
          subscribeToNewsletter(input: $input)
        }`,
        variables: {
          input: {
            referringDomain: window.location.hostname,
            emailAddress: email,
            domain: domain,
            contactSourceDetail: contactSourceDetail
          }
        }
      }
      PYD.fetchData(apiUrl, graphql, "POST")
        .then(response => response.json())
        .then(results => {
          resolve(results)
        })
        .catch((error) => {
          let errorData = {apiUrl: apiUrl, query: graphql};
          PYD.handleError("Error caught while fetching subscribeToNewsletter", error, errorData);
          reject(error);
        });
    });
  },

  // Validates primary and (optional) secondary addresses, updates the UI, 
  // stores verified addresses, and advances the checkout flow.
  validateAddressesAndSubmit: async function(customerData) {
    // Main Address Validation
    const mailingUserInputAddress = document.querySelector('.gpyd-m-checkout__confirm-address--mailing [user-input-address]');
    if (mailingUserInputAddress) {
      mailingUserInputAddress.innerHTML = PYD.formatAddress({
        street1: customerData.customerAddress,
        city: customerData.customerCity,
        state: customerData.customerState,
        zip: customerData.customerZip
      });
    }

    // Primary Address Validation
    const primary = await PYD.verifyShippingAddress({
      street1: customerData.customerAddress,
      city: customerData.customerCity,
      state: customerData.customerState,
      zip: customerData.customerZip
    });

    if (primary) {
      VERIFIED_MAIN_ADDRESS = primary;

      const mailingVerifiedAddress = document.querySelector('.gpyd-m-checkout__confirm-address--mailing [verified-address]');
      if (mailingVerifiedAddress) {
        mailingVerifiedAddress.innerHTML = PYD.formatAddress({
          street1: primary.street1,
          city: primary.city,
          state: primary.state,
          zip: primary.zip
        });
      }
    }

    // Determine if "Use same address" is selected
    const paymentRadio = document.querySelector('.checkout-payment-options');
    const checkboxComponent = paymentRadio?.shadowRoot.querySelector('.gpyd-m-checkout__check-address checkbox-input');
    const useSameAddressCheckbox = checkboxComponent?.shadowRoot.querySelector('input[type="checkbox"]');
    
    const useSameAddress = !!useSameAddressCheckbox?.checked;


    const checkAddress = customerData.checkCustomerAddress;

    const hasCheckAddress =
      checkAddress &&
      checkAddress.customerAddress &&
      checkAddress.customerCity &&
      checkAddress.customerState &&
      checkAddress.customerZip;
    

    let secondary = null;
    // Check Address Handling
    if (useSameAddress == true) {
      // Reuse verified primary address
      secondary = primary;
      VERIFIED_CHECK_ADDRESS = primary;
    } else if (hasCheckAddress) {
      const checkUserInputAddress = document.querySelector('.gpyd-m-checkout__confirm-address--check [user-input-address]');
      if (checkUserInputAddress) {
        checkUserInputAddress.innerHTML = PYD.formatAddress({
          street1: checkAddress.customerAddress,
          city: checkAddress.customerCity,
          state: checkAddress.customerState,
          zip: checkAddress.customerZip
        });
      }

      secondary = await PYD.verifyShippingAddress({
        street1: checkAddress.customerAddress,
        city: checkAddress.customerCity,
        state: checkAddress.customerState,
        zip: checkAddress.customerZip
      });

      if (secondary) {
        VERIFIED_CHECK_ADDRESS = secondary;
        const checkVerifiedAddress = document.querySelector('.gpyd-m-checkout__confirm-address--check [verified-address]');
        if (checkVerifiedAddress) {
          checkVerifiedAddress.innerHTML = PYD.formatAddress({
            street1: secondary.street1,
            city: secondary.city,
            state: secondary.state,
            zip: secondary.zip
          });
        }
      }
    }

    CUSTOMER_DATA = { ...customerData };

    const normalize = str => (str || '').trim().toUpperCase();
    let isMainSameAddress = true;
    if (primary) {
      isMainSameAddress =
        normalize(customerData.customerAddress) === normalize(primary.street1) &&
        normalize(customerData.customerCity) === normalize(primary.city) &&
        normalize(customerData.customerState) === normalize(primary.state) &&
        normalize(primary.zip).includes(normalize(customerData.customerZip));
    }

    let isCheckSameAddress = true;
    if (!useSameAddress && secondary) {
      isCheckSameAddress =
        normalize(checkAddress.customerAddress) === normalize(secondary.street1) &&
        normalize(checkAddress.customerCity) === normalize(secondary.city) &&
        normalize(checkAddress.customerState) === normalize(secondary.state) &&
        normalize(secondary.zip).includes(normalize(checkAddress.customerZip));
    }

    if (isMainSameAddress && isCheckSameAddress) {
      PYD.moveToThankYou();
    } else {
      // Address different, move to confirm address page
      document.querySelector('.gpyd-m-checkout__confirm-sale')?.removeAttribute('disabled');
      const leftInner = document.querySelector('.gpyd-m-checkout__left-inner');
      if (leftInner) leftInner.classList.add('inactive');
      const address = document.querySelector('.gpyd-m-checkout__confirm-address');
      if (address) address.classList.add('active');
      window.scrollTo(0, 0);
    }
  },
  // Handles the final submission step, updates address fields based on user selections,
  // submits the packing slip, subscribes the user if selected,
  // and transitions the UI to the Thank You page.
  async moveToThankYou() {

    // Disable submit button to prevent double-submission
    document.querySelector('.gpyd-m-checkout__confirm-address--submit')?.setAttribute('disabled', 'true');

    // Elements for "Use Verified Address" checkboxes
    const mailInUserVerifiedAddress = document.querySelector('[data-name="user-default-address-mailin"]');
    const checkUserVerifiedAddress = document.querySelector('[data-name="user-default-address-check"]');

    // Flags storing whether the user selected "Use Verified Address"
    let useVerifiedMainAddress = false;
    let useVerifiedCheckAddress = false;

    // ---------------------------------------------
    // 1. READ CHECKBOXES FROM SHADOW DOM
    // ---------------------------------------------
    if (mailInUserVerifiedAddress?.shadowRoot) {
      const checkbox = mailInUserVerifiedAddress.shadowRoot.querySelector('input[type="checkbox"]');
      if (checkbox) useVerifiedMainAddress = checkbox.checked;
    }

    if (checkUserVerifiedAddress?.shadowRoot) {
      const checkbox = checkUserVerifiedAddress.shadowRoot.querySelector('input[type="checkbox"]');
      if (checkbox) useVerifiedCheckAddress = checkbox.checked;
    }

    // ---------------------------------------------
    // 2. POPULATE THANK YOU PAGE WITH DEFAULT USER INPUT ADDRESS
    // ---------------------------------------------
    Object.entries(CUSTOMER_ADDRESS).forEach(([id, value]) => {
      const el = document.getElementById(id);
      if (el) el.textContent = value;
    });


    // This object holds the final values to submit in the packing slip
    let customerMainDataForPackingSlip = { ...CUSTOMER_DATA };


    // ---------------------------------------------
    // 3. APPLY VERIFIED MAIN ADDRESS IF USER SELECTED IT
    // ---------------------------------------------
    if (useVerifiedMainAddress && VERIFIED_MAIN_ADDRESS) {

      // Map verified main address to DOM fields
      const verifiedMap = {
        customerAddress: VERIFIED_MAIN_ADDRESS.street1 || '',
        customerCity: VERIFIED_MAIN_ADDRESS.city || '',
        customerState: VERIFIED_MAIN_ADDRESS.state || '',
        customerZip: VERIFIED_MAIN_ADDRESS.zip || ''
      };

      // Update Thank You page UI values
      Object.entries(verifiedMap).forEach(([id, value]) => {
        const el = document.getElementById(id);
        if (el) el.textContent = value;
      });

      // Update data used for packing slip submission
      customerMainDataForPackingSlip = {
        ...customerMainDataForPackingSlip,
        customerAddress: VERIFIED_MAIN_ADDRESS.street1,
        customerCity: VERIFIED_MAIN_ADDRESS.city,
        customerState: VERIFIED_MAIN_ADDRESS.state,
        customerZip: VERIFIED_MAIN_ADDRESS.zip
      };
    }


    // ---------------------------------------------
    // 4. APPLY VERIFIED CHECK ADDRESS IF USER SELECTED IT
    // ---------------------------------------------
    if (useVerifiedCheckAddress && VERIFIED_CHECK_ADDRESS) {
      customerMainDataForPackingSlip = {
        ...customerMainDataForPackingSlip,
        checkCustomerAddress: {
          ...customerMainDataForPackingSlip.checkCustomerAddress,
          customerAddress: VERIFIED_CHECK_ADDRESS.street1,
          customerCity: VERIFIED_CHECK_ADDRESS.city,
          customerState: VERIFIED_CHECK_ADDRESS.state,
          customerZip: VERIFIED_CHECK_ADDRESS.zip,
        }
      };
    }


    // ---------------------------------------------
    // 5. DETERMINE SELECTED SHIPPING OPTION (inside Web Component)
    // ---------------------------------------------
    const selectedShippingOptionId =
      document.getElementById("shippingOptions")?.shadowRoot
        ?.querySelector('input[type="radio"]:checked')?.value || null;


    // ---------------------------------------------
    // 6. SUBMIT PACKING SLIP
    // ---------------------------------------------
    const result = await PYD.submitPackingSlip(customerMainDataForPackingSlip, selectedShippingOptionId);


    // ---------------------------------------------
    // 7. HANDLE SUBMISSION RESPONSE
    // ---------------------------------------------
    if (result) {

      window.dispatchEvent(
        new CustomEvent('tradeIn:thankYouLoaded', {
          detail: { ...PYD.state, stepName: "thank you mail-in" }
        })
      );

      // 7a. Newsletter subscription
      const subscribeInput =
        document.querySelector('checkbox-input[data-name="subscribe"]')
          ?.shadowRoot
          ?.querySelector('input[type="checkbox"]');

      if (subscribeInput?.checked) {
        PYD.subscribeToNewsletter(CUSTOMER_DATA.customerEmail, PYD.getBrandFromDomain(), PYD.config.NEWSLETTER_SOURCE);
      }

      // Re-enable submit button
      document.querySelector('.gpyd-m-checkout__confirm-address--submit')
        ?.removeAttribute('disabled');

      // Delete cookie used earlier in the checkout process
      window.tradeIn.deletePackingSlipFromStorage();

      // ---------------------------------------------
      // 8. UPDATE THANK YOU CARD CONTENT
      // ---------------------------------------------
      const nextStepsCard = document.querySelector('.gpyd-m-checkout__thank-you--card-2-row.row-2'),
            descriptionContainer = nextStepsCard.querySelector('.gpyd-m-checkout__description'),
            labelText = descriptionContainer?.getAttribute('data-label-text') || 'Print out your shipping label, then pack & ship your device(s).',
            boxText = descriptionContainer?.getAttribute('data-label-box') || 'Wait for your box to arrive, then pack & ship your device(s).',
            mailInState = PYD.getSessionStorage('pyd').mailInMethod;

      descriptionContainer.innerHTML = 
        mailInState === 'Get a box sent to you' 
            ? boxText
            : mailInState === 'Print a Shipping Label'
                ? labelText
                : labelText; 

      // ---------------------------------------------
      // 9. TRANSITION TO THE THANK YOU PAGE
      // ---------------------------------------------
      const leftInner = document.querySelector('.gpyd-m-checkout__left-inner');
      if (leftInner) leftInner.classList.add('inactive');

      const confirmSection = document.querySelector('.gpyd-m-checkout__confirm-address');
      const thankYouSection = document.querySelector('.gpyd-m-checkout__thank-you');

      confirmSection?.classList.remove('active');
      thankYouSection?.classList.add('active');

      window.scrollTo(0, 0);

      document.querySelector('.gpyd-m-checkout__confirm-address--submit')?.removeAttribute('disabled');
      document.querySelector('.gpyd-m-checkout__confirm-sale')?.removeAttribute('disabled');
      PYD.clearSessionStorage('pyd');
    } else {
      document.querySelector('.gpyd-m-checkout__confirm-address--submit')?.removeAttribute('disabled');
      document.querySelector('.gpyd-m-checkout__confirm-sale')?.removeAttribute('disabled');
      console.error('Packing slip submission failed.');
    }
  },
  showCheckoutErrorMessage: (type) => {
    let selector = "input-address";
    const confirmAddress = document.querySelector(
      '.gpyd-m-checkout__left .gpyd-m-checkout__confirm-address'
    );
    if (confirmAddress?.classList.contains('active')) {
      selector = "verify-address";
    }

    document.querySelector('.gpyd-m-checkout__confirm-sale')?.removeAttribute('disabled');
    document.querySelector('.gpyd-m-checkout__confirm-address--submit')?.removeAttribute('disabled');

    document.querySelectorAll('.ti-checkout__error-popup .ti-checkout__error-popup--content').forEach(el => {
      el.classList.remove('active');
    });

    document.querySelector(`.ti-checkout__error-popup[data-type="${selector}"]`)?.classList.add('active');
    document.querySelector(`.ti-checkout__error-popup[data-type="${selector}"] .ti-checkout__error-popup--content[data-type="${type}"]`)?.classList.add('active');
  },
  hideCheckoutErrorMessage: () => {
    document.querySelectorAll('.ti-checkout__error-popup')
      .forEach(popup => {
        popup.classList.remove('active');
      });
    document.querySelectorAll('.ti-checkout__error-popup--content')
      .forEach(popup => {
        popup.classList.remove('active');
      });
  },
  setMailInMethods: (shippingOptions) => {
    const options = [];
    // Print Shipping Level option (usps or anything except obb)
    const fallback = shippingOptions.find(opt => opt.name !== "obb");
    if (fallback) {
      options.push({
        value: fallback.id.toString(),
        title: "Print a Shipping Label",
        caption: "Sent via email"
      });
    }
    // Get a Box option (obb)
    const obbOption = shippingOptions.find(opt => opt.name === "obb");
    if (obbOption && options.length < 2) {
      options.push({
        value: obbOption.id.toString(),
        title: "Get a box sent to you",
        caption: "6 - 7 days to arrive"
      });
    }

    // Update the radio-group
    const radioGroup = document.getElementById("shippingOptions");
    if (radioGroup) {
      radioGroup.setAttribute("data-options", JSON.stringify(options));
      // If only one option, then auto select
      if (options.length === 1) {
        const shadow = radioGroup.shadowRoot;
        if (shadow) {
          const radio = shadow.querySelector('input[type="radio"]');
          if (radio) {
            radio.checked = true;
            radio.dispatchEvent(new Event('change', { bubbles: true })); 
          }
          const radioOption = shadow.querySelector('.radio-option.checked');
          if (radioOption) {
            radioOption.classList.add('hide-radio');
          }
        }
      }
    }
  },
  gettingPackingSlip: async (paymentType) => {
    const packingSlip = await window.tradeIn.getPackingSlip();

    const isCheckoutPage = window.location.search.includes('ti-screen=checkout');
    if (!packingSlip && isCheckoutPage) {
      const baseUrl = window.location.origin + window.location.pathname;
      window.location.href = baseUrl;
      return;
    }
  
    if (!packingSlip) {
      return;
    }
  
    const items = packingSlip.transactionItems || [];
    const html = `
      <div class="gpyd-m-checkout__right-summary--content gpyd-m-checkout__description">
        ${items
          .map(
            (item) => `
          <div class="gpyd-m-checkout__right-summary--content-row">
            <div>${item.product.name}</div>
            <div>$${item.estimatedValue.toFixed(2)}</div>
          </div>
        `
          )
          .join("")}
      </div>
    `;
  
    if (packingSlip.shippingOptions) {
      PYD.setMailInMethods(packingSlip.shippingOptions);
    }
    // Update LineItems
    const rightSummaryObserver = new MutationObserver((mutations, obs) => {
      const containers = document.querySelectorAll(".gpyd-m-checkout__right-summary");
      if (containers.length > 0) {
        containers.forEach((container) => {
          container.innerHTML = html;
        });
        obs.disconnect();
      }
    });
    rightSummaryObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
    // Use values from API or calculate
    const subTotal = packingSlip.totalEstimatedValue || 0;
    const promoPrice = packingSlip.totalPromo || 0;
    let amazonGiftcardPrice = packingSlip.totalPayoutBonus || 0;
    let totalPrice = packingSlip.totalEstimatedPayment || 0;
    // Hide Promo Price for now
    let showPromoPrice = false;
    if (paymentType == 'Amazon Gift Card' && amazonGiftcardPrice == 0) {
      amazonGiftcardPrice = parseFloat((subTotal * 0.015).toFixed(2));
      totalPrice = parseFloat((subTotal + promoPrice + amazonGiftcardPrice).toFixed(2));
    }
    PYD.setSessionStorage("pyd", {
      "promotionalBonus": promoPrice,
      "coupon": ""});
    // Helper Functions
    function updateElementsTextRaw(selector, value, prefix = '$') {
      const elements = document.querySelectorAll(selector);
      elements.forEach((el) => {
        el.textContent = `${prefix}${value}`;
      });
    }
    function updateElementsText(selector, value, prefix = '$') {
      const elements = document.querySelectorAll(selector);
      elements.forEach((el) => {
        el.textContent = `${prefix}${value.toFixed(2)}`;
      });
    }
    function addClassToElement(selector, newClass) {
      const elements = document.querySelectorAll(selector);
      elements.forEach((el) => {
        el.classList.add(newClass)
      });
    }
    function removeClassFromElement(selector, newClass) {
      const elements = document.querySelectorAll(selector);
      elements.forEach((el) => {
        el.classList.remove(newClass)
      });
    }
    // Set Item count next Subtotal
    const itemCount = items.length;
    const countSpans = document.querySelectorAll('.gpyd-m-checkout__right-subtotal--amount-count');
    countSpans.forEach(span => {
      span.textContent = itemCount === 1 
        ? '1 item' 
        : `${itemCount} items`;
    });
    // Display Price
    updateElementsTextRaw(".gpyd-m-checkout__right-subtotal--amount-number", PYD.formatCurrency(subTotal));
    // Hide Promo Price for now
    if (showPromoPrice) {
      updateElementsText(".gpyd-m-checkout__right-promo--amount-number", promoPrice);
      removeClassFromElement(".gpyd-m-checkout__right-promo", "inactive");
    } else {
      addClassToElement(".gpyd-m-checkout__right-promo", "inactive");
    }
    // Display Amazon summary only when Amazon payment is selected
    if (paymentType == 'Amazon Gift Card') {
      updateElementsText(".gpyd-m-checkout__right-amazon--amount-number", amazonGiftcardPrice);
      removeClassFromElement(".gpyd-m-checkout__right-amazon", "inactive");
    } else {
      addClassToElement(".gpyd-m-checkout__right-amazon", "inactive");
    }

    updateElementsTextRaw(".gpyd-m-checkout__right-total--amount-number", PYD.formatCurrency(totalPrice));
    updateElementsTextRaw(".gpyd-m-checkout__summary-top-amount", PYD.formatCurrency(totalPrice));
  },
  submitPackingSlip: async (customerData, selectedShippingOptionId) => {
    const packingSlipNumber = window.tradeIn.getPackingSlipFromStorage();

    let input = {
      operation: "SUBMIT",
      packingSlipNumber: packingSlipNumber,
      email: customerData.customerEmail,
      shippingInformation: {
        firstName: customerData.customerFirstName,
        lastName: customerData.customerLastName,
        address: {
          street1: customerData.customerAddress,
          city: customerData.customerCity,
          state: customerData.customerState,
          zipCode: customerData.customerZip,
          country: "United States"
        },
        phoneNumber: customerData.customerPhone
      },
      selectedShippingOptionId: parseInt(selectedShippingOptionId)
    };

    // Add payment-specific fields
    if (customerData.customerPaymentName === "Paypal") {
      input.paymentInformation = {
        payoutType: "PAYPAL",
        paypalEmail: customerData.customerPaymentAddress
      };
    }

    if (customerData.customerPaymentName === "Amazon Gift Card") {
      input.paymentInformation = {
        payoutType: "AMAZON_GIFT_CARD"
      };
    }

    if (customerData.customerPaymentName === "Check") {
      input.paymentInformation = {
        payoutType: "CHECK"
      };
      input.paymentInformation.checkName = customerData.checkCustomerAddress.customerFullName;
      input.paymentInformation.checkAddress = {
        street1: customerData.checkCustomerAddress.customerAddress,
        city: customerData.checkCustomerAddress.customerCity,
        state: customerData.checkCustomerAddress.customerState,
        zipCode: customerData.checkCustomerAddress.customerZip,
        country: "United States"
      };
    }

    let variables = { input };

    let apiUrl = `${PYD.config.GRAPHQL_URL}/graphql`;
    const graphql = {
      query: PYD.queries.checkout,
      variables: variables
    };

    return PYD.fetchData(apiUrl, graphql, "POST")
      .then(response => response.json())
      .then(results => {
        if (results?.errors?.[0]?.code === "TRANSACTION_ITEM_LIMIT_EXCEEDED" || results?.errors?.[0]?.code === "TRANSACTION_ITEM_LIMIT_WOULD_EXCEED") {
          PYD.showCheckoutErrorMessage("limit");
        } else {
          PYD.hideCheckoutErrorMessage();
        }
        return results?.data?.checkout?.packingSlip || null;
      })
      .catch((error) => {
        PYD.showCheckoutErrorMessage("general");
        let errorData = {apiUrl: apiUrl, query: graphql};
        PYD.handleError("Error caught while Submitting PackingSlip", error, errorData);
        return null;
      });
  },
  verifyShippingAddress: async ({ street1, city, state, zip }) => {
    let apiUrl = `${PYD.config.GRAPHQL_URL}/graphql`;
    const graphql = {
      query: PYD.queries.verifyAddress,
      variables: { street1, city, state, zip }
    };

    return PYD.fetchData(apiUrl, graphql, "GET")
      .then(response => response.json())
      .then(results => {
        const verified = results?.data?.verifyAddress;
        PYD.hideCheckoutErrorMessage();
        return verified || null;
      })
      .catch((error) => {
        PYD.showCheckoutErrorMessage("general");
        let errorData = {apiUrl: apiUrl, query: graphql};
        PYD.handleError("Error caught while verifyShippingAddress", error, errorData);
        return null;
      });
  },
  initCheckoutPage: async () => {
    document.querySelector('.ti-cart')?.classList.add('inactive');
  
    const packingSlip = await window.tradeIn.getPackingSlip();
    if (packingSlip) {
      PYD.state.confirmationNumber = packingSlip.number;

      const span = document.getElementById('gpydOrderNumber');
      if (span) {
        span.textContent = packingSlip.number;
      }
  
      await PYD.gettingPackingSlip('paypal');
    } else {
      PYD.init();
      initTradeIn();
    }
    await PYD.cartReady;
    window.dispatchEvent(new CustomEvent('tradeIn:CheckoutLoaded', {
      detail: { ...PYD.state, stepName: "mail-in checkout" },
    }));
  },

  // [START FAQs]
  getFAQs: async (handle) => {
    try {
      let variables = {
        handle: {
          handle: handle,
          type: "device_faq"
        }
      };
  
      const deviceFAQResponse = await PYD.fetchData(
        PYD.config.SHOPIFY_URL,
        {
          query: PYD.queries.deviceFAQ,
          variables
        },
        "POST",
        {
          "X-Shopify-Storefront-Access-Token": PYD.config.SHOPIFY_ACCESS_TOKEN
        }
      );
  
      // Response exists but could be empty or 204, don't need to throw error
      if (!deviceFAQResponse || !deviceFAQResponse.ok) {
        // soft fail — return null, not error
        console.info(`No FAQ response for handle "${handle}" (status: ${deviceFAQResponse?.status})`);
        return null;
      }
  
      const text = await deviceFAQResponse.text();
  
      // Empty FAQ returned, valid case so don't need to throw error
      if (!text?.trim()) {
        console.info(`No FAQ content found for handle "${handle}"`);
        return null;
      }
  
      // Parse only if valid JSON
      let deviceFAQData;
      try {
        deviceFAQData = JSON.parse(text);
      } catch {
        console.info(`FAQ data not JSON for handle "${handle}" — ignoring`);
        return null;
      }
  
      // Shopify returned valid response but no metaobject, don't need to throw error
      const metaobject = deviceFAQData?.data?.metaobject;
      if (!metaobject?.fields?.length) {
        console.info(`No FAQ metaobject fields found for handle "${handle}"`);
        return null;
      }
  
      // Build key/value map
      let faq = {};
      metaobject.fields.forEach(field => {
        if (field.value) faq[field.key] = field.value;
      });
  
      return faq || null;
  
    } catch (error) {
      // Only log *real* failures, not missing FAQ
      console.warn(`FAQ fetch failed for "${handle}"`, error);
      return null;
    }
  },  
  parseFAQs: (answerStr) => {
    try {
      // Unescape and parse the JSON string
      let cleanedStr = answerStr.replace(/\\"/g, '"').replace(/\\n/g, '');
      return JSON.parse(cleanedStr);
    } catch (e) {
      console.warn("Failed to parse answer:", e);
      return null;
    }
  },
  extractFAQ: (faqData) => {
    let faqList = [];

    for (let i = 1; ; i++) {
      let questionKey = `brand_question_${i}`;
      let answerKey = `answer_${i}`;

      if (!(questionKey in faqData) || !(answerKey in faqData)) break;

      let question = faqData[questionKey];
      let answerRaw = faqData[answerKey];
      let answer = PYD.parseFAQs(answerRaw);

      faqList.push({ question, answer });
    }

    return faqList;
  },
  loadFAQs: async (handle) => {
    try {
      let faqResponse = await PYD.getFAQs(handle);
      if (faqResponse) {
        let faqs = PYD.extractFAQ(faqResponse);
        PYD.renderFAQs(faqs);
      } else {
        console.log("No FAQ fields found for handle:", handle);
      }
    } catch (error) {
      console.warn("Error loading FAQs:", error);
    }
  },
  renderFAQs: (faqList) => {
    let container = document.getElementById('dynamic-accordion-container');
    if (!container || !faqList.length) return;

    let generateHTMLFromRichText = (richText) => {
      // Recursive rendering of parsed JSON rich text
      let renderNode = (node) => {
        if (node.type === 'text') return node.value;
        if (node.type === 'paragraph') {
          return `<p>${node.children.map(renderNode).join('')}</p>`;
        }
        if (node.type === 'list') {
          let tag = node.listType === 'ordered' ? 'ol' : 'ul';
          return `<${tag}>${node.children.map(renderNode).join('')}</${tag}>`;
        }
        if (node.type === 'list-item') {
          return `<li>${node.children.map(renderNode).join('')}</li>`;
        }
        return '';
      };
      return richText.children.map(renderNode).join('');
    };

    const html = faqList.map((faq, index) => {
      const contentHtml = generateHTMLFromRichText(faq.answer);
      return `
        <div class="accordion" data-index="${index}">
          <details>
            <summary aria-expanded="false" role="button">
              <h3 class="accordion__title inline-richtext h4">${faq.question}</h3>
              <svg class="icon icon-caret" viewBox="0 0 10 6"><path fill="currentColor" fill-rule="evenodd" d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708" clip-rule="evenodd"></path></svg>
            </summary>
            <div class="accordion__content rte" role="region">
              <div class="metafield-rich_text_field">
                ${contentHtml}
              </div>
            </div>
          </details>
        </div>
      `;
    }).join('');

    container.innerHTML = html;
  },
  deleteFAQs: () => {
    let container = document.getElementById('dynamic-accordion-container');
    if (!container) return;
    container.innerHTML = '';
  },
  handleFAQs: async function(state) {
    const { brand, series, model, stepName } = state ?? {};
    if (!stepName) return;

    if(stepName == 'brand') {
      if (!brand) return;
      this.deleteFAQs();
      await this.loadFAQs(brand.handle);

    } else if(stepName == 'series') {
      if (!brand || !series) return;
      const handle = `${brand.name}-${this.handleize(series.handle)}`
      this.deleteFAQs();
      await this.loadFAQs(handle);

    } else if (stepName == 'model') {
      if (!brand || !model) return;
      this.deleteFAQs();
      const handle = `${brand?.name}-${this.handleize(model.handle)}`;
      await this.loadFAQs(handle);
    }
  }
  // [END FAQs]
}

function parseProductName(fullName = "") {
  const carrierMatch = fullName.match(/\(([^)]+)\)$/); // capture inside final parentheses
  const carrier = carrierMatch ? carrierMatch[1] : null;

  // Remove carrier portion
  let remaining = fullName.replace(/\([^)]+\)$/, "").trim();

  const capacityMatch = remaining.match(/(\d+GB)$/i);
  const capacity = capacityMatch ? capacityMatch[1] : null;

  // Remove capacity portion
  if (capacity) remaining = remaining.replace(/\d+GB$/i, "").trim();

  // Remaining text is the name (1–3 words, variable)
  const name = remaining;

  return { name, capacity, carrier };
}

let DATALAYER = {
  dataLayerTrackEvent(payload) {
    (window.dataLayer = window.dataLayer || []).push(payload);
  },

  stringToHash(str) {
    let hash = 0;
    if (!str) return hash;
    for (let i = 0; i < str.length; i++) {
      hash = (hash << 5) - hash + str.charCodeAt(i);
      hash |= 0;
    }
    return hash;
  },

  buildPayload(st) {
    let stepName = st?.stepName;
    const { brand, category, series, model, payout, storage, carrier, q1, q2, q3 } = st;

    const cartItems = st?.cart?.items || [];
    let doneState = false;
    let displayCartItems = false;
    let pydSession = PYD.getSessionStorage('pyd');
    // only fire condition step when all 3 questions have been answered
    if ((stepName?.toLowerCase().includes('condition') && q3 == undefined) || stepName?.toLowerCase().includes('q1') || stepName?.toLowerCase().includes('q2') || stepName?.toLowerCase().includes('q3')) {
      return;
    } else if (stepName?.toLowerCase().includes('mail-in estimate') && !(PYD.state?.currentScreen?.toLowerCase().includes('cart'))) {
      return;
    } else if (stepName?.toLowerCase().includes('#ti-device-picker')) {
      stepName = 'start';
    } else if (stepName?.toLowerCase().includes('series')) {
      stepName = 'device model';
    } else if (stepName?.toLowerCase().includes('thank you')) {
      doneState = true;
    } 
    if (stepName?.toLowerCase().includes('mail-in')) {
      displayCartItems = true;
    } 

    // Determine price based on selected offer type
    let price, value = null;
    let offerAmountWeb = null;
    let offerAmountTradeIn = null;
    // get kiosk and mail-in values
    if (Array.isArray(payout?.offerV3)) {
      for (const o of payout.offerV3) {
        if (o.channel?.toLowerCase().includes("web")) offerAmountWeb = o.amount;
        if (o.channel?.toLowerCase().includes("trade_in")) offerAmountTradeIn = o.amount;
      }
    }
    // set value and price based on flow selected (kiosk or trade in)
    const selectedOfferType = pydSession?.selectedOfferType;
    if (selectedOfferType?.toLowerCase().includes("mailin")) {
      price = offerAmountTradeIn;
      value = st?.cart?.estimatedTotal;
    } else if (selectedOfferType?.toLowerCase().includes("kiosk")) {
      if (offerAmountWeb) {
        if (payout?.offerState.toLowerCase() == 'promo_price') {
          price = payout.promotion.promoPrice + offerAmountWeb;
          value = payout.promotion.promoPrice + offerAmountWeb;
        } 
        else {
          price = offerAmountWeb;
          value = offerAmountWeb;
        }
      }
    }

    const promoBonus = pydSession?.promotionalBonus;
    // 1. USER FIELDS
    const userFields = {
      ...(st?.emailAddress && { hashedemail: this.stringToHash(st?.emailAddress) }),
      ...(st?.phone && { hashedphone: this.stringToHash(st?.phone) }),
      ...(st?.kioskCode && { offer_code: st?.kioskCode }),
      ...(pydSession?.emailSubscribed && { "marketing_opt_in": pydSession.emailSubscribed }),
      ...(pydSession?.mailInMethod && { "mail-in_method": pydSession.mailInMethod }),
      ...(pydSession?.offerDisplayed && { offer_displayed: pydSession.offerDisplayed }),
      ...(selectedOfferType && { offer_type: selectedOfferType }),
      ...(st?.paymentOption && { payment_type: st?.paymentOption }),
      ...((st?.confirmationNumber || st?.kioskCode) && { transaction_id: st?.confirmationNumber || st.kioskCode }),
      ...(promoBonus != null && { promotional_bonus: promoBonus }),
      ...(value && { value: value }),
      ...(pydSession?.currency && { currency: pydSession.currency }),
      ...(pydSession?.coupon && { coupon: pydSession.coupon })
    };

    // 2. EXISTING CART DEVICES (historical), only add for step 8B - 10B (mail-in flow)
    let itemsFromCart = [];
    if (displayCartItems) {  
      itemsFromCart = cartItems.map((dev, idx) => {
        const parsed = parseProductName(dev?.product?.name);
        return {
          item_id: dev?.product?.id,
          item_brand: dev?.product?.manufacturerName,
          item_category: dev?.product?.categoryName,
          item_name: parsed?.name,
          device_capacity: parsed?.capacity,
          device_carrier: parsed?.carrier,
          device_power: dev?.q1?.id,
          device_light: dev?.q2?.id,
          device_cracks: dev?.q3?.id,
          offer_state: dev?.offerState,
          price: dev?.actualValue || dev?.estimatedValue,
          offer_amount_mail_in: dev?.actualValue || dev?.estimatedValue,
          quantity: 1,
          index: idx + 1
        };
      });
    }

    // 3. CURRENT DEVICE (step 1–7 values from PYD.state)
    // Extract channel-based amounts from payout.offerV3


    // Build active device payload
    const hasActiveDevice =
      brand || category || series || model || storage || carrier || q1 || q2 || q3;
    let currentDevicePayload = [];
    if (hasActiveDevice) {
      currentDevicePayload.push({
        item_id: payout?.pid || null,
        item_brand: brand?.name || null,
        item_category: category?.name || null,
        item_name: model?.name ?? series?.name ?? null,
        device_capacity: storage?.name || null,
        device_carrier: carrier?.name || null,
        device_power: q1 == null ? null : (q1.id?.toLowerCase().includes('yes')),
        device_light: q2 == null ? null : (q2.id?.toLowerCase().includes('yes')),
        device_cracks: q3 == null ? null : (q3.id?.toLowerCase().includes('yes')),
        offer_state: payout?.offerState || null,
        price: price,
        offer_amount_kiosk: offerAmountWeb,
        offer_amount_mail_in: offerAmountTradeIn,
        quantity: 1,
        index: itemsFromCart.length + 1
      });
    }

    const items = [...itemsFromCart, ...currentDevicePayload];

    // 4. OPTIMIZELY DATA
    const optimizely_data =
      PYD.getSessionStorage("optimizelyDecisionData") || null;

    // 5. FINAL PAYLOAD
    const payload = {
      gtm: {
        uniqueEventId: Date.now(),
        priorityId: 1,
        start: performance.now()
      },
      event: "page.submit",
      site_id: window.location.hostname,
      v: 12,
      name: "price your device",
      step_name: stepName,
      done: doneState,
      record: { recordType: "user" },
      domain: window.location.hostname,
      ...userFields,
      items,
      ...(optimizely_data && { optimizely_data })
    };

    this.dataLayerTrackEvent(payload);
  },
  // OLD Datalayer function
  trackDevicePricing: (st) => {
    let stepName = st?.stepName;
    const { brand, category, series, model, payout, storage, carrier, q1, q2, q3 } = st;

    let doneState = false;
    // only fire condition step when all 3 questions have been answered
    if ((stepName?.toLowerCase().includes('condition') && q3 == undefined) || stepName?.toLowerCase().includes('q1') || stepName?.toLowerCase().includes('q2') || stepName?.toLowerCase().includes('q3')) {
      return;
    } else if (stepName?.toLowerCase().includes('mail-in estimate') && !(PYD.state?.currentScreen?.toLowerCase().includes('cart'))) {
      return;
    } else if (stepName?.toLowerCase().includes('ti-device-picker')) {
      stepName = 'start';
    } else if (stepName?.toLowerCase().includes('series')) {
      stepName = 'device model';
    } else if (stepName?.toLowerCase().includes('thank you')) {
      doneState = true;
    } 
    let offerAmountWeb;
    if (Array.isArray(payout?.offerV3)) {
      for (const o of payout.offerV3) {
        if (o.channel?.toLowerCase().includes("web")) offerAmountWeb = o.amount;
      }
    }
    let data = {};
    // Add fields only if they have non-empty values
    if (brand?.name) data.device_brand = brand.name;
    if (category?.name) data.device_category = category.name;
    if (series?.name) data.device_model = decodeURIComponent(series.name);
    if (model?.name) data.device_model = decodeURIComponent(model.name);
    if (storage?.name) data.device_capacity = storage.name;
    if (carrier?.name) data.device_carrier = carrier.name;
    if (payout?.offerState) data.offer_state = payout.offerState;
    if (offerAmountWeb) {
      if (payout?.offerState.toLowerCase() == 'promo_price') {
        data.offer_amount = payout.promotion.promoPrice + offerAmountWeb;
      } 
      else {
        data.offer_amount = offerAmountWeb;
      }
    }
    if (st?.emailAddress) data.email = st.emailAddress;
    if (st?.emailAddress) data.hashedemail = DATALAYER.stringToHash(st.emailAddress);
    if (st?.kioskCode) data.offer_code = st.kioskCode;
    if (PYD.getSessionStorage('pyd')?.emailSubscribed) data.marketing_opt_in = PYD.getSessionStorage('pyd').emailSubscribed;
    if (q1?.id) data.device_power = (q1.id?.toLowerCase().includes('yes'));
    if (q2?.id) data.device_light = (q2.id?.toLowerCase().includes('yes'));
    if (q3?.id) data.device_cracks = (q3.id?.toLowerCase().includes('yes'));

    // Remove condition data from data on offer page status
    if (stepName?.toLowerCase().includes('offer page')) {
      delete data.device_power;
      delete data.device_light;
      delete data.device_cracks;
    }

    // OPTIMIZELY DATA
    const optimizely_data =
      PYD.getSessionStorage("optimizelyDecisionData") || null;
    
    const eventData = {
      event: 'page.submit',
      v: 12,
      name: 'price your device',
      done: doneState,
      step: {
        name: stepName
      },
      record: {
        recordType: 'user'
      },
      ...(Object.keys(data).length > 0 && { data }),  // Only include 'data' if not empty
      ...(optimizely_data && { optimizely_data })
    };

    DATALAYER.dataLayerTrackEvent(eventData);
  }
};


// list of all the event dispatchers related to datalayer
const PYD_EVENTS = [
  "pageload",
  "pyd:enter-contact",
  "pyd:thank-you",
  "tradeIn:cartLoadedPYD",
  "pyd:form-completed",
  "pyd:condition-completed",
  "pyd:offer-kiosk",
  "tradeIn:CheckoutLoaded",
  "tradeIn:thankYouLoaded",
  "pyd:form-change-completed"
];

// Attach listeners based on list above
PYD_EVENTS.forEach(evtName => {
  window.addEventListener(evtName, (event) => {
    // If feature flag is on → use old schema
    if (window.PYD?.config?.DATALAYER_FLAG) {
      DATALAYER.trackDevicePricing(event?.detail);
    } else {
      // Otherwise → run new payload builder
      DATALAYER.buildPayload(event?.detail);
    }
  });
});

window.tradeIn = {};

(() => {
  const initTradeIn = () => {
    window.tradeIn = {
      API_URL: PYD.config.GRAPHQL_URL,

      resetCart() {
        PYD.state.cart = {}
      },

      async getCart() {
        window.dispatchEvent(new CustomEvent('tradeIn:cartLoading'));
        // If a cart fetch is already in progress, await it
        if (PYD._cartPromise) {
          return PYD._cartPromise;
        }

        // Create a new in-flight promise
        PYD._cartPromise = (async () => {
          window.dispatchEvent(new CustomEvent('tradeIn:cartLoading'));

          try {
            // Get the PackingSlip number from localStorage
            const packingSlip = await this.getPackingSlip();
            if (!packingSlip) {

              this.resetCart();

              window.dispatchEvent(new CustomEvent('tradeIn:cartLoaded', {
                detail: { cart: PYD.state.cart },
              }));
              if (PYD._resolveCartReady) {
                PYD._resolveCartReady();
                PYD._resolveCartReady = null; // prevent double resolve
              }
              return PYD.state.cart;
            }

            // Update cart state
            PYD.state.cart = {
              items: packingSlip.transactionItems || [],
              estimatedTotal: packingSlip.totalEstimatedPayment || 0
            };

            window.dispatchEvent(new CustomEvent('tradeIn:cartLoaded', {
              detail: { cart: PYD.state.cart }
            }));

            localStorage.setItem('tradein_cart', JSON.stringify(PYD.state.cart));
            window.dispatchEvent(new CustomEvent('tradeIn:cartLoadedPYD', {
              detail: { ...PYD.state, cart: PYD.state.cart, stepName: "mail-in estimate" },
              bubbles: true,
              composed: true
            }));
            if (PYD._resolveCartReady) {
              PYD._resolveCartReady();
              PYD._resolveCartReady = null; // prevent double resolve
            }
            return PYD.state.cart;
          } catch (err) {
            let errorData = {apiUrl: this.API_URL, query: PYD.queries.packingSlip};
            PYD.handleError('Failed to get cart for given packing slip number:', err, errorData);
            window.dispatchEvent(new CustomEvent('tradeIn:cartError', {
              detail: { error: err }
            }));
            throw err;
          } finally {
          // release the lock
            PYD._cartPromise = null;
          }
        })();
        return PYD._cartPromise;
      },

      async addItem(item) {
        window.dispatchEvent(new CustomEvent('tradeIn:cartLoading'));
      
        const packingSlip = await this.getPackingSlip();
        const packingSlipNumber = packingSlip?.number;
      
        const isNew = !packingSlipNumber;
      
        try {
          const query = isNew
            ? PYD.queries.createPackingSlip
            : PYD.queries.addOffer;
      
          const variables = isNew
            ? { item }
            : { item, packingSlipNumber };
      
          const res = await PYD.fetchData(this.API_URL, {
            query: query,
            variables: variables,
          }, "POST");
      
          const json = await res.json();
          // Update localStorage with PSNumber (PackingSlip Number)
          const PSNumber = json?.data?.checkout?.packingSlip?.number;
          this.setPackingSlipToStorage(PSNumber);
      
          // Invalidate cached packing slip so next load refetches
          this.packingSlipData = null;
          this._packingSlipPromise = null;
      
          window.dispatchEvent(new CustomEvent('tradeIn:item-added', {
            detail: { packingSlipNumber: PSNumber, item, cart: PYD.state.cart },
            bubbles: true,
            composed: true
          }));
          //Wipe PYD form data so datalayer doesn't have duplicate items
          PYD.resetPYDState();
          // Update cart 
          return await this.getCart();
        } catch (err) {
          let errorData = {apiUrl: this.API_URL, query: query};
          PYD.handleError('Failed to add item to cart:', err, errorData);
          window.dispatchEvent(new CustomEvent('tradeIn:cartError', {
            detail: { error: err }
          }));
          return [];
        }
      },


      async deleteItem(SRNumber, productId) {
        window.dispatchEvent(new CustomEvent('tradeIn:cartLoading'));

        // Get the PackingSlip number from localStorage
        const packingSlip = await this.getPackingSlip();
        if (!packingSlip?.number) return null;

        try {
          // Remove item for associated PackingSlip number and SRNumber
          await PYD.fetchData(this.API_URL, {
            query: PYD.queries.removeOffer,
            variables: { 
              packingSlipNumber: packingSlip.number, 
              offerNumber: SRNumber 
            },
          }, "POST");
      
          // Invalidate cached packing slip so next load refetches
          this._packingSlipPromise = null;
          this.packingSlipData = null;
      
          window.dispatchEvent(new CustomEvent('tradeIn:item-removed', {
            detail: { 
              packingSlipNumber: packingSlip.number,
              item: { SRNumber, productId },
              cart: PYD.state.cart
            },
            bubbles: true,
            composed: true
          }));
          // GTM/dataLayer quirk: we must first clear the previous items object by setting it to null
          // in a separate push. Without this, GTM may not treat the next items array as a fresh list
          // and can keep using the stale items from the last event instead of the updated cart state.
          dataLayer.push({ items: null });
          // Get and update cart state
          return await this.getCart();
        } catch (err) {
          let errorData = { apiUrl: this.API_URL, query: PYD.queries.removeOffer };
          PYD.handleError('Failed to remove item from cart:', err, errorData);
          window.dispatchEvent(new CustomEvent('tradeIn:cartError', {
            detail: { error: err }
          }));
          return null;
        }
      },      
      async getPackingSlip() {
        // Step 1: Check if localStorage has the packingSlipNumber
        const packingSlipNumber = this.getPackingSlipFromStorage();
        if (!packingSlipNumber) return null;
      
        if (this.packingSlipData?.number === packingSlipNumber) {
          return this.packingSlipData;
        }
      
        if (this._packingSlipPromise) {
          return this._packingSlipPromise;
        }
        // Step 2: Validate it via API
        this._packingSlipPromise = (async () => {
          try {
            const res = await PYD.fetchData(this.API_URL, {
              query: PYD.queries.packingSlip,
              variables: { number: packingSlipNumber },
            }, "POST");
      
            const json = await res.json();
            const packingSlip = json?.data?.packingSlip || null;
      
            this.packingSlipData = packingSlip;
            return packingSlip;
          } catch (err) {
            let errorData = {apiUrl: this.API_URL, query: PYD.queries.packingSlip};
            PYD.handleError('Failed to fetch packingSlip:', err, errorData);
            return null;
          } finally {
            this._packingSlipPromise = null;
          }
        })();
      
        return this._packingSlipPromise;
      },
      

      // Save the packing slip number to localStorage
      setPackingSlipToStorage(value) {
        localStorage.setItem('packingSlipNumber', value);
      },

      // Retrieve the packing slip number from localStorage
      getPackingSlipFromStorage() {
        return localStorage.getItem('packingSlipNumber');
      },

      // Remove the packing slip number from localStorage
      deletePackingSlipFromStorage() {
        localStorage.removeItem('packingSlipNumber');
      }
    };

    // Immediately fetch cart on mount
    window.tradeIn.getCart();
  }

  // Immediately execute if DOM is ready, otherwise wait
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      PYD.init();
      initTradeIn();
    });
  } else {
    PYD.init();
    initTradeIn();
  }
})();

class PYDSearchableDropdown extends HTMLElement {
  constructor() {
    super();
    this.options = [];
    this.filteredOptions = [];
    this.isOpen = false;
    this.isRestoringFromUrl = false;
    this.selectedValue = '';
    this.activeOptionIndex = -1;
  }

  connectedCallback() {
    this.cacheElements();
    this.setupAria();
    this.attachListeners();
  }

  cacheElements() {
    this.input = this.querySelector('[data-input]');
    this.icon = this.querySelector('[data-icon]');
    this.spinner = this.querySelector('[data-spinner]');
    this.dropdown = this.querySelector('[dropdown-menu]');
  }

  setupAria() {
    if (!this.input || !this.dropdown) return;
    const selection = this.getAttribute('data-selection') || 'field';
    const counter = (PYDSearchableDropdown._idCounter = (PYDSearchableDropdown._idCounter || 0) + 1);
    const dropdownId = this.dropdown.id || ('pyd-dd-' + selection + '-' + counter);
    this.dropdown.id = dropdownId;
    this.dropdown.setAttribute('role', 'listbox');
    this.input.setAttribute('role', 'combobox');
    this.input.setAttribute('aria-expanded', 'false');
    this.input.setAttribute('aria-haspopup', 'listbox');
    this.input.setAttribute('aria-autocomplete', 'list');
    this.input.setAttribute('aria-controls', dropdownId);
  }

  attachListeners() {
    // Do NOT open dropdown on focus - wait for explicit action (click or Enter)
    this.input?.addEventListener('focus', () => {
      // Do nothing on focus; dropdown stays closed until user acts
    });
    
    this.input?.addEventListener('click', () => {
      this.input.value = '';
      this.showAllOptions();
      this.open();
    });

    // Filter while typing
    this.input?.addEventListener('input', (e) => {
      this.filter(e.target.value);
      this.open();
    });

    // Restore selected value if input is empty on blur
    this.input?.addEventListener('blur', () => {
      setTimeout(() => {
        if (!this.contains(document.activeElement)) {
          if (!this.input.value.trim()) {
            this.input.value = this.selectedValue;
          }
          this.close();
        }
      }, 100);
    });

    // Handle option selection via click
    this.dropdown?.addEventListener('click', (e) => {
      const option = e.target.closest('[data-value]');
      const isHeader = e.target.closest('[data-is-header]');
      const isLink = e.target.closest('[data-is-link]');
      
      if (!option || isHeader || isLink) {
        return;
      }

      this._selectOption(option);
    });

    // Prevent input from losing focus when clicking dropdown options,
    // so the click event fires correctly without blur interference.
    this.dropdown?.addEventListener('mousedown', (e) => {
      e.preventDefault();
    });

    // Close when clicking outside
    document.addEventListener('click', (e) => {
      if (!this.contains(e.target)) this.close();
    });

    // Keyboard navigation
    this.input?.addEventListener('keydown', (e) => {
      const isOpen = this.isOpen;
      const options = this._getSelectableOptions();

      if (e.key === 'Enter') {
        e.preventDefault();
        if (!isOpen) {
          this.input.value = '';
          this.showAllOptions();
          this.open();
        } else if (this.activeOptionIndex >= 0 && options[this.activeOptionIndex]) {
          this._selectOption(options[this.activeOptionIndex]);
        }
      } else if (e.key === 'ArrowDown') {
        e.preventDefault();
        if (!isOpen) {
          this.showAllOptions();
          this.open();
        }
        const newIndex = Math.min(this.activeOptionIndex + 1, options.length - 1);
        this.activeOptionIndex = newIndex;
        this._highlightOption(options, this.activeOptionIndex);
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        if (this.activeOptionIndex > 0) {
          this.activeOptionIndex--;
          this._highlightOption(options, this.activeOptionIndex);
        }
      } else if (e.key === 'Escape') {
        e.preventDefault();
        this.close();
      }
    });
  }

  _getSelectableOptions() {
    return Array.from(this.dropdown?.querySelectorAll('[data-value]') || []);
  }

  _highlightOption(options, index) {
    options.forEach((opt, i) => {
      const isActive = i === index;
      opt.classList.toggle('active', isActive);
      opt.setAttribute('aria-selected', isActive ? 'true' : 'false');
      if (isActive) opt.scrollIntoView({ block: 'nearest' });
    });
    if (index >= 0 && options[index]) {
      this.input?.setAttribute('aria-activedescendant', options[index].id || '');
    } else {
      this.input?.removeAttribute('aria-activedescendant');
    }
  }

  _selectOption(option) {
    const id = option.dataset.value || null;
    const categoryId = option.dataset.categoryId || null;
    const categoryName = option.dataset.categoryName || null;
    const name = option.textContent.trim();
    
    this.selectedValue = name;
    this.setValue(name);
    this.close();

    this.dispatchEvent(new CustomEvent('pyd:form-changed', {
      detail: { 
        id,
        name,
        categoryId,
        categoryName,
        selection: this.getAttribute('data-selection'),
        stepName: this.getAttribute('data-selection')
      },
      bubbles: true,
      composed: true
    }));
  }


  toggle() {
    if (this.hasAttribute('disabled')) return;
    this.isOpen ? this.close() : this.open();
  }

  open() {
    if (this.hasAttribute('disabled')) return;
    this.isOpen = true;
    this.activeOptionIndex = -1;
    this.dropdown?.removeAttribute('hidden');
    this.input?.setAttribute('aria-expanded', 'true');
  }

  close() {
    this.isOpen = false;
    this.activeOptionIndex = -1;
    this.dropdown?.setAttribute('hidden', '');
    this.input?.setAttribute('aria-expanded', 'false');
    this.input?.removeAttribute('aria-activedescendant');
    this.dropdown?.querySelectorAll('[data-value]').forEach(opt => opt.classList.remove('active'));
  }

  enable() {
    this.input?.removeAttribute('disabled');
  }

  disable() {
    this.input?.setAttribute('disabled', '');
    this.close();
  }

  hide() {
    this.setAttribute('hidden', '');
  }

  show() {
    this.removeAttribute('hidden');
  }

  setValue(label) {
    if (this.input) this.input.value = label;
  }

  reset() {
    this.options = [];
    this.filteredOptions = [];
    this.selectedValue = '';
    if (this.input) this.input.value = '';
    this.renderOptions();
    this.disable();
  }

  setLoading(loading) {
    if (loading) {
      this.spinner?.removeAttribute('hidden');
      this.icon?.setAttribute('hidden', '');
    } else {
      this.spinner?.setAttribute('hidden', '');
      this.icon?.removeAttribute('hidden');
    }
  }

  setOptions(options) {
    this.options = options;
    this.filteredOptions = options;
    this.renderOptions();
    this.enable();
  }

  showAllOptions() {
    this.filteredOptions = this.options;
    this.renderOptions();
  }

  filter(query) {
    const q = query.trim().toLowerCase();
    this.filteredOptions = q
      ? this.options.filter(opt =>
          !opt.isHeader &&
          opt.name.toLowerCase().includes(q)
        )
      : this.options;
    this.renderOptions();
  }

  getItemSeoLink(selection, handle) {
    const order = ['brand', 'series', 'model'];

    // Get base URL without query params
    const baseUrl = `${window.location.origin}${window.location.pathname}`;

    const params = new URLSearchParams();
    const selectionIndex = order.indexOf(selection);

    if (selectionIndex === -1) return baseUrl;

    // Add all previous selections from PYD.state
    for (let i = 0; i < selectionIndex; i++) {
      const key = order[i];
      const value = PYD.state?.[key]?.handle;
      if (value) {
        params.set(key, value);
      }
    }

    // Add current selection with provided handle
    if (handle) {
      params.set(selection, handle);
    }

    const query = params.toString();
    return query ? `${baseUrl}?${query}` : baseUrl;
  }

  renderOptions() {
    if (!this.dropdown) return;
    const selection = this.dropdown.getAttribute('data-menu-selection') || '';

    const options = this.filteredOptions.length
      ? this.filteredOptions
      : [{ name: 'No results', id: '', isHeader: true }];

    const mappedOptions = options
      .map(opt => {
        if (opt.isHeader) {
          if (opt.name === "Cell Phone") {
            const cellPhoneLabel = "CELL PHONE";
            return `<div class="searchable-dropdown__menu-header searchable-dropdown__menu-header--small pyd-header pyd-dropdown-header device-subtitle" data-is-header="true" aria-hidden="true">${cellPhoneLabel}</div>`;
          } else if (opt.name === "Tablet" || opt.name === "MP3 Player") {
            return `<div class="searchable-dropdown__menu-header pyd-header pyd-dropdown-header device-subtitle" data-is-header="true" aria-hidden="true">${opt.name}</div>`;
           }
          else {
            return `<div class="searchable-dropdown__menu-header pyd-header pyd-dropdown-header" data-is-header="true" aria-hidden="true">${opt.name}</div>`;
          }
        }

        if (opt.isLink) {
          return `<a data-tracking-id="${opt.dataTrackingId}" href="${opt.url}" target="_blank" rel="noopener noreferrer" class="searchable-dropdown__menu-item searchable-dropdown__menu-item--link" data-is-link="true">
            ${opt.name}
            <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <path d="M9.5 1.25C9.5 0.84375 9.8125 0.5 10.25 0.5H15.2188C15.6562 0.5 15.9688 0.84375 15.9688 1.25V6.25C15.9688 6.6875 15.6562 7 15.2188 7C14.8125 7 14.4688 6.6875 14.4688 6.25V3.0625L7.5 10.0312C7.21875 10.3438 6.75 10.3438 6.46875 10.0312C6.15625 9.75 6.15625 9.28125 6.46875 8.96875L13.4375 2H10.25C9.8125 2 9.5 1.6875 9.5 1.25ZM2.25 1.5H6.25C6.65625 1.5 7 1.84375 7 2.25C7 2.6875 6.65625 3 6.25 3H2.25C1.8125 3 1.5 3.34375 1.5 3.75V14.25C1.5 14.6875 1.8125 15 2.25 15H12.75C13.1562 15 13.5 14.6875 13.5 14.25V10.25C13.5 9.84375 13.8125 9.5 14.25 9.5C14.6562 9.5 15 9.84375 15 10.25V14.25C15 15.5 13.9688 16.5 12.75 16.5H2.25C1 16.5 0 15.5 0 14.25V3.75C0 2.53125 1 1.5 2.25 1.5Z" fill="currentColor"/>
            </svg>
          </a>`;
        }
  
        const { id, name, categoryId, categoryName, tracking, handle } = opt;
        const selection = this.getAttribute('data-selection') || 'item';
        const optId = `pyd-opt-${selection}-${id || i}`;
  
        // Build attributes if any
        const attrs = [
          `id="${optId}"`,
          `data-value="${id}"`,
          `role="option"`,
          `aria-selected="false"`,
          categoryId ? `data-category-id="${categoryId}"` : '',
          categoryName ? `data-category-name="${categoryName}"` : '',
          tracking ? `data-tracking-id="${tracking}"` : '',
          handle ? `data-handle="${handle}"` : '',
        ]
        .filter(Boolean)
        .join(' ');

        const seoLink = this.getItemSeoLink(selection, handle);

        return `<div class="searchable-dropdown__menu-item" ${attrs}>
          <a href="${seoLink}" onclick="event.preventDefault();">${name}</a>
        </div>`;
      });

    this.dropdown.innerHTML = mappedOptions.join('');
  }
}
customElements.define('pyd-searchable-dropdown', PYDSearchableDropdown);

class PYDForm extends HTMLElement {
  constructor() {
    super();
    this.apiUrl = PYD.config.GRAPHQL_URL;
    this.props = this.parseProps();
  }

  parseProps() {
    try {
      const propsAttr = this.getAttribute('data-props');
      return propsAttr ? JSON.parse(propsAttr) : {};
    } catch (error) {
      console.error('Error parsing data-props:', error);
      return {};
    }
  }

  connectedCallback() {
    this.cacheFormFields();
    this.disableQuestions();
    this.setupDownstream();
    this.attachEventListeners();
    this.init();
  }

  cacheFormFields() {
    this.dropdowns = {
      brand: this.querySelector('[data-selection="brand"]'),
      series: this.querySelector('[data-selection="series"]'),
      model: this.querySelector('[data-selection="model"]'),
      storage: this.querySelector('[data-selection="storage"]'),
      carrier: this.querySelector('[data-selection="carrier"]')
    };
    
    this.conditionQuestions = {
      q1: this.querySelector('[data-condition="q1"]'),
      q2: this.querySelector('[data-condition="q2"]'),
      q3: this.querySelector('[data-condition="q3"]')
    };

    this.submit = this.querySelector('button[data-submit]')
  }

  // Handle form changes and update state, URL, and downstream options
  setupDownstream() {
    this.addEventListener('pyd:form-changed', async (e) => {
      const { id, name, selection, value, categoryId, categoryName } = e.detail ?? {};
      e.asyncResult = (async () => {
        try {
          
          if (selection === 'brand') {
            // Update brand state, reset dependent dropdowns, fetch devices
            const handle = PYD.handleize(name);
            PYD.state = { 
              ...PYD.state, 
              brand: { id, name, handle },
              series: null,
              model: null,
              category: null,
              storage: null,
              carrier: null,
              q1: null,
              q2: null,
              q3: null,
              payout: [],
            };
            this.resetDownstream(['series', 'model', 'storage', 'carrier']);
            this.disableQuestions();
            this.disableSubmit();
            
            // Single batched URL update
            PYD.updateUrlParams({
              brand: handle,
              series: null,
              model: null,
              storage: null,
              carrier: null,
              q1: null,
              q2: null,
              q3: null
            });
            // Update page title, page meta description, and canonical url based on selected brand
            if (window.PYD_META_TAGS_ENABLED) {
              PYD.updateMetaTags({
                title: `Sell Your ${PYD.capitalize(handle)} ${handle == 'apple' ? 'iPhone for Cash or Estimate the Trade In Value' : `Phones, Trade In Your ${PYD.capitalize(handle)} Phones for Cash`} – EcoATM`,
                description: `Safely sell your ${PYD.capitalize(handle)} ${handle == 'apple' ? 'iPhone, iPad or iPod' : 'phone'}  at an ecoATM kiosk near you! Get cash immediately for your old devices!`,
                canonical: `${window.location.origin}${window.location.pathname}?ti-screen=pyd&brand=${handle}`
              });
            }
            
            await this.loadDevices();

          } else if (selection === 'series') {
            // 1. Fetch device data from API for selected device
            const { brand } = PYD.state;
            const deviceResponse = await PYD.fetchData(this.apiUrl, {
              query: PYD.queries.models,
              variables: { brandId: brand.id, seriesId: id, categoryId: categoryId },
            }, "GET");

            let handle;
            const deviceData = await deviceResponse.json();

            // 2. Safely extract the first model from the API response and add handle property
            const deviceArr = deviceData?.data?.models || [];

            if(deviceArr.length == 1) {
              handle = PYD.handleize(deviceArr[0].name);
              const device = deviceArr.length > 0
              ? { 
                  ...deviceArr[0], 
                  handle: PYD.handleize(deviceArr[0].name) 
                }
              : null;

              PYD.state = { 
                ...PYD.state, 
                series: { id, name, handle },
                model: { id: null, name: null, handle: null },
                category: { id: categoryId, name: categoryName, handle: PYD.handleize(categoryName) },
                storage: null,
                carrier: null,
                q1: null,
                q2: null,
                q3: null
              };

            } else {
              handle = PYD.handleize(name);
              PYD.state = { 
                ...PYD.state, 
                series: { id, name, handle },
                model: { id: null, name: null, handle: null },
                category: { id: categoryId, name: categoryName, handle: PYD.handleize(categoryName) },
                storage: null,
                carrier: null,
                q1: null,
                q2: null,
                q3: null
              };
            }

            this.resetDownstream(['model', 'storage', 'carrier']);
            this.disableQuestions();
            this.disableSubmit();
            
            // Single batched URL update
            PYD.updateUrlParams({
              series: handle,
              model: null,
              storage: null,
              carrier: null,
              q1: null,
              q2: null,
              q3: null
            });
            // Update page title, page meta description, and canonical url based on selected device
            if (window.PYD_META_TAGS_ENABLED) {
              PYD.updateMetaTags({
                title: `Sell Your ${PYD.capitalize(brand.handle)} ${PYD.capitalize(name)}, Trade In Your ${PYD.capitalize(brand.handle)} ${PYD.capitalize(name)} for Cash – EcoATM `,
                description: `Get instant cash for your ${PYD.capitalize(brand.handle)} ${PYD.capitalize(name)} at an ecoATM kiosk near you. Fast, secure, and available nationwide.`,
                canonical: `${window.location.origin}${window.location.pathname}?ti-screen=pyd&brand=${brand.handle}&series=${handle}`
              });
            }
            
            // Show Model if multiple; else show Storage
            const models = await this.loadModels(deviceData);
            if(models.length <= 1) await this.loadStorage();
  
          } else if (selection === 'model') {
            // Update model, reset downstream, fetch storage
            const handle = PYD.handleize(name);
            PYD.state = { 
              ...PYD.state, 
              model: { id, name, handle },
              storage: null,
              carrier: null,
              q1: null,
              q2: null,
              q3: null
            };
            this.resetDownstream(['storage', 'carrier']);
            this.disableQuestions();
            this.disableSubmit();
            
            // Single batched URL update
            PYD.updateUrlParams({
              model: handle,
              storage: null,
              carrier: null,
              q1: null,
              q2: null,
              q3: null
            });
            // Update page title, page meta description, and canonical url based on selected device
            if (window.PYD_META_TAGS_ENABLED) {
              PYD.updateMetaTags({
                title: `Sell Your ${PYD.capitalize(PYD.state.brand.handle)} ${PYD.capitalize(handle)}, Trade In Your ${PYD.capitalize(PYD.state.brand.handle)} ${PYD.capitalize(handle)} for Cash – EcoATM `,
                description: `Get instant cash for your ${PYD.capitalize(PYD.state.brand.handle)} ${PYD.capitalize(handle)} at an ecoATM kiosk near you. Fast, secure, and available nationwide.`,
                canonical: `${window.location.origin}${window.location.pathname}?ti-screen=pyd&brand=${PYD.state.brand.handle}&series=${PYD.state.series.handle}&model=${handle}`
              });
            }
            
            await this.loadStorage();
          
          } else if (selection === 'storage') {
            // Update storage, reset downstream, fetch carriers
            const handle = PYD.handleize(name);
            PYD.state = { 
              ...PYD.state,
              storage: { id, name, handle },
              carrier: null,
              q1: null,
              q2: null,
              q3: null
            };
            this.resetDownstream(['carrier']);
            this.disableQuestions();
            this.disableSubmit();
            
            // Single batched URL update
            PYD.updateUrlParams({
              storage: handle,
              carrier: null,
              q1: null,
              q2: null,
              q3: null
            });
            
            await this.loadCarriers();

          } else if (selection === 'carrier') {
            // Update carrier and enable first condition question
            const handle = PYD.handleize(name);
            PYD.state = { 
              ...PYD.state,
              carrier: { id, name, handle },
              q1: null,
              q2: null,
              q3: null
            };
            this.disableQuestions();
            this.disableSubmit();
            
            // Single batched URL update
            PYD.updateUrlParams({
              carrier: handle,
              q1: null,
              q2: null,
              q3: null
            });
            
            this.enableQuestion('q1');

          } else if (selection === 'q1') {
            // Update q1 state, enable next condition question
            PYD.state = { ...PYD.state, q1: { id: value, name: 'powerUp' } };
            this.disableSubmit();
            PYD.updateUrlParam('q1', value);
            this.enableQuestion('q2');

          } else if (selection === 'q2') {
            // Update q2 state, enable next condition question
            PYD.state = { ...PYD.state, q2: { id: value, name: 'lcdOk' } };
            this.disableSubmit();
            PYD.updateUrlParam('q2', value);
            this.enableQuestion('q3');

          } else if (selection === 'q3') {
            // Update q3 state and trigger form completion
            PYD.state = { ...PYD.state, q3: { id: value, name: 'cracks' } };
            PYD.updateUrlParam('q3', value);
            this.enableSubmit();
          }

          // Dispatch event AFTER all async operations complete
          window.dispatchEvent(new CustomEvent('pyd:form-change-completed', {
            detail: { ...PYD.state, stepName: selection },
            bubbles: true,
            composed: true
          }));
        } catch (error) {
          let errorData = { apiUrl: this.apiUrl, query: PYD.state };
          PYD.handleError(`Failed to process ${selection}`, error, errorData);
        }
      })();
    });
  }

  attachEventListeners() {
    // Condition question listeners
    Object.entries(this.conditionQuestions).forEach(([key, question]) => {
      if (!question) return;
  
      const radios = question.querySelectorAll('input[type="radio"]');
      radios.forEach(radio => {
        radio.addEventListener('change', () => {
          this.dispatchEvent(new CustomEvent('pyd:form-changed', {
            detail: { selection: key, value: radio.value, stepName: "condition" },
            bubbles: true
          }));
        });
        radio.addEventListener('keydown', (e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            radio.checked = true;
            radio.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      });

      const labels = question.querySelectorAll('label.pyd-form__question-card');
      labels.forEach(label => {
        label.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            label.click();
          }
        });
      });
    });

    // Attach submit button listener for price estimate
    this.submit.addEventListener('click', (e) => {
      e.preventDefault();
      this.handleFormSubmit();
    });
  }

  // Initialize the brand dropdown and auto-select from URL
  async init() {
    try {
      PYD.deActivateErrorCard();
      if (PYD.state?.currentScreen?.toLowerCase().includes('pyd')) {

        // Show loading indicator while fetching brands
        this.dropdowns.brand.setLoading(true);

        // 1. Fetch all brands from API
        const channels = this.props.channel ? [this.props.channel] : null;
        const brandResponse = await PYD.fetchData(this.apiUrl, {
          query: PYD.queries.brands,
          variables: channels ? { channels } : {}
        }, "GET");
        const brandData = await brandResponse.json();

        // 2. Safely extract brand list from API response and add handle property
        const brands = (brandData?.data?.brands || []).map(brand => ({
          ...brand,
          handle: PYD.handleize(brand.name)
        }));

        // 3. Define top brands to prioritize in the dropdown
        const topBrandNames = [
          'Apple', 'Samsung', 'Google', 'HTC', 'LG', 'Motorola', 'Nokia'
        ];

        // 4. Create a lookup map of all brands (case-insensitive)
        const brandMap = new Map(
          brands.map(b => [b.name.toLowerCase(), b])
        );

        // 5. Preserve top brand order while filtering out missing brands
        const topBrands = topBrandNames
          .map(name => brandMap.get(name.toLowerCase()))
          .filter(Boolean);

        // 6. Collect remaining brands as "Other"
        const otherBrands = brands.filter(
          b => !topBrandNames.some(name => b.name.toLowerCase() === name.toLowerCase())
        );

        // 7. Combine into grouped dropdown list with headers
        const groupedBrands = [
          { id: '', name: 'Top Brands', isHeader: true },
          ...topBrands,
          ...(otherBrands.length ? [{ id: '', name: 'Other Brands', isHeader: true }, ...otherBrands] : [])
        ];

        // 8. Update dropdown options in the UI
        this.dropdowns.brand.setOptions(groupedBrands);

        // 9. Auto-select values from URL parameters (if available)
        this.autoSelectFromUrl();

        // 10. Dispatch event pyd:form-initialized
        window.dispatchEvent(new CustomEvent('pyd:form-initialized', { detail: {}, bubbles: true }));
        
        // 11. Disable the error card
        PYD.deActivateErrorCard();
      }
      //12. cart
      PYD.cartPromise = null;
    } catch (error) {
      PYD.activateErrorCard();
      let errorData = {apiUrl: this.apiUrl, query: PYD.queries.brands};
      PYD.handleError('Failed to load brands', error, errorData);
    } finally {
      this.dropdowns.brand.setLoading(false);
    }
  }

  // Load devices for selected brand
  async loadDevices() {
    const { brand } = PYD.state;

    try {
      // Show loading indicator while fetching devices
      this.dropdowns.series.setLoading(true);

      // 1. Fetch all categories from API
      const channels = this.props.channel ? [this.props.channel] : null;
      const categoryResponse = await PYD.fetchData(this.apiUrl, {
        query: PYD.queries.categories,
        variables: channels ? { channels } : {}
      }, "GET");
      const categoryData = await categoryResponse.json();

      // 2. Safely extract categories list from API response and add handle property
      const categories = (categoryData?.data?.categories|| []).map(category => ({
        ...category,
        name: this.props.deviceCategories[PYD.handleize(category.name)] ?? category.name,
        handle: PYD.handleize(category.name)
      }));

      // 3. Fetch devices for each category and combine them
      const allDevices = (
        await Promise.all(
          categories.map(async ({ id, name }) => {
            const variables = { 
              brandId: brand.id, 
              categoryId: id
            };
            
            // Only add channels if it exists
            if (channels) {
              variables.channels = channels;
            }

            const res = await PYD.fetchData(this.apiUrl, {
              query: PYD.queries.series,
              variables
            }, "GET");

            const { data } = await res.json();
            const devices = data.series || [];

            // Group devices under category headers
            return devices.length
              ? [
                  { id, name, isHeader: true },
                  ...devices.map(d => ({
                    id: d.id,
                    name: d.name,
                    categoryId: id,
                    categoryName: name,
                    handle: PYD.handleize(d.name),
                  })),
                ]
              : [];
          })
        )
      ).flat();

      // 4. Add help link if available
      if (this.props.deviceLinkText && this.props.deviceLinkUrl) {
        allDevices.unshift({
          id: null,
          name: this.props.deviceLinkText,
          url: this.props.deviceLinkUrl,
          isLink: true,
          dataTrackingId: "how-to-find-device"
        });
      }
      // 4a. Add "Search for & select a device" header at the very top
      allDevices.unshift({ id: '', name: 'Search for & select a device', isHeader: true });

      // 5. Update device dropdown options
      this.dropdowns.series.setOptions(allDevices);
    } catch (error) {
      PYD.activateErrorCard();
      let errorData = {apiUrl: this.apiUrl, query: PYD.queries.categories};
      PYD.handleError('Failed to load devices:', error, errorData);
    } finally {
      this.dropdowns.series.setLoading(false);
    }
  }

  // Load models for selected brand, device, and category
  async loadModels(prefetchedData = null) {
    const { brand, series, category } = PYD.state;

    try {
      this.dropdowns.model.setLoading(true);
      
      // 1. Fetch models for selected brand, device, and category, 
      // only if there is no earlier model response
      let modelData;
      if (prefetchedData) {
        modelData = prefetchedData;
      } else {
        const modelResponse = await PYD.fetchData(this.apiUrl, {
          query: PYD.queries.models,
          variables: { brandId: brand.id, seriesId: series.id, categoryId: category.id },
        }, "GET");

        modelData = await modelResponse.json();
      }

      // 2. Safely extract categories list from API response and add handle property
      const models = (modelData?.data?.models || []).map(model => ({
        ...model,
        handle: PYD.handleize(model.name)
      }));

      // EDGE CASE → Single Model returned, update state directly
      // This skips the model dropdown entirely but ensures state is set
      if(models.length == 1) {
        const model = models[0];

        PYD.state = { 
          ...PYD.state, 
          model: { id: model.id, name: model.name, handle: model.handle },
        };
      }

      // 3. Show model dropdown only if there is more than one option
      if(models.length > 1) {
        this.dropdowns.model.show();
        this.dropdowns.model.setOptions(models);
      }

      return models;
    } catch (error) {
      PYD.activateErrorCard();
      let errorData = {apiUrl: this.apiUrl, query: PYD.queries.models};
      PYD.handleError('Failed to load model', error, errorData);
      return [];
    } finally {
      this.dropdowns.model.setLoading(false);
    }
  }

  // Load storage options for selected device
  async loadStorage() {
    const { brand, model, series } = PYD.state;

    try {
      this.dropdowns.storage.setLoading(true);

      // 1. Fetch storage options for selected brand and device
      const storageResponse = await PYD.fetchData(this.apiUrl, {
        query: PYD.queries.storage,
        variables: { brandId: brand.id, seriesId: series.id, modelName: model.name },
      }, "GET");
      const storageData = await storageResponse.json();

      // 2. Safely extract categories list from API response and add handle property
      let storages = (storageData?.data?.storageOptions || []).map(storage => ({
        ...storage,
        handle: PYD.handleize(storage.name)
      }));
      
      // 3. EDGE CASE → No storages returned
      if (!storages.length) {

        // Disable storage and carrier dropdowns entirely
        this.dropdowns.storage.disable();
        this.dropdowns.carrier.disable();
  
        // Reset any existing storage state
        PYD.state = { ...PYD.state, 
          storage: { id: null, name: null, handle: null },
          carrier: { id: null, name: null, handle: null }
        };
  
        // Skip ahead to q1
        this.enableQuestion('q1');
        return;
      }

      // 4. Add tracking property to each storage object
      storages.forEach(storage => {
        storage.tracking = `capacity-${storage.name}-button`;
      });

      // 5. Add "Select the storage" header at the top
      storages.unshift({ id: '', name: 'Select the storage', isHeader: true });

      // 6. Add help link at the bottom if available
      if (this.props.storageLinkText && this.props.storageLinkUrl) {
        storages.push({
          id: null,
          name: this.props.storageLinkText,
          url: this.props.storageLinkUrl,
          isLink: true,
          dataTrackingId: "how-to-find-storage"
        });
      }

      // 7. Update storage dropdown options
      this.dropdowns.storage.setOptions(storages);
      return storages;
    } catch (error) {
      PYD.activateErrorCard();
      let errorData = { apiUrl: this.apiUrl, query: PYD.queries.storage };
      PYD.handleError('Failed to load storage', error, errorData);
    } finally {
      this.dropdowns.storage.setLoading(false);
    }
  }

  // Load carrier options
  async loadCarriers() {
    try {
      this.dropdowns.carrier.setLoading(true);
      const categoryHandle = PYD.state?.category?.handle;
      const showCarrierList = this.props?.showCarrierList !== false;
  
      // 1. Fetch carrier options
      const carrierResponse = await PYD.fetchData(this.apiUrl, {
        query: PYD.queries.carriers,
      }, "GET");
      const carrierData = await carrierResponse.json();
  
      // 2. Safely extract categories list from API response and add handle property
      let carriers = (carrierData?.data?.carriers || []).map(carrier => ({
        ...carrier,
        handle: PYD.handleize(carrier.name)
      }));
  
      // 3. Category is "MP3 player" OR no carriers returned → skip carrier entirely
      if (categoryHandle === 'mp3-player' || !carriers.length) {
        this.dropdowns.carrier.disable();
  
        PYD.state = { 
          ...PYD.state, 
          carrier: { id: null, name: null, handle: null } 
        };
  
        this.enableQuestion('q1');
        return;
      }
  
      // 4. Always filter: Tablet → ONLY show WiFi carriers; others → HIDE WiFi carriers
      if (categoryHandle === 'tablet') {
        carriers = carriers.filter(c =>
          c.id?.toLowerCase().includes('wifi')
        );
      } else {
        carriers = carriers.filter(c =>
          !c.id?.toLowerCase().includes('wifi')
        );
          // 5. If toggle is off, replace carrier list with device unlock status options
        if (!showCarrierList) {
          const unlockedCarrier = carriers.find(c => c.handle === 'unlocked');
          const otherCarrier = carriers.find(c => c.handle === 'other');
          const unlockedOption = unlockedCarrier
            ? {
                id: unlockedCarrier.id,
                name: unlockedCarrier.name,
                handle: unlockedCarrier.handle
              }
            : {
                id: 'unlocked',
                name: 'Unlocked',
                handle: 'unlocked'
              };
          carriers = [
            unlockedOption,
            {
              id: otherCarrier?.id || 'other',
              name: 'Locked to a carrier',
              handle: LOCKED_CARRIER_HANDLE
            }
          ];
        }
      }

      
  
      // 6. Add tracking property to each carrier object
      carriers.forEach(carrier => {
        carrier.tracking = `capacity-${carrier.name}-button`;
      });

      // 7. Add dropdown header at the top
      carriers.unshift({
        id: '',
        name: showCarrierList ? 'Select the carrier' : (categoryHandle === 'tablet' ? 'Does your tablet connect to cellular' : 'Is your device unlocked?'),
        isHeader: true
      });

      // 8. Add help link at the bottom if available
      if (this.props.carrierLinkText && this.props.carrierLinkUrl) {
        const carrierUrl = (categoryHandle === 'tablet' && this.props.carrierLinkUrlTablet)
          ? this.props.carrierLinkUrlTablet
          : this.props.carrierLinkUrl;
        carriers.push({
          id: null,
          name: this.props.carrierLinkText,
          url: carrierUrl,
          isLink: true,
          dataTrackingId: "how-to-find-carrier"
        });
      }
  
      // 9. Update dropdown
      this.dropdowns.carrier.setOptions(carriers);
      return carriers;
    } catch (error) {
      PYD.activateErrorCard();
      let errorData = {apiUrl: this.apiUrl, query: PYD.queries.carriers};
      PYD.handleError('Failed to load carrier', error, errorData);
    } finally {
      this.dropdowns.carrier.setLoading(false);
    }
  }

  // Populate dropdowns based on URL parameters 
  async autoSelectFromUrl() {
    this.formSubmitting(true);

    const urlParams = PYD.getUrlParams(['brand','series','model','storage','carrier','q1','q2','q3']);
    const { brand, series, model, storage, carrier } = urlParams;
  
    const selectDropdown = async (dropdown, value, selection) => {
      if (!value || !dropdown) return null;
  
      // 1. Find the matching dropdown option
      const dropdownOptions = Array.from(dropdown.querySelectorAll('[data-value]'));
      let matchedDropdown = dropdownOptions.find(item => item.getAttribute('data-handle')?.trim() === value);
      const shouldMapLegacyCarrierToLocked =
        selection === 'carrier' &&
        this.props?.showCarrierList === false &&
        value !== 'unlocked';
      if (!matchedDropdown && shouldMapLegacyCarrierToLocked) {
        matchedDropdown = dropdownOptions.find(item => item.getAttribute('data-handle')?.trim() === LOCKED_CARRIER_HANDLE);
      }
      if (!matchedDropdown) return null;
  
      // 2. Extract option data
      const id = matchedDropdown.dataset.value;
      const name = matchedDropdown.textContent.trim();
      const categoryId = matchedDropdown.dataset.categoryId || null;
      const categoryName = matchedDropdown.dataset.categoryName || null;

      // 3. Update dropdown UI to show selected value
      dropdown.setValue(name);
  
      // 4. Dispatch a custom event and wait for any listeners to handle downstream logic
      const wait = this.waitForEventResult(this, 'pyd:form-changed');
      this.dispatchEvent(new CustomEvent('pyd:form-changed', {
        detail: {
          id,
          name,
          selection,
          categoryId,
          categoryName,
          stepName: selection
        },
        bubbles: true
      }));
      await wait;
  
      return { id, name };
    };

    // 1. Sequentially populate dropdowns based on URL parameters 
    // (brand, series, model, storage, carrier)
    const brandData = await selectDropdown(this.dropdowns.brand, brand, 'brand');
    const seriesData = brandData ? await selectDropdown(this.dropdowns.series, series, 'series') : null;
    const deviceData = seriesData;
    const modelData = seriesData ? await selectDropdown(this.dropdowns.model, model, 'model') : null;
    const storageData = modelData || seriesData ? await selectDropdown(this.dropdowns.storage, storage, 'storage') : null;
    storageData ? await selectDropdown(this.dropdowns.carrier, carrier, 'carrier') : null;
  
    this.formSubmitting(false);

    // 2. Automatically select condition radio buttons 
    // If brand wasn't resolved from URL, leave form ready for manual selection —
    // brand dropdown is already re-enabled by formSubmitting(false), conditions stay locked.
    // Matches legacy PYD behavior: user sees active brand dropdown and can start the flow.
    if (brandData === null) {
      this.disableQuestions();
      this.disableSubmit();
      return;
    }

    // 2. Automatically select condition radio buttons
    // (q1: powerOn, q2: functional, q3:cosmetic)
    let allSelected = true;
    ['q1', 'q2', 'q3'].forEach(key => {
      const value = urlParams[key];
      if (!value) {
        allSelected = false;
        return;
      }

      // 2.1 Find the question container for this condition
      const question = this.conditionQuestions[key];
      if (!question) {
        allSelected = false;
        return;
      }

      // 2.2 Find the specific radio input matching the URL value
      const radio = question.querySelector(`input[type="radio"][value="${value}"]`);
      if (!radio) {
        allSelected = false;
        return;
      }

      // 2.3 Check the radio button and trigger the 'pyd:form-changed' event
      radio.checked = true;
      this.dispatchEvent(new CustomEvent('pyd:form-changed', {
        detail: { selection: key, value , stepName: key },
        bubbles: true
      }));
    });

    // 3. Auto-submit the form only if all questions are selected AND brand+device state is valid
    if (allSelected && brandData !== null && deviceData !== null) {
      this.handleFormSubmit();
    }
  }

  // Waits for a custom event and resolves its async result (if any)
  waitForEventResult(target, eventName) {
    return new Promise(resolve => {
      const handler = async (e) => {
        target.removeEventListener(eventName, handler);
        resolve(e.asyncResult instanceof Promise ? await e.asyncResult : e.asyncResult);
      };
      target.addEventListener(eventName, handler);
    });
  }

  // Reset specified downstream dropdowns - just resets UI
  resetDownstream(keys) {
    keys.forEach(key => {
      const dropdown = this.dropdowns[key];
      dropdown?.reset();
      if (key === 'model') dropdown?.hide();
    });
  }

  // Disable all condition questions and their radio buttons
  disableQuestions() {
    Object.values(this.conditionQuestions).forEach(question => {
      if (!question) return;
      question.setAttribute('disabled', '');
      question.querySelectorAll('input[type="radio"]').forEach(input => {
        input.checked = false;
        input.disabled = true;
        input.tabIndex = -1;
      });
      question.querySelectorAll('label.pyd-form__question-card').forEach(label => {
        label.tabIndex = -1;
      });
    });
  }

  // Enable a specific condition question and its radios
  enableQuestion(key) {
    const section = this.conditionQuestions[key];
    if (!section) return;
    section.removeAttribute('disabled');
    section.querySelectorAll('input[type="radio"]').forEach(input => {
      input.disabled = false;
      input.tabIndex = -1;
    });
    section.querySelectorAll('label.pyd-form__question-card').forEach(label => {
      label.tabIndex = 0;
    });
  }

  // Enable the form submit button
  enableSubmit() {
    this.submit.removeAttribute('disabled');
  }

  // Disable the submit button if any condition question is disabled
  disableSubmit() {
    const anyDisabled = Object.values(this.conditionQuestions)
      .some(q => q?.hasAttribute('disabled'));

    this.submit.toggleAttribute('disabled', anyDisabled);
  }

  // Toggle loading state when submitting
  formSubmitting(submitting = false) {
    this.classList.toggle('submitting', submitting);
    this.submit.classList.toggle('loading', submitting);

    if (submitting) {
      this.submit.toggleAttribute('disabled', true);
      // Disable all dropdowns while submitting to prevent changes
      Object.values(this.dropdowns || {}).forEach(dropdown => {
        if (typeof dropdown?.disable === 'function') {
          dropdown.disable();
        }
      });
    } else {
      // Re-enable only dropdowns that have options loaded to preserve the
      // correct cascade state (e.g. downstream dropdowns without options stay disabled)
      Object.values(this.dropdowns || {}).forEach(dropdown => {
        if (typeof dropdown?.enable === 'function' && dropdown.options?.length > 0) {
          dropdown.enable();
        }
      });
      // Restore correct submit button state based on condition questions
      this.disableSubmit();
    }
  }

  // Submit Form, get price estimate
  async handleFormSubmit() {
    this.formSubmitting(true);

    try {
      document.querySelector('.offer-screen.device-error')?.classList.add('hidden');
      await PYD.getPriceEstimate();
      this.handleFormComplete();
    } catch (error) {
      PYD.activateErrorCard();
      let errorData = {apiUrl: this.apiUrl, query: PYD.state};
      PYD.handleError('Failed to submit form', error, errorData);
    } finally {
      this.formSubmitting(false);
      this.submit.toggleAttribute('disabled', true);
    }
  }

  // Dispatch form-complete event with current form state
  handleFormComplete() {
    const { brand, series, model, category, storage, carrier, payout, q1, q2, q3 } = PYD.state;

    // This can be avoided if API responses with offerV3 namespace with channelName
    const offerList = payout?.offerV3 ?? [];

    const mailInEntry = offerList.find(entry => entry.channel === "TRADE_IN") || null;
    const kioskEntry  = offerList.find(entry => entry.channel === "WEB") || null;

    // Compute mail-in and kiosk prices directly
    const mailInPayout = mailInEntry?.amount ?? null;
    const baseKioskPayout = kioskEntry?.amount ?? null;

    PYD.clearSessionStorage('pyd');
    PYD.clearSessionStorage('price_your_device');

    PYD.setSessionStorage('pyd', {
      carrierName:
        carrier?.handle === LOCKED_CARRIER_HANDLE ? 'Other' : (carrier?.name ?? null),
      brandId: brand?.id ?? null,
      brandName: brand?.name ?? null,
      carrierId: carrier?.id ?? null,
      categoryId: category?.id ?? null,
      categoryName: category?.name ?? null,
      cracks: q3?.id ?? null,
      deviceId: payout?.deviceId,
      lcdOk: q2?.id ?? null,
      modelId: model?.id ?? null,
      modelName: model?.name ?? null,
      productId: payout?.pid ?? null,
      offerId: payout?.offerId ?? null,
      offerPriceMailIn: mailInPayout ?? null,
      offerPrice: baseKioskPayout ?? null,
      offerState: payout?.offerState ?? null,
      promoPrice: payout?.promotion?.promoPrice ?? 0,
      powerUp: q1?.id ?? null,
      seriesHandle: model?.handle || series?.handle,
      seriesId: model?.id || series?.id,
      seriesName: model?.name || series?.name,
      storageHandle: storage?.handle ?? null,
      storageId: storage?.id ?? null,
      storageOption: storage?.name ?? null,
    });

    // RECOMMENDED to USE: New sessionStorage entry match exact data structure as PYD.state
    PYD.setSessionStorage('price_your_device', PYD.state);

    PYD.setDeviceInfo();
  }
}
customElements.define('pyd-form', PYDForm);

class PYDModal extends HTMLElement {
  constructor() {
    super();
    this.backdrop = null;
    this.dialog = null;
    this.triggerElement = null;
    this.closeHandler = this.closeHandler.bind(this);
    this.outsideClickHandler = this.outsideClickHandler.bind(this);
    this.keydownHandler = this.keydownHandler.bind(this);
  }

  connectedCallback() {
    const id = this.dataset.modalId;
    if (!id) return;

    // Attach trigger listeners
    document.querySelectorAll(`[data-modal-trigger="${id}"]`).forEach(btn => {
      btn.addEventListener('click', () => {
        this.triggerElement = btn;
        this.open();
      });
    });
  }

  open() {
    // Clone modal content to move to document root
    const clone = this.cloneNode(true);
    this.backdrop = document.createElement('div');
    this.backdrop.classList.add('pyd-modal__backdrop');
    this.backdrop.setAttribute('role', 'dialog');
    this.backdrop.setAttribute('aria-modal', 'true');

    this.dialog = document.createElement('div');
    this.dialog.classList.add('pyd-modal__dialog');
    while (clone.firstChild) {
      this.dialog.appendChild(clone.firstChild);
    }
    this.backdrop.appendChild(this.dialog);

    // Set aria-labelledby to the modal title if present
    const titleEl = this.dialog.querySelector('.pyd-modal__title');
    if (titleEl) {
      if (!titleEl.id) {
        const modalCounter = (PYDModal._idCounter = (PYDModal._idCounter || 0) + 1);
        titleEl.id = 'pyd-modal-title-' + modalCounter;
      }
      this.backdrop.setAttribute('aria-labelledby', titleEl.id);
    }

    document.body.appendChild(this.backdrop);

    requestAnimationFrame(() => {
      this.backdrop.classList.add('show');
      this.dialog.classList.add('show');
      // Move focus to the first focusable element in the modal
      const focusable = this.dialog.querySelector('button:not([disabled]):not([hidden]), [href]:not([disabled]):not([hidden]), input:not([disabled]):not([hidden]), select:not([disabled]):not([hidden]), textarea:not([disabled]):not([hidden]), [tabindex]:not([tabindex="-1"]):not([disabled]):not([hidden])');
      if (focusable) focusable.focus();
    });

    this.bindEvents();
  }

  close() {
    if (!this.backdrop) return;
    this.backdrop.classList.remove('show');
    this.dialog.classList.remove('show');

    // Return focus to the trigger element
    const trigger = this.triggerElement;

    // Clean up after transition
    setTimeout(() => {
      if (this.backdrop && this.backdrop.parentNode) {
        this.backdrop.parentNode.removeChild(this.backdrop);
      }
      this.unbindEvents();
      if (trigger) trigger.focus();
    }, 250);
  }

  bindEvents() {
    this.backdrop.addEventListener('click', this.outsideClickHandler);
    this.backdrop.querySelectorAll('[data-modal-close]').forEach(btn => {
      btn.addEventListener('click', this.closeHandler);
    });
    document.addEventListener('keydown', this.keydownHandler);
  }

  unbindEvents() {
    if (!this.backdrop) return;
    this.backdrop.removeEventListener('click', this.outsideClickHandler);
    this.backdrop.querySelectorAll('[data-modal-close]').forEach(btn => {
      btn.removeEventListener('click', this.closeHandler);
    });
    document.removeEventListener('keydown', this.keydownHandler);
  }

  outsideClickHandler(e) {
    if (e.target === this.backdrop) {
      this.close();
    }
  }

  closeHandler() {
    this.close();
  }

  keydownHandler(e) {
    if (e.key === 'Escape') {
      e.preventDefault();
      this.close();
    }
  }
}
customElements.define('pyd-modal', PYDModal);

class PYDTabs extends HTMLElement {
  constructor() {
    super();
    this.buttons = [];
    this.contents = [];
  }

  connectedCallback() {
    this.buttons = Array.from(this.querySelectorAll("[data-tab-btn]"));
    this.contents = Array.from(this.querySelectorAll("[data-tab-content]"));

    // Bind events
    this.buttons.forEach(btn => {
      btn.addEventListener("click", () => this.openTab(btn.dataset.tabBtn));
    });

    // Open default tab
    const defaultBtn = this.querySelector("[data-default]");
    if (defaultBtn) {
      this.openTab(defaultBtn.dataset.tabBtn);
    } else if (this.buttons.length) {
      this.openTab(this.buttons[0].dataset.tabBtn);
    }
  }

  openTab(id) {
    // Update buttons
    this.buttons.forEach(btn => {
      btn.classList.toggle("active", btn.dataset.tabBtn === id);
    });

    // Update tab content
    this.contents.forEach(content => {
      const match = content.dataset.tabContent === id;
      content.classList.toggle("active", match);
    });
  }
}
customElements.define("pyd-tabs", PYDTabs);

class PYDSlider extends HTMLElement {
  constructor() {
    super();
    this.index = 0;
  }

  connectedCallback() {
    this.track = this.querySelector("[data-track]");
    this.slides = Array.from(this.querySelectorAll("[data-slide]"));
    this.total = this.slides.length;

    this.count = this.querySelector("[data-count]");
    this.prevBtn = this.querySelector("[data-prev]");
    this.nextBtn = this.querySelector("[data-next]");

    // Update UI initially
    this.update();

    // Add events
    this.prevBtn.addEventListener("click", () => this.prev());
    this.nextBtn.addEventListener("click", () => this.next());
  }

  update() {
    this.style.setProperty("--index", this.index);
    this.count.textContent = `${this.index + 1} / ${this.total}`;
  }

  next() {
    if (this.index < this.total - 1) {
      this.index++;
      this.update();
    }
  }

  prev() {
    if (this.index > 0) {
      this.index--;
      this.update();
    }
  }
}
customElements.define("pyd-slider", PYDSlider);

class TradeInCartItems extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', this.onDomReady.bind(this));
    } else {
      this.onDomReady();
    }

    this.emptyCartText = this.getAttribute('empty-cart-text') || '';
    this.emptyCartCta = this.getAttribute('empty-cart-cta') || '';
    this.sellMoreCta = this.getAttribute('sell-more-cta') || '';

    window.addEventListener('tradeIn:cartLoading', () => this.renderSkeleton());
    window.addEventListener('tradeIn:cartLoaded', (e) => this.renderCart(e.detail.cart));
    window.addEventListener('tradeIn:cartError', (e) => this.renderError(e.detail.error));
  }

  onDomReady() {
    this.renderSkeleton(); // Show skeleton until tradeIn:cartLoaded event fires
  }

  renderCart(cart) {
    const items = Array.isArray(cart?.items) ? cart.items : [];
    const hasItems = items.length > 0;
    this.innerHTML = hasItems ? this.renderTable(items) : this.renderEmpty();

    this.querySelectorAll('.delete-btn').forEach(btn => {
      btn.addEventListener('click', e => {
        const srNumber = e.currentTarget.dataset.srNumber;
        const productId = e.currentTarget.dataset.productId;
        window.tradeIn.deleteItem(srNumber, productId);
      });
    });
  }

  renderTable(items) {
    return `
      <div class="ti-cart-items">
        <table class="ti-table">
          <thead>
            <tr>
              <th>Device</th>
              <th></th>
              <th>Offer</th>
            </tr>
          </thead>
          <tbody>
            ${items.map(item => `
              <tr data-id="${item.number}">
                <td>${item.product.manufacturerName} ${item.product.name}</td>
                <td>
                  <button class="delete-btn" data-sr-number="${item.number}" data-product-id="${item.id}" aria-label="Delete item">
                    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                      <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M12.97 5.5h3.53a.5.5 0 0 1 0 1h-1.25v10a.5.5 0 0 1-.5.5h-8.5c-.28 0-.5-.22-.5-.5v-10H4.5a.5.5 0 1 1 0-1h3.53a3.06 3.06 0 0 1 .6-1.65C9.06 3.32 9.7 3 10.5 3s1.44.32 1.87.85a3.07 3.07 0 0 1 .6 1.65ZM10.5 4c-.51 0-.86.19-1.09.48-.19.24-.31.6-.36 1.02h2.9c-.06-.42-.16-.78-.36-1.02-.24-.29-.58-.48-1.09-.48ZM6.75 6.5V16h7.5V6.5h-7.5Zm1.946 1.396a.5.5 0 0 1 .854.354v6a.5.5 0 0 1-1 0v-6a.5.5 0 0 1 .146-.354Zm2.9 0a.5.5 0 0 1 .854.354v6a.5.5 0 0 1-1 0v-6a.5.5 0 0 1 .146-.354Z"
                        fill="#000"/>
                    </svg>
                  </button>
                </td>
                <td>
                  ${item.bonus > 0
                    ? `<span class="bonus-price"><s>$${item.estimatedValue.toFixed(2)}</s></span> <span>$${item.estimatedValue.toFixed(2) + item.bonus.toFixed(2)}</span>`
                    : `<span>$${item.estimatedValue.toFixed(2)}</span>`
                  }
                </td>
              </tr>
            `).join('')}
          </tbody>
        </table>

        <button data-ti-get-pyd-btn class="pyd-button pyd-button--outline" onclick="javascript:PYD.reset(this);">
          <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
            <path d="M10 3H6L4.5.781C4.281.47 4.531 0 4.906 0h6.157c.374 0 .624.469.406.781L10 3ZM6 4h4c.094.094.25.188.406.281C12.156 5.406 16 7.844 16 13a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3c0-5.156 3.813-7.594 5.594-8.719.125-.093.281-.187.406-.281Zm2.625 2.75A.627.627 0 0 0 8 6.125a.627.627 0 0 0-.625.625v.438c-.25.062-.5.156-.719.28-.437.25-.812.72-.781 1.376 0 .625.375 1.031.75 1.281.344.188.781.313 1.125.438h.063c.375.124.656.218.875.343.156.094.156.156.156.25.031.156-.031.25-.156.313-.157.125-.407.156-.688.156-.344 0-.656-.125-1.094-.25-.062-.031-.156-.063-.218-.094-.344-.094-.688.063-.782.406a.604.604 0 0 0 .375.782c.063.031.125.031.188.062.281.094.562.188.875.281v.438c0 .344.281.625.625.625a.627.627 0 0 0 .625-.625v-.406c.25-.063.5-.156.75-.281.437-.282.781-.75.75-1.407 0-.656-.344-1.062-.75-1.312a4.994 4.994 0 0 0-1.156-.469h-.032c-.406-.125-.687-.219-.875-.344-.156-.094-.187-.156-.187-.187 0-.125.062-.219.218-.313.157-.094.407-.156.657-.156.312 0 .625.094.968.188.344.062.688-.126.782-.47.094-.312-.125-.655-.438-.75-.219-.062-.437-.124-.656-.155V6.75Z" fill="currentColor"/>
          </svg>
          ${this.sellMoreCta}
        </button>
      </div>
    `;
  }

  renderEmpty() {
    return `
      <div class="ti-cart-items">
        <div class="ti-cart-empty">
          <div class="ti-cart-empty__text">
            ${this.emptyCartText}
          </div>
          <button data-ti-get-pyd-btn class="pyd-button pyd-button--primary" onclick="javascript:PYD.reset(this);">
            <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
              <path d="M10 3H6L4.5.781C4.281.47 4.531 0 4.906 0h6.157c.374 0 .624.469.406.781L10 3ZM6 4h4c.094.094.25.188.406.281C12.156 5.406 16 7.844 16 13a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3c0-5.156 3.813-7.594 5.594-8.719.125-.093.281-.187.406-.281Zm2.625 2.75A.627.627 0 0 0 8 6.125a.627.627 0 0 0-.625.625v.438c-.25.062-.5.156-.719.28-.437.25-.812.72-.781 1.376 0 .625.375 1.031.75 1.281.344.188.781.313 1.125.438h.063c.375.124.656.218.875.343.156.094.156.156.156.25.031.156-.031.25-.156.313-.157.125-.407.156-.688.156-.344 0-.656-.125-1.094-.25-.062-.031-.156-.063-.218-.094-.344-.094-.688.063-.782.406a.604.604 0 0 0 .375.782c.063.031.125.031.188.062.281.094.562.188.875.281v.438c0 .344.281.625.625.625a.627.627 0 0 0 .625-.625v-.406c.25-.063.5-.156.75-.281.437-.282.781-.75.75-1.407 0-.656-.344-1.062-.75-1.312a4.994 4.994 0 0 0-1.156-.469h-.032c-.406-.125-.687-.219-.875-.344-.156-.094-.187-.156-.187-.187 0-.125.062-.219.218-.313.157-.094.407-.156.657-.156.312 0 .625.094.968.188.344.062.688-.126.782-.47.094-.312-.125-.655-.438-.75-.219-.062-.437-.124-.656-.155V6.75Z" fill="currentColor"/>
            </svg>
            ${this.emptyCartCta}
          </button>
        </div>
      </div>
    `;
  }

  renderSkeleton() {
    this.innerHTML = `
      <div class="pyd-skeleton pyd-skeleton-line-items">
        <div><span></span><span></span></div>
        <div><span></span><span></span><span></span></div>
        <div><span></span><span></span><span></span></div>
      </div>
    `;
  }

  renderError(error) {
    this.innerHTML = `
      <div class="ti-cart-items ti-error">
        <p>Something went wrong while loading your cart.</p>
        <p>${error?.message || 'Unknown error'}</p>
      </div>
    `;
  }
}
customElements.define('tradein-cart-items', TradeInCartItems);

class TradeInCartSummary extends HTMLElement {
  connectedCallback() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', this.onDomReady.bind(this));
    } else {
      this.onDomReady();
    }

    window.addEventListener('tradeIn:cartLoading', () => this.renderSkeleton());
    window.addEventListener('tradeIn:cartLoaded', (e) => this.renderSummary(e.detail.cart));

    window.addEventListener('tradeIn:cartLoaded', (e) => {
      const cart = e.detail?.cart;
      this.renderSummary(cart);
    });
  }

  onDomReady() {
    this.renderSkeleton(); // Show skeleton until tradeIn:cartLoaded event fires
  }

  renderSummary(cart) {
    const { estimatedSubtotal, estimatedBonus, estimatedTotal } = cart || {};
    const items = Array.isArray(cart?.items) ? cart.items : [];
    const hasItems = items?.length > 0;

    const disclaimer = this.getAttribute('disclaimer') || '';
    const cta = this.getAttribute('cta') || '';
    const terms = this.getAttribute('terms') || '';
    const bonus = this.getAttribute('bonus') || 'Bonus';
    const subtotal = this.getAttribute('subtotal') || 'Subtotal';
    const total = this.getAttribute('total') || 'Total';
    const currency = 'USD';

    this.innerHTML = hasItems ? `
      <ul class="ti-cart__summary-content">
        ${estimatedSubtotal ? `
          <li class="ti-cart__summary-item">
            <span>${subtotal}</span>
            <span>$${PYD.formatCurrency(estimatedSubtotal)}</span>
          </li>` : ''}
    
        ${estimatedBonus ? `
          <li class="ti-cart__summary-item bonus">
            <span>${bonus}</span>
            <span>+ $${PYD.formatCurrency(estimatedBonus)}</span>
          </li>` : ''}
    
        ${estimatedTotal !== undefined ? `
          <li class="ti-cart__summary-item total">
            <span>${total}</span>
            <span><span>${currency}</span> $${PYD.formatCurrency(estimatedTotal)}</span>
          </li>` : ''}
    
        ${disclaimer ? `
          <li class="ti-cart__summary-item disclaimer"><p>${disclaimer}</p></li>` : ''}
    
        ${cta ? `
          <li class="ti-cart__summary-item btn">
            <button class="pyd-button pyd-button--primary w-full ti-cart__checkout">${cta}</button>
          </li>` : ''}
    
        ${terms ? `
          <li class="ti-cart__summary-item terms">${terms}</li>` : ''}
      </ul>
    ` : '';

    // button event listener after rendering
    if (cta) {
      this.querySelector('.ti-cart__checkout')?.addEventListener('click', () => {
        PYD.showScreen('checkout') ??
        PYD.initCheckoutPage();
      });
    }
  }

  renderSkeleton() {
    this.innerHTML = `
      <div class="pyd-skeleton pyd-skeleton-cart-summary ti-cart__summary-content">
        <div><span></span><span></span></div>
        <div><span></span><span></span></div>
        <div><span></span><span></span></div>
        <div><span></span><span></span><span></span></div>
        <div><span></span></div>
        <div><span></span><span></span></div>
      </div>
    `;
  }
}
customElements.define('tradein-cart-summary', TradeInCartSummary);


// ===== Checkout Page Related Script Start =====
class TextInput extends HTMLElement {
  static get observedAttributes() {
    return ['data-name', 'data-label', 'text-color', 'placeholder-color', 'border-color', 'background-color', 'data-type', 'data-required', 'paragraph-size', 'legend-size', 'input-label-checked-size'];
  }
  constructor() {
    super();
    this.attachShadow({
      mode: 'open',
    });
  }
  connectedCallback() {
    this.style.setProperty('--text-color', this.getAttribute('text-color') || '#000000');
    this.style.setProperty('--placeholder-color', this.getAttribute('placeholder-color') || '#707070');
    this.style.setProperty('--border-color', this.getAttribute('border-color') || '#e85200');
    this.style.setProperty('--background-color', this.getAttribute('background-color') || '#fff3f3');
    this.style.setProperty('--paragraph-size', this.getAttribute('paragraph-size') + 'px' || '16px');
    this.style.setProperty('--legend-size', this.getAttribute('legend-size') + 'px' || '16px');
    this.style.setProperty('--input-label-checked-size', this.getAttribute('input-label-checked-size') + 'px' || '14px');
    this.style.setProperty('--input-error-color', this.getAttribute('input-error-color'));
    this.render();
  }
  attributeChangedCallback(name, oldVal, newVal) {
    if (oldVal === newVal) return;
    if (['text-color', 'placeholder-color', 'border-color', 'background-color', 'paragraph-size', 'legend-size', 'input-label-checked-size'].includes(name)) {
      this.style.setProperty('--text-color', this.getAttribute('text-color') || '#000000');
      this.style.setProperty('--placeholder-color', this.getAttribute('placeholder-color') || '#707070');
      this.style.setProperty('--border-color', this.getAttribute('border-color') || '#e85200');
      this.style.setProperty('--background-color', this.getAttribute('background-color') || '#fff3f3');
      this.style.setProperty('--paragraph-size', this.getAttribute('paragraph-size') + 'px' || '16px');
      this.style.setProperty('--legend-size', this.getAttribute('legend-size') + 'px' || '16px');
      this.style.setProperty('--input-label-checked-size', this.getAttribute('input-label-checked-size') + 'px' || '14px');
    }
    if (['data-name', 'data-label'].includes(name)) {
      this.inputName = this.getAttribute('data-name') || 'input-name';
      this.inputLabel = this.getAttribute('data-label') || 'Label';
    }
    this.render();
  }
  render() {
    const alreadyStyled = !!this.shadowRoot.querySelector('style');
    if (!alreadyStyled) {
      const style = document.createElement('style');
      style.textContent = `
        :host {
          display: block;
        }

        .input-box {
          position: relative;
          display: block;
          max-width: 749px;
          margin: 0;
        }

        input[type="text"], input[type="email"], input[type="tel"] {
          width: 100%;
          box-sizing: border-box;
          height: 48px;
          padding: 16px 16px 0 16px;
          border: 1px solid var(--border-color);
          border-radius: 6px;
          background-color: var(--background-color);
          color: var(--text-color);
          font-size: var(--paragraph-size);
          font-weight: 500;
          outline: none;
        }

        input[type="text"]::placeholder, input[type="email"]::placeholder, input[type="tel"]::placeholder {
          color: transparent;
        }

        label {
          position: absolute;
          left: 12px;
          top: 50%;
          transform: translateY(-50%);
          font-size: var(--legend-size);
          color: var(--placeholder-color);
          background: transparent;
          pointer-events: none;
          transition:
            top 0.2s ease,
            right 0.2s ease,
            left 0.2s ease,
            font-size 0.2s ease,
            color 0.2s ease;
        }

        .input-box.focused label,
        .input-box.error label,
        .input-box.filled label {
          top: 5px;
          left: 12px;
          right: 12px;
          font-size: var(--input-label-checked-size);
          color: var(--placeholder-color);
        }

        .input-box.error input {
          border-color: var(--input-error-color);
        }

        .input-box .error-message {
          color: var(--input-error-color);
          font-size: var(--legend-size);
          margin-top: 4px;
          display: none;
          line-height: 1;
        }

        .input-box.error .error-message {
          display: block;
          var(--legend-size)
        }
      `;
      this.shadowRoot.appendChild(style);
    }

    const existing = this.shadowRoot.querySelector('.input-box');
    if (existing) this.shadowRoot.removeChild(existing);
    const container = document.createElement('div');
    container.className = 'input-box';
    container.innerHTML = `
      <input type="${this.getAttribute('data-type')}" name="${this.inputName}" id="${this.inputName}" aria-label="${this.inputLabel}">
      <label for="${this.inputName}">${this.inputLabel}</label>
      <div class="error-message">This field is required</div>
    `;
    this.shadowRoot.appendChild(container);
    const input = container.querySelector('input');

    // Required validation
    const dataRequired = this.getAttribute('data-required');
    if (dataRequired == 'true') {
      input.required = true;
    }
    // Phone Validation
    const dataType = this.getAttribute('data-type');
    if (dataType == 'tel') {
      input.setAttribute('pattern', '[0-9]{3}-[0-9]{3}-[0-9]{4}');
      input.setAttribute('title', 'Enter a 10-digit phone number');
      input.addEventListener('input', function (e) {
        let x = e.target.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
        e.target.value = !x[2] ? x[1] : x[1] + '-' + x[2] + (x[3] ? '-' + x[3] : '');
      });
    }
    // Min 2 charactor allowed
    if (this.inputName === 'first-name' || this.inputName === 'last-name') {
      input.setAttribute('pattern', '.{2,}');
      input.setAttribute('title', 'Please enter at least 2 characters');
    }

    const updateState = () => {
      container.classList.toggle('filled', !!input.value);
    };
    input.addEventListener('focus', () => container.classList.add('focused'));

    const errorMessage = container.querySelector('.error-message');

    const validate = () => {
      const isRequired = dataRequired === 'true';
      const isEmpty = !input.value.trim();
      const inputId = input.getAttribute('id');
      const message = PYD.allErrorMessages[inputId] || 'This field is required';

      if (isRequired && isEmpty) {
        container.classList.add('error');
        errorMessage.textContent = message;
      } else {
        container.classList.remove('error');
        errorMessage.textContent = '';
      }
    };

    input.addEventListener('blur', () => {
      container.classList.remove('focused');
      updateState();
      validate();
    });

    input.addEventListener('input', updateState);
    updateState();
  }
}
customElements.define('text-input', TextInput);

class CheckboxInput extends HTMLElement {
  static get observedAttributes() {
    return ['data-name', 'data-checked', 'data-richtext', 'data-label', 'check-color', 'text-color', 'border-color', 'background-color', 'data-required', 'paragraph-size', 'legend-size'];
  }

  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
  }

  connectedCallback() {
    this.updateCustomProperties();
    this.render();
  }

  attributeChangedCallback(name, oldVal, newVal) {
    if (oldVal === newVal) return;
    if (['check-color', 'text-color', 'border-color', 'background-color'].includes(name)) {
      this.updateCustomProperties();
    }
    if (['data-name', 'data-label'].includes(name)) {
      this.inputName = this.getAttribute('data-name') || 'checkbox-name';
      this.inputLabel = this.getAttribute('data-label') || 'Check me';
    }
    this.render();
  }

  updateCustomProperties() {
    this.style.setProperty('--check-color', this.getAttribute('check-color') || '#ffffff');
    this.style.setProperty('--text-color', this.getAttribute('text-color') || '#000000');
    this.style.setProperty('--border-color', this.getAttribute('border-color') || '#e85200');
    this.style.setProperty('--background-color', this.getAttribute('background-color') || '#fff3f3');
    this.style.setProperty('--checkbox-error-color', this.getAttribute('checkbox-error-color') || '#FF2026');
    this.style.setProperty('--checkbox-unchecked-border-color', this.getAttribute('checkbox-unchecked-border-color') || '#000000');
    this.style.setProperty('--paragraph-size', this.getAttribute('paragraph-size') + 'px' || '16px');
    this.style.setProperty('--legend-size', this.getAttribute('legend-size') + 'px' || '16px');
  }

  render() {
    const alreadyStyled = !!this.shadowRoot.querySelector('style');
    if (!alreadyStyled) {
      const style = document.createElement('style');
      style.textContent = `
        :host {
          display: block;
        }

        .checkbox-wrapper {
          display: grid;
          grid-template-columns: 24px auto;
          align-items: start;
          gap: 0;
          margin: 0;
          cursor: pointer;
          color: var(--text-color);
        }

        input[type="checkbox"] {
          appearance: none;
          width: 16px;
          height: 16px;
          margin: 3px 0;
          border: 1.5px solid var(--checkbox-unchecked-border-color);
          border-radius: 4px;
          background-color: transparent;
          cursor: pointer;
          position: relative;
        }

        input[type="checkbox"]:checked {
          border: 1.5px solid var(--border-color);
          background-color: var(--background-color);
        }

        input[type="checkbox"]:checked::after {
          content: '';
          position: absolute;
          left: 4px;
          top: 0;
          width: 4px;
          height: 8px;
          border: solid var(--check-color);
          border-width: 0 2px 2px 0;
          transform: rotate(45deg);
        }

        label {
          font-size: var(--legend-size);
          cursor: pointer;
        }

        input[type="checkbox"].invalid:checked {
          border: 1.5px solid var(--border-color);
        }

        .error-message {
          display: none;
          color: var(--checkbox-error-color);
          font-size: var(--legend-size);
          grid-column: 1 / -1;
          letter-spacing: 0;
          margin-top: 10px;
        }

        .label-content * {
          margin: 0;
        }

        .label-content a {
          color: inherit;
          text-decoration: underline;
        }
      `;
      this.shadowRoot.appendChild(style);
    }

    const existing = this.shadowRoot.querySelector('.checkbox-wrapper');
    if (existing) this.shadowRoot.removeChild(existing);

    this.inputName = this.getAttribute('data-name') || 'checkbox-name';
    const isRichtext = this.getAttribute('data-richtext') === 'true';
    let inputLabel = this.getAttribute('data-label') || 'Check me';
    if (isRichtext) {
      const el = document.getElementById(inputLabel);
      if (el) {
        inputLabel = el.innerHTML.trim();
      }
    }
    const isChecked = this.getAttribute('data-checked') === 'true';

    // Required validation
    const dataRequired = this.getAttribute('data-required') === 'true';

    const wrapper = document.createElement('label');
    wrapper.className = 'checkbox-wrapper';
    wrapper.innerHTML = `
      <input type="checkbox" name="${this.inputName}" id="${this.inputName}" ${isChecked ? 'checked' : ''} ${dataRequired ? 'required' : ''}>
      <div class="label-content"></div>
      <div class="error-message">This field is required.</div>
    `;

    const labelContent = wrapper.querySelector('.label-content');

    if (isRichtext) {
      labelContent.innerHTML = inputLabel;
    } else {
      labelContent.textContent = inputLabel;
    }

    this.shadowRoot.appendChild(wrapper);

    const checkbox = this.shadowRoot.querySelector('input[type="checkbox"]');
    const errorMessage = this.shadowRoot.querySelector('.error-message');
    checkbox.addEventListener('change', () => {
      const isCheckedNow = checkbox.checked;
      if (isCheckedNow) {
        checkbox.classList.remove('invalid');
        checkbox.setCustomValidity('');
        if (errorMessage) {
          errorMessage.textContent = '';
          errorMessage.style.display = 'none';
        }
      }
    });
  }
}
customElements.define('checkbox-input', CheckboxInput);

class RadioAccordion extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
    this.options = [];
  }

  static get observedAttributes() {
    return ['data-name', 'data-options', 'title-color', 'caption-color', 'border-color', 'background-color', 'hide-dropdown', 'paragraph-size', 'legend-size', 'data-required'];
  }

  attributeChangedCallback(name, oldVal, newVal) {
    if (name === 'data-name') {
      this.radioName = newVal || 'dynamic-radio';
      this.render();
    }
    if (name === 'data-options' && oldVal !== newVal) {
      this.parseOptionsFromAttribute(newVal);
      this.render();
    }
    if (name === 'title-color') {
      this.style.setProperty('--title-color', newVal || '#000000');
    }

    if (name === 'caption-color') {
      this.style.setProperty('--caption-color', newVal || '#707070');
    }

    if (name === 'border-color') {
      this.style.setProperty('--border-color', newVal || '#e85200');
    }

    if (name === 'background-color') {
      this.style.setProperty('--background-color', newVal || '#fff3f3');
    }

    if (name === 'hide-dropdown') {
      if (newVal == 'true') {
          this.style.setProperty('--hide-dropdown', 'none');
      } else {
          this.style.setProperty('--hide-dropdown', 'block');
      }
    }
  }

  connectedCallback() {
    this.radioName = this.getAttribute('data-name') || 'radio-name';
    const dataAttr = this.getAttribute('data-options');
    this.parseOptionsFromAttribute(dataAttr);

    this.style.setProperty('--title-color', this.getAttribute('title-color') || '#000000');
    this.style.setProperty('--caption-color', this.getAttribute('caption-color') || '#707070');
    this.style.setProperty('--border-color', this.getAttribute('border-color') || '#e85200');
    this.style.setProperty('--background-color', this.getAttribute('background-color') || '#fff3f3');
    this.style.setProperty('--input-error-color', this.getAttribute('input-error-color') || '#FF2026');
    this.style.setProperty('--paragraph-size', this.getAttribute('paragraph-size') + 'px' || '16px');
    this.style.setProperty('--legend-size', this.getAttribute('legend-size') + 'px' || '16px');
    this.render();
  }

  parseOptionsFromAttribute(data) {
    try {
      this.options = data ? JSON.parse(data) : [];
    } catch (e) {
      console.error('Invalid JSON in data-options:', e);
      this.options = [];
    }
  }

  render() {
    this.shadowRoot.innerHTML = `
      <style>
        :host {
          display: block;
        }
        .info-wrapper {
          display: grid;
          grid-template-columns: 26px auto;
          align-items: start;
        }
        .info-icon {
          width: 18px;
          height: 18px;
          background-repeat: no-repeat;
          background-position: center;
          background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAxOCAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkgMkM2LjY1NjI1IDIgNC41MzEyNSAzLjI1IDMuMzQzNzUgNS4yNUMyLjE4NzUgNy4yODEyNSAyLjE4NzUgOS43NSAzLjM0Mzc1IDExLjc1QzQuNTMxMjUgMTMuNzgxMiA2LjY1NjI1IDE1IDkgMTVDMTEuMzEyNSAxNSAxMy40Mzc1IDEzLjc4MTIgMTQuNjI1IDExLjc1QzE1Ljc4MTIgOS43NSAxNS43ODEyIDcuMjgxMjUgMTQuNjI1IDUuMjVDMTMuNDM3NSAzLjI1IDExLjMxMjUgMiA5IDJaTTkgMTYuNUM2LjEyNSAxNi41IDMuNSAxNSAyLjA2MjUgMTIuNUMwLjYyNSAxMC4wMzEyIDAuNjI1IDcgMi4wNjI1IDQuNUMzLjUgMi4wMzEyNSA2LjEyNSAwLjUgOSAwLjVDMTEuODQzOCAwLjUgMTQuNDY4OCAyLjAzMTI1IDE1LjkwNjIgNC41QzE3LjM0MzggNyAxNy4zNDM4IDEwLjAzMTIgMTUuOTA2MiAxMi41QzE0LjQ2ODggMTUgMTEuODQzOCAxNi41IDkgMTYuNVpNNy43NSAxMUg4LjVWOUg3Ljc1QzcuMzEyNSA5IDcgOC42ODc1IDcgOC4yNUM3IDcuODQzNzUgNy4zMTI1IDcuNSA3Ljc1IDcuNUg5LjI1QzkuNjU2MjUgNy41IDEwIDcuODQzNzUgMTAgOC4yNVYxMUgxMC4yNUMxMC42NTYyIDExIDExIDExLjM0MzggMTEgMTEuNzVDMTEgMTIuMTg3NSAxMC42NTYyIDEyLjUgMTAuMjUgMTIuNUg3Ljc1QzcuMzEyNSAxMi41IDcgMTIuMTg3NSA3IDExLjc1QzcgMTEuMzQzOCA3LjMxMjUgMTEgNy43NSAxMVpNOSA2LjVDOC40Mzc1IDYuNSA4IDYuMDYyNSA4IDUuNUM4IDQuOTY4NzUgOC40Mzc1IDQuNSA5IDQuNUM5LjUzMTI1IDQuNSAxMCA0Ljk2ODc1IDEwIDUuNUMxMCA2LjA2MjUgOS41MzEyNSA2LjUgOSA2LjVaIiBmaWxsPSIjNTI0RjREIi8+Cjwvc3ZnPgo=);
        }

        .radio-option {
          position: relative;
          display: block;
          border: 2px solid #ffffff;
          background-color: #F0EBE3;
          margin-bottom: -1px;
          max-width: 600px;
          transition: border-color 0.2s, background-color 0.2s;
          overflow: hidden;
        }
        
        label.radio-option:first-of-type {
          border-top-left-radius: 8px;
          border-top-right-radius: 8px;
        }

        label.radio-option:last-of-type {
          border-bottom-left-radius: 8px;
          border-bottom-right-radius: 8px;
        }

        .radio-option.checked {
          border-radius: 8px;
          background-color: var(--background-color);
          border-color: var(--border-color);
          z-index: 1;
        }

        .radio-header {
          display: grid;
          grid-template-columns: 26px 1fr 100px;
          align-items: start;
          padding: 10px;
          cursor: pointer;
          transition: background 0.2s;
          align-items: center;
        }

        .radio-option:hover .radio-header {
          background-color: #ffffff;
        }

        .radio-input {
          appearance: none;
          -webkit-appearance: none;
          width: 18px;
          height: 18px;
          border: 2px solid #000000;
          border-radius: 50%;
          margin: 3px 0;
          position: relative;
          background-color: white;
          cursor: pointer;
          transition: border 0.2s;
        }

        .radio-input:checked {
          border: 6px solid var(--border-color);
        }
        .text-content {
          display: flex;
          flex-direction: column;
        }

        .image-content {
          text-align: right;
        }

        .image-content img {
          max-width: 80px;
        }

        .title {
          font-weight: 400;
          font-size: var(--legend-size);
          margin-top: 0;
          color: var(--title-color);
        }

        .caption {
          font-size: var(--legend-size);
          color: var(--caption-color);
          margin-top: 2px;
        }

        .dropdown {
          font-size: var(--legend-size);
          padding: 12px 10px;
          display: none;
          background: var(--background-color);
          border-top: 1px solid #ddd;
        }

        .radio-option.checked .dropdown {
          display: block;
        }

        .radio-option.checked .dropdown{
          display: var(--hide-dropdown);
        }

        .radio-checked-content {
          display: none;
        }

        .radio-checked-content.active {
          padding: 14px 0;
          display: flex;
          flex-direction: column;
          gap: 14px;
        }

        .radio-checked-content__grid-3 {
          display: grid;
          grid-template-columns: 1fr 1fr 1fr;
          gap: 14px;
        }

        .info-wrapper {
          margin-top: 14px;
        }

        #container.invalid .radio-options-wrapper {
          border-radius: 8px;
          border: 1px solid var(--input-error-color);
          padding-bottom: 1px;
        }

        #container.invalid .error-message {
          display: block!important;
          font-size: var(--legend-size);
        }
      </style>
      <div id="container"></div>
    `;

    const container = this.shadowRoot.querySelector('#container');
    container.innerHTML = '';

    const optionsWrapper = document.createElement('div');
    optionsWrapper.className = 'radio-options-wrapper';

    this.options.forEach((opt, index) => {
      const label = document.createElement('label');
      label.className = 'radio-option';

      label.innerHTML = `
        <div class="radio-header">
          <input class="radio-input" type="radio" name="${this.radioName}" value="${opt.value}">
          <div class="text-content">
            <div class="title">${opt.title}</div>
            <div class="caption">${opt.caption}</div>
          </div>
          <div class="image-content">
            ${opt.image ? `<img src="${opt.image}">` : ''}
          </div>
        </div>
      `;

      const input = label.querySelector('input');
      input.addEventListener('change', () => this.updateChecked());

      const dropdown = document.createElement('div');
      dropdown.className = 'dropdown';

      if (opt.html) {
        const temp = document.createElement('div');
        temp.innerHTML = opt.html;
        [...temp.children].forEach((el) => dropdown.appendChild(el));
      }

      label.appendChild(dropdown);
      optionsWrapper.appendChild(label);
    });

    container.appendChild(optionsWrapper);

    const errorDiv = document.createElement('div');
    errorDiv.className = 'error-message';
    errorDiv.style.display = 'none';
    errorDiv.style.color = '#FF2026';
    container.appendChild(errorDiv);

    this.updateChecked();
  }

  updateChecked() {
    const allOptions = this.shadowRoot.querySelectorAll('.radio-option');
    const hasCheckoutPaymentOptions = this.classList.contains('checkout-payment-options');
    let anyChecked = false;

    allOptions.forEach((label) => {
      const input = label.querySelector('input[type="radio"]');
      const isChecked = input.checked;
      label.classList.toggle('checked', isChecked);
      if (isChecked) {
        anyChecked = true;
        if (hasCheckoutPaymentOptions) {
          PYD.gettingPackingSlip(input.value);
        }
      }
    });

    // Handle error message visibility
    const radioContainer = this.shadowRoot.querySelector('#container');
    if (radioContainer) {
      if (anyChecked) {
        radioContainer.classList.remove('invalid');
      }
    }
  }
}
customElements.define('radio-accordion', RadioAccordion);

class RadioGroup extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
    this.options = [];
  }

  static get observedAttributes() {
    return ['data-name', 'data-options', 'title-color', 'caption-color', 'border-color', 'background-color', 'background-color-checked', 'error-color', 'data-required'];
  }

  attributeChangedCallback(name, oldVal, newVal) {
    if (name === 'data-name') {
      this.radioName = newVal || 'dynamic-radio';
      this.render();
    }
    if (name === 'data-options' && oldVal !== newVal) {
      this.parseOptionsFromAttribute(newVal);
      this.render();
    }
    if (name === 'title-color') {
      this.style.setProperty('--title-color', newVal);
    }

    if (name === 'caption-color') {
      this.style.setProperty('--caption-color', newVal);
    }

    if (name === 'border-color') {
      this.style.setProperty('--border-color', newVal);
    }

    if (name === 'background-color') {
      this.style.setProperty('--background-color', newVal);
    }

    if (name === 'error-color') {
      this.style.setProperty('--input-error-color', newVal);
    }
  }

  connectedCallback() {
    this.radioName = this.getAttribute('data-name') || 'radio-name';

    const dataAttr = this.getAttribute('data-options');
    this.parseOptionsFromAttribute(dataAttr);

    const titleColor = this.getAttribute('title-color');
    const captionColor = this.getAttribute('caption-color');
    const borderColor = this.getAttribute('border-color');
    const bgColor = this.getAttribute('background-color');
    const errorColor = this.getAttribute('error-color');
    const bgColorChecked = this.getAttribute('background-color-checked');
    this.style.setProperty('--title-color', titleColor);
    this.style.setProperty('--caption-color', captionColor);
    this.style.setProperty('--border-color', borderColor);
    this.style.setProperty('--background-color', bgColor);
    this.style.setProperty('--background-color-checked', bgColorChecked);
    this.style.setProperty('--input-error-color', errorColor);
    const legendSizeAttr = this.getAttribute('legend-size');
    const legendSize = legendSizeAttr ? legendSizeAttr + 'px' : '16px';
    this.style.setProperty('--legend-size', legendSize);

    this.render();
  }

  parseOptionsFromAttribute(data) {
    try {
      this.options = data ? JSON.parse(data) : [];
    } catch (e) {
      console.error('Invalid JSON in data-options:', e);
      this.options = [];
    }
  }

  render() {
    this.shadowRoot.innerHTML = `
      <style>
        :host {
          display: block;
        }

        .radio-option {
          position: relative;
          display: flex;
          align-items: flex-start;
          padding: 14px 8px 14px;
          border: 1px solid #dedcdf;
          margin-bottom: -1px;
          max-width: 749px;
          cursor: pointer;
          transition: border-color 0.2s, background-color 0.2s;
          background-color: var(--background-color);
        }

        .radio-option.hide-radio {
          padding: 14px;
        }

        label.radio-option:first-of-type {
          border-top-left-radius: 8px;
          border-top-right-radius: 8px;
        }

        label.radio-option:last-of-type {
          border-bottom-left-radius: 8px;
          border-bottom-right-radius: 8px;
        }

        .radio-option:hover {
          background-color: var(--background-color-checked);
          border-color: var(--border-color);
          z-index: 1;
          border-radius: 8px;
        }

        .radio-option.checked {
          background-color: var(--background-color-checked);
          border-color: var(--border-color);
          z-index: 1;
          border-width: 2px;
          border-radius: 8px;
        }

        .radio-input {
          appearance: none;
          -webkit-appearance: none;
          width: 18px;
          height: 18px;
          border: 1px solid #dedede;
          border-radius: 50%;
          margin-right: 8px;
          position: relative;
          cursor: pointer;
          background-color: #ffffff;
          transition: border 0.2s;
        }

        .radio-option.hide-radio .radio-input {
          display: none;
        }

        .radio-input:checked {
          border: 6px solid var(--border-color);
        }

        .radio-input:focus {
          outline: none;
        }

        .radio-option:has(.radio-input:focus-visible) {
          outline: 2px solid var(--border-color);
          outline-offset: 2px;
          z-index: 2;
        }

        .text-content {
          display: flex;
          flex-direction: column;
        }

        .title {
          margin-top: 0;
          font-weight: 700;
          font-size: 14px;
          color: var(--title-color);
        }

        .caption {
          font-size: 14px;
          color: var(--caption-color);
          margin-top: 4px;
        }

        #container.invalid .radio-options-wrapper {
          border-radius: 8px;
          border: 1px solid var(--input-error-color);
          padding-bottom: 1px;
        }

        .error-message {
          color: var(--input-error-color);
        }

        #container.invalid .error-message {
          display: block!important;
          font-size: var(--legend-size);
        }
      </style>
      <div id="container"></div>
    `;

    const container = this.shadowRoot.querySelector('#container');
    container.innerHTML = '';

    const optionsWrapper = document.createElement('div');
    optionsWrapper.className = 'radio-options-wrapper';

    this.options.forEach((opt, index) => {
      const label = document.createElement('label');
      label.className = 'radio-option';
      label.innerHTML = `
        <input class="radio-input" type="radio" name="${this.radioName}" value="${opt.value}">
        <div class="text-content">
          <div class="title">${opt.title}</div>
          <div class="caption">${opt.caption}</div>
        </div>
      `;

      const input = label.querySelector('input');
      input.addEventListener('change', () => this.updateChecked());

      optionsWrapper.appendChild(label);
    });

    container.appendChild(optionsWrapper);

    const errorDiv = document.createElement('div');
    errorDiv.className = 'error-message';
    errorDiv.style.display = 'none';
    container.appendChild(errorDiv);

    this.updateChecked();
  }

  updateChecked() {
    const allOptions = this.shadowRoot.querySelectorAll('.radio-option');
    let anyChecked = false;

    allOptions.forEach((label) => {
      const input = label.querySelector('input[type="radio"]');
      const isChecked = input.checked;
      label.classList.toggle('checked', isChecked);
      if (isChecked) {
        anyChecked = true;
      }
    });

    // Handle error message visibility
    const radioContainer = this.shadowRoot.querySelector('#container');
    if (radioContainer) {
      if (anyChecked) {
        radioContainer.classList.remove('invalid');
      }
    }
  }
}
customElements.define('radio-group', RadioGroup);

class SearchableSelect extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
    this.states = [];
  }

  connectedCallback() {
    const name = this.getAttribute('data-name') || 'state';
    const label = this.getAttribute('data-label') || 'Select';
    const textColor = this.getAttribute('text-color');
    const placeholderColor = this.getAttribute('placeholder-color');
    const borderColor = this.getAttribute('border-color');
    const backgroundColor = this.getAttribute('background-color');
    const optionData = this.getAttribute('data-options');
    const paragraphSize = this.getAttribute('paragraph-size') + 'px' || '16px';
    const legendSize = this.getAttribute('legend-size') + 'px' || '16px';
    const inputLabelCheckedSize = this.getAttribute('input-label-checked-size') + 'px' || '14px';
    const inputErrorColor = this.getAttribute('input-error-color');

    try {
      this.states = JSON.parse(optionData) || [];
    } catch (e) {
      console.warn('Invalid JSON in data-options attribute');
      this.states = [];
    }

    this.shadowRoot.innerHTML = `
      <style>
        :host {
          display: block;
          position: relative;
          max-width: 749px;
        }

        .input-box {
          position: relative;
          width: 100%;
        }

        input {
          width: 100%;
          box-sizing: border-box;
          height: 48px;
          padding: 16px 12px 0 12px;
          border: 1px solid ${borderColor};
          border-radius: 6px;
          background-color: ${backgroundColor};
          background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTEiIHZpZXdCb3g9IjAgMCAxOCAxMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguMzM1OTQgOS42NjQwNkwwLjgzNTkzOCAyLjE2NDA2QzAuNDQ1MzEyIDEuODEyNSAwLjQ0NTMxMiAxLjIyNjU2IDAuODM1OTM4IDAuODM1OTM4QzEuMTg3NSAwLjQ4NDM3NSAxLjc3MzQ0IDAuNDg0Mzc1IDIuMTY0MDYgMC44MzU5MzhMOSA3LjcxMDk0TDE1LjgzNTkgMC44NzVDMTYuMTg3NSAwLjQ4NDM3NSAxNi43NzM0IDAuNDg0Mzc1IDE3LjE2NDEgMC44NzVDMTcuNTE1NiAxLjIyNjU2IDE3LjUxNTYgMS44MTI1IDE3LjE2NDEgMi4xNjQwNkw5LjYyNSA5LjY2NDA2QzkuMjczNDQgMTAuMDU0NyA4LjY4NzUgMTAuMDU0NyA4LjMzNTk0IDkuNjY0MDZaIiBmaWxsPSIjNTM0RjRDIi8+Cjwvc3ZnPgo=);
          background-repeat: no-repeat;
          background-position: right 15px center;
          color: ${textColor};
          font-size: ${paragraphSize};
          outline: none;
          cursor: default;
          caret-color: transparent;
        }

        .input-box.error input {
          border-color: ${inputErrorColor};
        }

        .input-box .error-message {
          color: ${inputErrorColor};
          font-size: ${legendSize};
          margin-top: 4px;
          display: none;
          line-height: 1;
        }

        .input-box.error .error-message {
          display: block;
        }

        label {
          position: absolute;
          left: 12px;
          top: 50%;
          transform: translateY(-50%);
          font-size: 14px;
          color: ${placeholderColor};
          background: transparent;
          pointer-events: none;
          transition: top 0.2s ease, font-size 0.2s ease;
        }

        .focused label,
        .error label,
        .filled label {
          top: 5px;
          font-size: ${inputLabelCheckedSize}px;
        }

        ul {
          list-style: none;
          padding: 0;
          margin: 4px 0 0;
          border: 1px solid ${borderColor};
          background: white;
          max-height: 180px;
          overflow-y: auto;
          border-radius: 6px;
          position: absolute;
          width: -webkit-fill-available;
          width: -moz-available;
          z-index: 100;
          display: none;
        }

        ul.visible {
          display: block;
        }

        li {
          padding: 8px 12px;
          cursor: pointer;
        }

        li:hover,
        li.active {
          background: #eee;
        }
      </style>

      <div class="input-box">
        <label for="${name}">${label}</label>
        <input type="text" id="${name}" name="${name}" autocomplete="off" />
        <div class="error-message">This field is required</div>
        <ul></ul>
      </div>
    `;

    const container = this.shadowRoot.querySelector('.input-box');
    const input = this.shadowRoot.querySelector('input');
    const ul = this.shadowRoot.querySelector('ul');

    // Required validation
    const dataRequired = this.getAttribute('data-required');
    if (dataRequired == 'true') {
      input.required = true;
    }

    let activeIndex = -1;

    const updateSuggestions = () => {
      ul.innerHTML = '';
      activeIndex = -1;
      this.states.forEach((state) => {
        const li = document.createElement('li');
        li.textContent = state;
        li.addEventListener('mousedown', () => {
          input.value = state;
          ul.classList.remove('visible');
          container.classList.add('filled');
        });
        ul.appendChild(li);
      });
      ul.classList.add('visible');
    };

    const highlightItem = (items, index) => {
      items.forEach((li, i) => li.classList.toggle('active', i === index));
      if (index >= 0 && items[index]) {
        items[index].scrollIntoView({ block: 'nearest' });
      }
    };

    const getItems = () => Array.from(ul.querySelectorAll('li'));

    input.addEventListener('focus', () => {
      container.classList.add('focused');
      updateSuggestions();
    });

    input.addEventListener('blur', () => {
      ul.classList.remove('visible');
      container.classList.remove('focused');
      activeIndex = -1;

      const inputId = input.getAttribute('id');
      const message = PYD.allErrorMessages[inputId] || 'This field is required';
      const errorMessage = container.querySelector('.error-message');

      if (input.value.trim() !== '') {
        container.classList.add('filled');
        container.classList.remove('error');
        errorMessage.textContent = '';
      } else {
        container.classList.remove('filled');
        container.classList.add('error');
        errorMessage.textContent = message;
      }
    });

    input.addEventListener('keydown', (e) => {
      const isOpen = ul.classList.contains('visible');

      if (e.key === 'ArrowDown') {
        e.preventDefault();
        if (!isOpen) updateSuggestions();
        const items = getItems();
        activeIndex = Math.min(activeIndex + 1, items.length - 1);
        highlightItem(items, activeIndex);
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        const items = getItems();
        activeIndex = Math.max(activeIndex - 1, 0);
        highlightItem(items, activeIndex);
      } else if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        const items = getItems();
        if (isOpen && activeIndex >= 0 && items[activeIndex]) {
          items[activeIndex].dispatchEvent(new MouseEvent('mousedown', { bubbles: true }));
        } else if (!isOpen) {
          updateSuggestions();
        }
      } else if (e.key === 'Escape') {
        e.preventDefault();
        ul.classList.remove('visible');
        activeIndex = -1;
      } else if (e.key !== 'Tab' && e.key !== 'Shift') {
        // Block typing — this is a select-only dropdown (caret-color: transparent)
        e.preventDefault();
      }
    });
  }
}
customElements.define('searchable-select', SearchableSelect);

class AddressInjector extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.injectPlaceholder();
  }

  injectPlaceholder() {
    const placeholder = document.querySelector('.check-address-placeholder');
    const checkoutBlock = document.querySelector('.checkout-payment-options');

    if (!placeholder || !checkoutBlock || !checkoutBlock.shadowRoot) return;

    const addressContainer = checkoutBlock.shadowRoot.querySelector('.dropdown .address');
    if (!addressContainer) return;

    addressContainer.appendChild(placeholder);

    this.dispatchEvent(
      new CustomEvent('address-injected', {
        detail: { injected: true },
        bubbles: true,
      })
    );

    const paymentRadio = document.querySelector('.checkout-payment-options');
    if (!paymentRadio || !paymentRadio.shadowRoot) return;

    const wrapper = paymentRadio.shadowRoot.querySelector('.gpyd-m-checkout__check-address checkbox-input');
    const target = paymentRadio.shadowRoot.querySelector('.gpyd-m-checkout__check-address .radio-checked-content');

    if (!wrapper || !target || !wrapper.shadowRoot) return;

    const checkbox = wrapper.shadowRoot.querySelector('input[type="checkbox"]');
    if (!checkbox) return;

    const toggleClass = () => {
      if (checkbox.checked) {
        target.classList.remove('active');
      } else {
        target.classList.add('active');
      }
    };

    toggleClass();
    checkbox.addEventListener('change', toggleClass);
  }
}
customElements.define('address-injector', AddressInjector);

// [TO-DO] - We need to do cleanup and conditionally including the JS down below
// Some JavaScripts are ECO-specific while some others are global

// Global Event Listeners:
// Use to update UI safely without blocking the from core functionality
this.addEventListener('pyd:form-initialized', async (e) => {
  if (PYD.state?.currentScreen?.toLowerCase().includes('pyd')) {
    PYD.loadFAQs('pyd');
  }
});

this.addEventListener('pyd:form-completed', async (e) => {
  PYD.deleteFAQs();
});

this.addEventListener('pyd:form-change-completed', async (e) => {
  if (PYD.state?.currentScreen?.toLowerCase().includes('pyd')) {
    PYD.handleFAQs(e.detail);
  }
});


// Global Variables
let CUSTOMER_ADDRESS = null;
let VERIFIED_MAIN_ADDRESS = null;
let VERIFIED_CHECK_ADDRESS = null;
let CUSTOMER_DATA = null;

// Summary Top Toggle
document.querySelectorAll('.gpyd-m-checkout__summary-top').forEach((element) => {
  element.addEventListener('click', () => {
    element.classList.toggle('active');
  });
});

// Close Checkout Error Popup
document.querySelectorAll('.ti-checkout__error-popup--close-icon')
  .forEach(icon => {
    icon.addEventListener('click', function () {
      const popup = this.closest('.ti-checkout__error-popup');
      if (popup) {
        popup.classList.remove('active');
      }
    });
  });

// Confirm Sale Button clicked
const form = document.querySelector('.confirm-sale-form');
  // Validation
  form?.addEventListener('submit', (e) => {
    e.preventDefault();

    let isValid = true;
    let firstInvalidInput = null;
    let customerEmail = '';
    let customerMailinMethodTitle = '';
    let customerMailinMethodCaption = '';
    let customerFirstName = '';
    let customerLastName = '';
    let customerAddress = '';
    let customerCity = '';
    let customerState = '';
    let customerZip = '';
    let customerPhone = '';
    let customerPaymentName = '';
    let customerPaymentAddress = '';
    let checkCustomerAddress = {};

    // Terms Validation
    const validateTermsCheckbox = () => {
      const checkboxComponent = form.querySelector('checkbox-input[data-name="terms"]');
      if (checkboxComponent && checkboxComponent.shadowRoot) {
        const checkbox = checkboxComponent.shadowRoot.querySelector('input[type="checkbox"]');
        const errorMessage = checkboxComponent.shadowRoot.querySelector('.error-message');
        const isRequired = checkbox.hasAttribute('required');
        const isChecked = checkbox.checked;

        // Clear previous custom validity
        checkbox.setCustomValidity('');

        if (isRequired && !isChecked) {
          isValid = false;
          if (!firstInvalidInput) firstInvalidInput = checkbox;

          checkbox.setCustomValidity(' '); // suppress browser tooltip
          checkbox.classList.add('invalid'); // optional: style with red border
          if (errorMessage) {
            errorMessage.textContent = PYD.allErrorMessages['terms'];
            errorMessage.style.display = 'block';
          }
        } else {
          checkbox.classList.remove('invalid');
          checkbox.setCustomValidity('');
          if (errorMessage) {
            errorMessage.textContent = '';
            errorMessage.style.display = 'none';
          }
        }
      }
    }

    // Radio Group Validation
    const validateMailin = () => {
      const radioGroupComponent = form.querySelector('radio-group[data-name="shipping-option"]');
      if (radioGroupComponent && radioGroupComponent.shadowRoot) {
        const checkedOption = radioGroupComponent.shadowRoot.querySelector('input[type="radio"]:checked');
        const errorMessage = radioGroupComponent.shadowRoot.querySelector('.error-message');
        const radioGroupContainer = radioGroupComponent.shadowRoot.querySelector('#container');
        const isRequired = radioGroupComponent.hasAttribute('data-required');

        radioGroupComponent.setCustomValidity?.('');

        if (isRequired && !checkedOption) {
          isValid = false;
          if (!firstInvalidInput) firstInvalidInput = radioGroupComponent.shadowRoot.querySelector('input[type="radio"]');
          radioGroupComponent.setCustomValidity?.(' ');
          radioGroupContainer.classList.add('invalid');
          if (errorMessage) {
            errorMessage.textContent = PYD.allErrorMessages['mailin'];
          }
        } else {
          radioGroupContainer.classList.remove('invalid');
          radioGroupComponent.setCustomValidity?.('');
          if (errorMessage) {
            errorMessage.textContent = '';
          }
        }
      }
    }

    // Payment Validation
    const validatePaymentOptions = () => {
      const radioAccordionComponent = form.querySelector('radio-accordion[data-name="payment-option"]');
      if (radioAccordionComponent && radioAccordionComponent.shadowRoot) {
        const checkedOption = radioAccordionComponent.shadowRoot.querySelector('input[type="radio"]:checked');
        const errorMessage = radioAccordionComponent.shadowRoot.querySelector('.error-message');
        const radioGroupContainer = radioAccordionComponent.shadowRoot.querySelector('#container');
        const isRequired = radioAccordionComponent.hasAttribute('data-required');

        radioAccordionComponent.setCustomValidity?.('');

        if (isRequired && !checkedOption) {
          isValid = false;
          if (!firstInvalidInput) firstInvalidInput = radioAccordionComponent.shadowRoot.querySelector('input[type="radio"]');
          radioAccordionComponent.setCustomValidity?.(' ');
          radioGroupContainer.classList.add('invalid');
          if (errorMessage) {
            errorMessage.textContent = PYD.allErrorMessages['payment-method'];
          }
        } else {
          radioGroupContainer.classList.remove('invalid');
          radioAccordionComponent.setCustomValidity?.('');
          if (errorMessage) {
            errorMessage.textContent = '';
          }
        }
      }
    }

    const paymentOptionElement = form.querySelector('radio-accordion[data-name="payment-option"]')?.shadowRoot.querySelector('.radio-option.checked');
    if (paymentOptionElement) {
      if (paymentOptionElement.querySelector('.radio-input')) {
        customerPaymentName = paymentOptionElement.querySelector('.radio-input').value;
        PYD.state.paymentOption = customerPaymentName;
      }
    }

    // Find all form elements
    const components = Array.from(form.querySelectorAll('text-input, searchable-select, radio-group, radio-accordion'));
    // Inner Form elements of payment accordion
    const paymentAccordions = form.querySelectorAll('.checkout-payment-options');
    paymentAccordions.forEach((accordion) => {
      if (accordion.shadowRoot) {
        const nestedComponents = accordion.shadowRoot.querySelectorAll('text-input, searchable-select');
        nestedComponents.forEach((input) => {
          const inputName = input.shadowRoot?.querySelector('input, select')?.name;
          const radioOption = input.closest('.radio-option');
          const isCheckField = [
            'payable-to',
            'address',
            'city',
            'state',
            'zip-code',
            'phone'
          ].includes(inputName);

          const hasCheckPlaceholder = radioOption?.querySelector('.check-address-placeholder');

          // Only include paypal-email if payment method is PAYPAL
          if (inputName === 'paypal-email') {
            if (customerPaymentName === 'Paypal') {
              components.push(input);
            }
            return;
          }

          // Only include check-related fields if payment method is CHECK
          if (isCheckField) {
            const checkboxComponent = hasCheckPlaceholder.querySelector('checkbox-input');
            const checkbox = checkboxComponent?.shadowRoot?.querySelector('input[type="checkbox"]');
            const isUsingSameAddress = checkbox?.checked;
            if (customerPaymentName === 'Check' && hasCheckPlaceholder && !isUsingSameAddress) {
              components.push(input);
            }
            return;
          }

          // Include all other inputs
          components.push(input);
        });
      }
    });
    // Terms checkbox element
    const termsBox = form.querySelector('checkbox-input[data-name="terms"]');
    if (termsBox) {
      components.push(termsBox);
    }

    let errorMessages = {...PYD.allErrorMessages};

    if (customerPaymentName === 'Paypal') {
      errorMessages["paypal-email"] = 'Enter a PayPal email address';
    } else {
      delete errorMessages["paypal-email"];
    }

    components.forEach((component) => {
      if (component.getAttribute('data-name') == "shipping-option") {
        validateMailin();
        return; 
      }
      if (component.getAttribute('data-name') == "payment-option") {
        validatePaymentOptions();
        return; 
      }
      if (component.getAttribute('data-name') == "terms") {
        validateTermsCheckbox();
        return; 
      }
      const shadowInput = component.shadowRoot.querySelector('input');
      const container = component.shadowRoot.querySelector('.input-box');
      const errorMessage = container?.querySelector('.error-message');

      const inputName = shadowInput.name;
      const isRequired = shadowInput.hasAttribute('required');
      const value = shadowInput.value.trim();
      const isEmpty = !value;

      // Clear previous custom validity
      shadowInput.setCustomValidity('');

      // Required field check
      if (isRequired && isEmpty) {
        isValid = false;
        if (!firstInvalidInput) firstInvalidInput = shadowInput;

        const customMessage = errorMessages[inputName] || 'This field is required';
        shadowInput.setCustomValidity(' ');
        container?.classList.add('error');
        if (errorMessage) errorMessage.textContent = customMessage;
        return; // Skip further validation if empty
      }

      // Format validation
      let formatError = '';

      if (inputName === 'email' || inputName === 'paypal-email') {
        if (!PYD.validateEmail(value)) {
          formatError = 'Enter a valid email address';
        }
      }

      if (inputName === 'zip-code') {
        if (!PYD.validateZip(value)) {
          formatError = 'Enter a 5-digit or 9-digit ZIP code';
        }
      }

      if (inputName === 'phone') {
        if (!PYD.validatePhone(value)) {
          formatError = 'Enter a 10-digit phone number';
        }
      }

      if (formatError) {
        isValid = false;
        if (!firstInvalidInput) firstInvalidInput = shadowInput;

        shadowInput.setCustomValidity(' ');
        container?.classList.add('error');
        if (errorMessage) errorMessage.textContent = formatError;
      } else {
        container?.classList.remove('error');
        if (errorMessage) errorMessage.textContent = '';
      }

      // Collect values
      switch (inputName) {
        case 'email':
          if (!customerEmail) customerEmail = value;
          break;
        case 'first-name':
          if (!customerFirstName) customerFirstName = value;
          break;
        case 'last-name':
          if (!customerLastName) customerLastName = value;
          break;
        case 'address':
          if (!customerAddress) customerAddress = value;
          break;
        case 'address-1':
          if (!customerCity) customerAddress += ' ' + value;
          break;
        case 'city':
          if (!customerCity) customerCity = value;
          break;
        case 'state':
          if (!customerState) customerState = value;
          break;
        case 'zip-code':
          if (!customerZip) customerZip = value;
          break;
        case 'phone':
          if (!customerPhone) customerPhone = value;
          break;
      }
    });

    PYD.state.emailAddress = customerEmail;
    const subscribeInput =
        document.querySelector('checkbox-input[data-name="subscribe"]')
          ?.shadowRoot
          ?.querySelector('input[type="checkbox"]');

      PYD.setSessionStorage("pyd", {
        emailSubscribed: subscribeInput ? subscribeInput.checked : false
      });

    // Get MailIn Title and Value
    const mailInMethodElement = form.querySelector('radio-group[data-name="shipping-option"]')?.shadowRoot.querySelector('.radio-option.checked');
    if (mailInMethodElement) {
      if (mailInMethodElement.querySelector('.title')) {
        customerMailinMethodTitle = mailInMethodElement.querySelector('.title').textContent.trim();
      }
      if (mailInMethodElement.querySelector('.caption')) {
        customerMailinMethodCaption = mailInMethodElement.querySelector('.caption').textContent.trim();
      }

      document.querySelectorAll('.gpyd-m-checkout__sale-confirmed').forEach(el => {
        el.classList.remove('active');
      });
      if (customerMailinMethodTitle === 'Get a box sent to you') {
        document.querySelector('.gpyd-m-checkout__sale-confirmed[data-type="box"]').classList.add('active');
      }
      if (customerMailinMethodTitle === 'Print a Shipping Label') {
        document.querySelector('.gpyd-m-checkout__sale-confirmed[data-type="shipping"]').classList.add('active');
      }
    }
    PYD.setSessionStorage("pyd", {"mailInMethod": customerMailinMethodTitle});

    // Check Payment Option, and Get Paypal Email or Check Address
    if (paymentOptionElement) {
      if (customerPaymentName == 'Paypal') {
        if (paymentOptionElement.querySelector('text-input')) {
          const paymentInput = paymentOptionElement.querySelector('text-input').shadowRoot.querySelector('input');
          if (paymentInput) {
            customerPaymentAddress = paymentInput.value;
          }
        }
      }
      const checkAddressCard = document.querySelector('.gpyd-m-checkout__confirm-address--check');
      if (customerPaymentName == 'Check') {
        if (checkAddressCard) {
          checkAddressCard.classList.remove('inactive');
        }
        checkCustomerAddress.customerFullName = customerFirstName + " " + customerLastName;
        checkCustomerAddress.customerAddress = customerAddress;
        checkCustomerAddress.customerCity = customerCity;
        checkCustomerAddress.customerState = customerState;
        checkCustomerAddress.customerZip = customerZip;
        checkCustomerAddress.customerPhone = customerPhone;

        const paymentOptions = document.querySelector('.checkout-payment-options');
        if (paymentOptions?.shadowRoot) {
          const checkCheckboxContainer = paymentOptions.shadowRoot.querySelector('.gpyd-m-checkout__check-address checkbox-input');
          if (checkCheckboxContainer?.shadowRoot) {
            const checkbox = checkCheckboxContainer.shadowRoot.querySelector('input[type="checkbox"]');
            if (checkbox) {
              if (checkbox.checked) {
                if (checkAddressCard) {
                  checkAddressCard.classList.add('inactive');
                }
              } else {
                const checkAddressContainer = paymentOptions.shadowRoot.querySelector('.gpyd-m-checkout__check-address');
                if (checkAddressContainer) {
                  const getInputValue = (selector) => {
                    const el = checkAddressContainer.querySelector(selector)?.shadowRoot?.querySelector(selector);
                    return el?.value?.trim() || '';
                  };

                  checkCustomerAddress.customerFullName = getInputValue('#payable-to');
                  checkCustomerAddress.customerAddress = [getInputValue('#address'), getInputValue('#address-1')].filter(Boolean).join(' ');
                  checkCustomerAddress.customerCity = getInputValue('#city');
                  checkCustomerAddress.customerZip = getInputValue('#zip-code');
                  checkCustomerAddress.customerState = getInputValue('#state');
                  checkCustomerAddress.customerPhone = getInputValue('#phone');
                }
              }
            }
          }
        }
      } else {
        if (checkAddressCard) {
          checkAddressCard.classList.add('inactive');
        }
      }
    }

    let customerData = {
      customerEmail,
      customerMailinMethodTitle,
      customerMailinMethodCaption,
      customerFirstName,
      customerLastName,
      customerAddress,
      customerCity,
      customerState,
      customerZip,
      customerPhone,
      customerPaymentName,
      customerPaymentAddress,
      checkCustomerAddress
    };

    CUSTOMER_ADDRESS = customerData;

    if (!isValid && firstInvalidInput) {
      firstInvalidInput.reportValidity(); // Show only first error
      firstInvalidInput.focus();
      const rect = firstInvalidInput.getBoundingClientRect();
      const absoluteTop = rect.top + window.scrollY;
      window.scrollTo({
        top: absoluteTop - 100,
        behavior: "smooth"
      });
      return;
    }

    // If All above Validation work, then Move to Address Validation step
    document.querySelector('.gpyd-m-checkout__confirm-sale')?.setAttribute('disabled', 'true');
    PYD.validateAddressesAndSubmit(customerData);
    // empty cart icon quantity
    window.dispatchEvent(
      new CustomEvent('tradeIn:cartLoaded', {
        detail: { cart: { items: [] } }
      })
    );
    // empty cart icon quantity for Gazelle header
    localStorage.setItem('tradein_cart', JSON.stringify([]));
  });

// When confirm Address button clicked, got to Thank you page
document.querySelector('.gpyd-m-checkout__confirm-address--submit')?.addEventListener('click', function () {
  PYD.moveToThankYou();
});

// When Edit address button clicked, go back to Prev Step
const editAddressButtons = document.querySelectorAll('.gpyd-m-checkout__confirm-address--edit');
editAddressButtons.forEach(button => {
  button.addEventListener('click', () => {
    const address = document.querySelector('.gpyd-m-checkout__confirm-address');
    const leftInner = document.querySelector('.gpyd-m-checkout__left-inner');
    if (address) address.classList.remove('active');
    if (leftInner) leftInner.classList.remove('inactive');
  });
});

// When Checkout page loaded first time, get saved Packing Slip
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    const params = new URLSearchParams(window.location.search);
    const tiScreen = params.get('ti-screen');
    if (tiScreen === 'checkout') {
      PYD.initCheckoutPage();
    }
  });
} else {
  const params = new URLSearchParams(window.location.search);
  const tiScreen = params.get('ti-screen');
  if (tiScreen === 'checkout') {
    PYD.initCheckoutPage();
  }
}
// ====== Checkout Page Related Script End =======
